export const iso6393languages = [
  { n: 'Ghotuo', i: 'aaa' },
  { n: 'Alumu-Tesu', i: 'aab' },
  { n: 'Ari', i: 'aac' },
  { n: 'Amal', i: 'aad' },
  { n: 'Arbëreshë Albanian', i: 'aae' },
  { n: 'Aranadan', i: 'aaf' },
  { n: 'Ambrak', i: 'aag' },
  { n: "Abu' Arapesh", i: 'aah' },
  { n: 'Arifama-Miniafia', i: 'aai' },
  { n: 'Ankave', i: 'aak' },
  { n: 'Afade', i: 'aal' },
  { n: 'Anambé', i: 'aan' },
  { n: 'Algerian Saharan Arabic', i: 'aao' },
  { n: 'Pará Arára', i: 'aap' },
  { n: 'Afar', i: 'aar' },
  { n: 'Aasáx', i: 'aas' },
  { n: 'Arvanitika Albanian', i: 'aat' },
  { n: 'Abau', i: 'aau' },
  { n: 'Solong', i: 'aaw' },
  { n: 'Mandobo Atas', i: 'aax' },
  { n: 'Amarasi', i: 'aaz' },
  { n: 'Abé', i: 'aba' },
  { n: 'Bankon', i: 'abb' },
  { n: 'Ambala Ayta', i: 'abc' },
  { n: 'Manide', i: 'abd' },
  { n: 'Western Abnaki', i: 'abe' },
  { n: 'Abai Sungai', i: 'abf' },
  { n: 'Abaga', i: 'abg' },
  { n: 'Tajiki Arabic', i: 'abh' },
  { n: 'Abidji', i: 'abi' },
  { n: 'Abkhazian', i: 'abk' },
  { n: 'Lampung Nyo', i: 'abl' },
  { n: 'Abanyom', i: 'abm' },
  { n: 'Abua', i: 'abn' },
  { n: 'Abon', i: 'abo' },
  { n: 'Abellen Ayta', i: 'abp' },
  { n: 'Abaza', i: 'abq' },
  { n: 'Abron', i: 'abr' },
  { n: 'Ambonese Malay', i: 'abs' },
  { n: 'Ambulas', i: 'abt' },
  { n: 'Abure', i: 'abu' },
  { n: 'Baharna Arabic', i: 'abv' },
  { n: 'Pal', i: 'abw' },
  { n: 'Inabaknon', i: 'abx' },
  { n: 'Aneme Wake', i: 'aby' },
  { n: 'Abui', i: 'abz' },
  { n: 'Achagua', i: 'aca' },
  { n: 'Áncá', i: 'acb' },
  { n: 'Gikyode', i: 'acd' },
  { n: 'Achinese', i: 'ace' },
  { n: 'Saint Lucian Creole French', i: 'acf' },
  { n: 'Acoli', i: 'ach' },
  { n: 'Mesopotamian Arabic', i: 'acm' },
  { n: 'Achang', i: 'acn' },
  { n: 'Eastern Acipa', i: 'acp' },
  { n: "Ta'izzi-Adeni Arabic", i: 'acq' },
  { n: 'Achi', i: 'acr' },
  { n: 'Achterhoeks', i: 'act' },
  { n: 'Achuar-Shiwiar', i: 'acu' },
  { n: 'Achumawi', i: 'acv' },
  { n: 'Hijazi Arabic', i: 'acw' },
  { n: 'Omani Arabic', i: 'acx' },
  { n: 'Cypriot Arabic', i: 'acy' },
  { n: 'Acheron', i: 'acz' },
  { n: 'Adangme', i: 'ada' },
  { n: 'Atauran', i: 'adb' },
  { n: 'Lidzonka', i: 'add' },
  { n: 'Adele', i: 'ade' },
  { n: 'Dhofari Arabic', i: 'adf' },
  { n: 'Andegerebinha', i: 'adg' },
  { n: 'Adhola', i: 'adh' },
  { n: 'Adi', i: 'adi' },
  { n: 'Adioukrou', i: 'adj' },
  { n: 'Galo', i: 'adl' },
  { n: 'Adang', i: 'adn' },
  { n: 'Abu', i: 'ado' },
  { n: 'Adangbe', i: 'adq' },
  { n: 'Adonara', i: 'adr' },
  { n: 'Adamorobe Sign Language', i: 'ads' },
  { n: 'Adnyamathanha', i: 'adt' },
  { n: 'Aduge', i: 'adu' },
  { n: 'Amundava', i: 'adw' },
  { n: 'Amdo Tibetan', i: 'adx' },
  { n: 'Adyghe', i: 'ady' },
  { n: 'Adzera', i: 'adz' },
  { n: 'Tunisian Arabic', i: 'aeb' },
  { n: 'Saidi Arabic', i: 'aec' },
  { n: 'Argentine Sign Language', i: 'aed' },
  { n: 'Northeast Pashai', i: 'aee' },
  { n: 'Haeke', i: 'aek' },
  { n: 'Ambele', i: 'ael' },
  { n: 'Arem', i: 'aem' },
  { n: 'Armenian Sign Language', i: 'aen' },
  { n: 'Aer', i: 'aeq' },
  { n: 'Eastern Arrernte', i: 'aer' },
  { n: 'Akeu', i: 'aeu' },
  { n: 'Ambakich', i: 'aew' },
  { n: 'Amele', i: 'aey' },
  { n: 'Aeka', i: 'aez' },
  { n: 'Gulf Arabic', i: 'afb' },
  { n: 'Andai', i: 'afd' },
  { n: 'Putukwam', i: 'afe' },
  { n: 'Afghan Sign Language', i: 'afg' },
  { n: 'Akrukay', i: 'afi' },
  { n: 'Nanubae', i: 'afk' },
  { n: 'Defaka', i: 'afn' },
  { n: 'Eloyi', i: 'afo' },
  { n: 'Tapei', i: 'afp' },
  { n: 'Afrikaans', i: 'afr' },
  { n: 'Afro-Seminole Creole', i: 'afs' },
  { n: 'Afitti', i: 'aft' },
  { n: 'Awutu', i: 'afu' },
  { n: 'Obokuitai', i: 'afz' },
  { n: 'Legbo', i: 'agb' },
  { n: 'Agatu', i: 'agc' },
  { n: 'Agarabi', i: 'agd' },
  { n: 'Angal', i: 'age' },
  { n: 'Arguni', i: 'agf' },
  { n: 'Angor', i: 'agg' },
  { n: 'Ngelima', i: 'agh' },
  { n: 'Agariya', i: 'agi' },
  { n: 'Argobba', i: 'agj' },
  { n: 'Isarog Agta', i: 'agk' },
  { n: 'Fembe', i: 'agl' },
  { n: 'Angaataha', i: 'agm' },
  { n: 'Agutaynen', i: 'agn' },
  { n: 'Tainae', i: 'ago' },
  { n: 'Aghem', i: 'agq' },
  { n: 'Aguaruna', i: 'agr' },
  { n: 'Esimbi', i: 'ags' },
  { n: 'Central Cagayan Agta', i: 'agt' },
  { n: 'Aguacateco', i: 'agu' },
  { n: 'Remontado Dumagat', i: 'agv' },
  { n: 'Kahua', i: 'agw' },
  { n: 'Aghul', i: 'agx' },
  { n: 'Southern Alta', i: 'agy' },
  { n: 'Mt. Iriga Agta', i: 'agz' },
  { n: 'Ahanta', i: 'aha' },
  { n: 'Axamb', i: 'ahb' },
  { n: 'Qimant', i: 'ahg' },
  { n: 'Aghu', i: 'ahh' },
  { n: 'Tiagbamrin Aizi', i: 'ahi' },
  { n: 'Akha', i: 'ahk' },
  { n: 'Igo', i: 'ahl' },
  { n: 'Mobumrin Aizi', i: 'ahm' },
  { n: 'Àhàn', i: 'ahn' },
  { n: 'Aproumu Aizi', i: 'ahp' },
  { n: 'Ahirani', i: 'ahr' },
  { n: 'Ashe', i: 'ahs' },
  { n: 'Ahtena', i: 'aht' },
  { n: 'Arosi', i: 'aia' },
  { n: 'Ainu (China)', i: 'aib' },
  { n: 'Ainbai', i: 'aic' },
  { n: 'Amara', i: 'aie' },
  { n: 'Agi', i: 'aif' },
  { n: 'Antigua and Barbuda Creole English', i: 'aig' },
  { n: 'Ai-Cham', i: 'aih' },
  { n: 'Assyrian Neo-Aramaic', i: 'aii' },
  { n: 'Lishanid Noshan', i: 'aij' },
  { n: 'Ake', i: 'aik' },
  { n: 'Aimele', i: 'ail' },
  { n: 'Aimol', i: 'aim' },
  { n: 'Ainu (Japan)', i: 'ain' },
  { n: 'Aiton', i: 'aio' },
  { n: 'Burumakok', i: 'aip' },
  { n: 'Aimaq', i: 'aiq' },
  { n: 'Airoran', i: 'air' },
  { n: 'Aari', i: 'aiw' },
  { n: 'Aighon', i: 'aix' },
  { n: 'Ali', i: 'aiy' },
  { n: 'Aja (South Sudan)', i: 'aja' },
  { n: 'Aja (Benin)', i: 'ajg' },
  { n: 'Ajië', i: 'aji' },
  { n: 'Andajin', i: 'ajn' },
  { n: 'South Levantine Arabic', i: 'ajp' },
  { n: 'Judeo-Tunisian Arabic', i: 'ajt' },
  { n: 'Judeo-Moroccan Arabic', i: 'aju' },
  { n: 'Amri Karbi', i: 'ajz' },
  { n: 'Batak Angkola', i: 'akb' },
  { n: 'Mpur', i: 'akc' },
  { n: 'Ukpet-Ehom', i: 'akd' },
  { n: 'Akawaio', i: 'ake' },
  { n: 'Akpa', i: 'akf' },
  { n: 'Anakalangu', i: 'akg' },
  { n: 'Angal Heneng', i: 'akh' },
  { n: 'Aiome', i: 'aki' },
  { n: 'Aklanon', i: 'akl' },
  { n: 'Akurio', i: 'ako' },
  { n: 'Siwu', i: 'akp' },
  { n: 'Ak', i: 'akq' },
  { n: 'Araki', i: 'akr' },
  { n: 'Akaselem', i: 'aks' },
  { n: 'Akolet', i: 'akt' },
  { n: 'Akum', i: 'aku' },
  { n: 'Akhvakh', i: 'akv' },
  { n: 'Akwa', i: 'akw' },
  { n: 'Alabama', i: 'akz' },
  { n: 'Alago', i: 'ala' },
  { n: 'Qawasqar', i: 'alc' },
  { n: 'Alladian', i: 'ald' },
  { n: 'Aleut', i: 'ale' },
  { n: 'Alege', i: 'alf' },
  { n: 'Alawa', i: 'alh' },
  { n: 'Amaimon', i: 'ali' },
  { n: 'Alangan', i: 'alj' },
  { n: 'Alak', i: 'alk' },
  { n: 'Allar', i: 'all' },
  { n: 'Amblong', i: 'alm' },
  { n: 'Gheg Albanian', i: 'aln' },
  { n: 'Larike-Wakasihu', i: 'alo' },
  { n: 'Alune', i: 'alp' },
  { n: 'Algonquin', i: 'alq' },
  { n: 'Alutor', i: 'alr' },
  { n: 'Tosk Albanian', i: 'als' },
  { n: 'Southern Altai', i: 'alt' },
  { n: "'Are'are", i: 'alu' },
  { n: 'Alaba-K’abeena', i: 'alw' },
  { n: 'Amol', i: 'alx' },
  { n: 'Alyawarr', i: 'aly' },
  { n: 'Alur', i: 'alz' },
  { n: 'Ambo', i: 'amb' },
  { n: 'Amahuaca', i: 'amc' },
  { n: "Yanesha'", i: 'ame' },
  { n: 'Hamer-Banna', i: 'amf' },
  { n: 'Amurdak', i: 'amg' },
  { n: 'Amharic', i: 'amh' },
  { n: 'Amis', i: 'ami' },
  { n: 'Amdang', i: 'amj' },
  { n: 'Ambai', i: 'amk' },
  { n: 'War-Jaintia', i: 'aml' },
  { n: 'Ama (Papua New Guinea)', i: 'amm' },
  { n: 'Amanab', i: 'amn' },
  { n: 'Amo', i: 'amo' },
  { n: 'Alamblak', i: 'amp' },
  { n: 'Amahai', i: 'amq' },
  { n: 'Amarakaeri', i: 'amr' },
  { n: 'Southern Amami-Oshima', i: 'ams' },
  { n: 'Amto', i: 'amt' },
  { n: 'Guerrero Amuzgo', i: 'amu' },
  { n: 'Ambelau', i: 'amv' },
  { n: 'Western Neo-Aramaic', i: 'amw' },
  { n: 'Anmatyerre', i: 'amx' },
  { n: 'Ami', i: 'amy' },
  { n: 'Ngas', i: 'anc' },
  { n: 'Ansus', i: 'and' },
  { n: 'Xârâcùù', i: 'ane' },
  { n: 'Animere', i: 'anf' },
  { n: 'Nend', i: 'anh' },
  { n: 'Andi', i: 'ani' },
  { n: 'Anor', i: 'anj' },
  { n: 'Goemai', i: 'ank' },
  { n: 'Anu-Hkongso Chin', i: 'anl' },
  { n: 'Anal', i: 'anm' },
  { n: 'Obolo', i: 'ann' },
  { n: 'Andoque', i: 'ano' },
  { n: 'Angika', i: 'anp' },
  { n: 'Jarawa (India)', i: 'anq' },
  { n: 'Andh', i: 'anr' },
  { n: 'Antakarinya', i: 'ant' },
  { n: 'Anuak', i: 'anu' },
  { n: 'Denya', i: 'anv' },
  { n: 'Anaang', i: 'anw' },
  { n: 'Andra-Hus', i: 'anx' },
  { n: 'Anyin', i: 'any' },
  { n: 'Anem', i: 'anz' },
  { n: 'Angolar', i: 'aoa' },
  { n: 'Abom', i: 'aob' },
  { n: 'Pemon', i: 'aoc' },
  { n: 'Andarum', i: 'aod' },
  { n: 'Angal Enen', i: 'aoe' },
  { n: 'Bragat', i: 'aof' },
  { n: 'Angoram', i: 'aog' },
  { n: 'Anindilyakwa', i: 'aoi' },
  { n: 'Mufian', i: 'aoj' },
  { n: 'Arhö', i: 'aok' },
  { n: 'Alor', i: 'aol' },
  { n: 'Ömie', i: 'aom' },
  { n: 'Bumbita Arapesh', i: 'aon' },
  { n: 'Taikat', i: 'aos' },
  { n: 'Atong (India)', i: 'aot' },
  { n: "A'ou", i: 'aou' },
  { n: 'Atorada', i: 'aox' },
  { n: 'Uab Meto', i: 'aoz' },
  { n: "Sa'a", i: 'apb' },
  { n: 'North Levantine Arabic', i: 'apc' },
  { n: 'Sudanese Arabic', i: 'apd' },
  { n: 'Bukiyip', i: 'ape' },
  { n: 'Pahanan Agta', i: 'apf' },
  { n: 'Ampanang', i: 'apg' },
  { n: 'Athpariya', i: 'aph' },
  { n: 'Apiaká', i: 'api' },
  { n: 'Jicarilla Apache', i: 'apj' },
  { n: 'Kiowa Apache', i: 'apk' },
  { n: 'Lipan Apache', i: 'apl' },
  { n: 'Mescalero-Chiricahua Apache', i: 'apm' },
  { n: 'Apinayé', i: 'apn' },
  { n: 'Ambul', i: 'apo' },
  { n: 'Apma', i: 'app' },
  { n: 'A-Pucikwar', i: 'apq' },
  { n: 'Arop-Lokep', i: 'apr' },
  { n: 'Arop-Sissano', i: 'aps' },
  { n: 'Apatani', i: 'apt' },
  { n: 'Apurinã', i: 'apu' },
  { n: 'Western Apache', i: 'apw' },
  { n: 'Aputai', i: 'apx' },
  { n: 'Apalaí', i: 'apy' },
  { n: 'Safeyoka', i: 'apz' },
  { n: 'Archi', i: 'aqc' },
  { n: 'Ampari Dogon', i: 'aqd' },
  { n: 'Arigidi', i: 'aqg' },
  { n: 'Atohwaim', i: 'aqm' },
  { n: 'Northern Alta', i: 'aqn' },
  { n: 'Arhâ', i: 'aqr' },
  { n: 'Angaité', i: 'aqt' },
  { n: 'Akuntsu', i: 'aqz' },
  { n: 'Standard Arabic', i: 'arb' },
  { n: 'Western Arrarnta', i: 'are' },
  { n: 'Aragonese', i: 'arg' },
  { n: 'Arhuaco', i: 'arh' },
  { n: 'Arikara', i: 'ari' },
  { n: 'Arikapú', i: 'ark' },
  { n: 'Arabela', i: 'arl' },
  { n: 'Mapudungun', i: 'arn' },
  { n: 'Araona', i: 'aro' },
  { n: 'Arapaho', i: 'arp' },
  { n: 'Algerian Arabic', i: 'arq' },
  { n: 'Karo (Brazil)', i: 'arr' },
  { n: 'Najdi Arabic', i: 'ars' },
  { n: 'Arbore', i: 'arv' },
  { n: 'Arawak', i: 'arw' },
  { n: 'Aruá (Rodonia State)', i: 'arx' },
  { n: 'Moroccan Arabic', i: 'ary' },
  { n: 'Egyptian Arabic', i: 'arz' },
  { n: 'Asu (Tanzania)', i: 'asa' },
  { n: 'Assiniboine', i: 'asb' },
  { n: 'Casuarina Coast Asmat', i: 'asc' },
  { n: 'American Sign Language', i: 'ase' },
  { n: 'Auslan', i: 'asf' },
  { n: 'Cishingini', i: 'asg' },
  { n: 'Buruwai', i: 'asi' },
  { n: 'Sari', i: 'asj' },
  { n: 'Ashkun', i: 'ask' },
  { n: 'Asilulu', i: 'asl' },
  { n: 'Assamese', i: 'asm' },
  { n: 'Xingú Asuriní', i: 'asn' },
  { n: 'Dano', i: 'aso' },
  { n: 'Algerian Sign Language', i: 'asp' },
  { n: 'Austrian Sign Language', i: 'asq' },
  { n: 'Asuri', i: 'asr' },
  { n: 'Ipulo', i: 'ass' },
  { n: 'Asturian', i: 'ast' },
  { n: 'Tocantins Asurini', i: 'asu' },
  { n: 'Asoa', i: 'asv' },
  { n: 'Australian Aborigines Sign Language', i: 'asw' },
  { n: 'Muratayak', i: 'asx' },
  { n: 'Yaosakor Asmat', i: 'asy' },
  { n: 'As', i: 'asz' },
  { n: 'Pele-Ata', i: 'ata' },
  { n: 'Zaiwa', i: 'atb' },
  { n: 'Ata Manobo', i: 'atd' },
  { n: 'Atemble', i: 'ate' },
  { n: 'Ivbie North-Okpela-Arhe', i: 'atg' },
  { n: 'Attié', i: 'ati' },
  { n: 'Atikamekw', i: 'atj' },
  { n: 'Ati', i: 'atk' },
  { n: 'Mt. Iraya Agta', i: 'atl' },
  { n: 'Ata', i: 'atm' },
  { n: 'Ashtiani', i: 'atn' },
  { n: 'Atong (Cameroon)', i: 'ato' },
  { n: 'Pudtol Atta', i: 'atp' },
  { n: 'Aralle-Tabulahan', i: 'atq' },
  { n: 'Waimiri-Atroari', i: 'atr' },
  { n: 'Gros Ventre', i: 'ats' },
  { n: 'Pamplona Atta', i: 'att' },
  { n: 'Reel', i: 'atu' },
  { n: 'Northern Altai', i: 'atv' },
  { n: 'Atsugewi', i: 'atw' },
  { n: 'Arutani', i: 'atx' },
  { n: 'Aneityum', i: 'aty' },
  { n: 'Arta', i: 'atz' },
  { n: 'Asumboa', i: 'aua' },
  { n: 'Alugu', i: 'aub' },
  { n: 'Waorani', i: 'auc' },
  { n: 'Anuta', i: 'aud' },
  { n: 'Aguna', i: 'aug' },
  { n: 'Aushi', i: 'auh' },
  { n: 'Anuki', i: 'aui' },
  { n: 'Awjilah', i: 'auj' },
  { n: 'Heyo', i: 'auk' },
  { n: 'Aulua', i: 'aul' },
  { n: 'Asu (Nigeria)', i: 'aum' },
  { n: 'Molmo One', i: 'aun' },
  { n: 'Makayam', i: 'aup' },
  { n: 'Anus', i: 'auq' },
  { n: 'Aruek', i: 'aur' },
  { n: 'Austral', i: 'aut' },
  { n: 'Auye', i: 'auu' },
  { n: 'Awyi', i: 'auw' },
  { n: 'Awiyaana', i: 'auy' },
  { n: 'Uzbeki Arabic', i: 'auz' },
  { n: 'Avaric', i: 'ava' },
  { n: 'Avau', i: 'avb' },
  { n: 'Alviri-Vidari', i: 'avd' },
  { n: 'Avikam', i: 'avi' },
  { n: 'Eastern Egyptian Bedawi Arabic', i: 'avl' },
  { n: 'Avatime', i: 'avn' },
  { n: 'Au', i: 'avt' },
  { n: 'Avokaya', i: 'avu' },
  { n: 'Avá-Canoeiro', i: 'avv' },
  { n: 'Awadhi', i: 'awa' },
  { n: 'Awa (Papua New Guinea)', i: 'awb' },
  { n: 'Cicipu', i: 'awc' },
  { n: 'Awetí', i: 'awe' },
  { n: 'Awbono', i: 'awh' },
  { n: 'Aekyom', i: 'awi' },
  { n: 'Arawum', i: 'awm' },
  { n: 'Awngi', i: 'awn' },
  { n: 'Awak', i: 'awo' },
  { n: 'Awera', i: 'awr' },
  { n: 'South Awyu', i: 'aws' },
  { n: 'Araweté', i: 'awt' },
  { n: 'Central Awyu', i: 'awu' },
  { n: 'Jair Awyu', i: 'awv' },
  { n: 'Awun', i: 'aww' },
  { n: 'Awara', i: 'awx' },
  { n: 'Edera Awyu', i: 'awy' },
  { n: 'Yaka (Central African Republic)', i: 'axk' },
  { n: 'Xârâgurè', i: 'axx' },
  { n: 'Awar', i: 'aya' },
  { n: 'Ayizo Gbe', i: 'ayb' },
  { n: 'Southern Aymara', i: 'ayc' },
  { n: 'Ayere', i: 'aye' },
  { n: 'Ginyanga', i: 'ayg' },
  { n: 'Hadrami Arabic', i: 'ayh' },
  { n: 'Leyigha', i: 'ayi' },
  { n: 'Akuku', i: 'ayk' },
  { n: 'Libyan Arabic', i: 'ayl' },
  { n: 'Sanaani Arabic', i: 'ayn' },
  { n: 'Ayoreo', i: 'ayo' },
  { n: 'North Mesopotamian Arabic', i: 'ayp' },
  { n: 'Ayi (Papua New Guinea)', i: 'ayq' },
  { n: 'Central Aymara', i: 'ayr' },
  { n: 'Sorsogon Ayta', i: 'ays' },
  { n: 'Magbukun Ayta', i: 'ayt' },
  { n: 'Ayu', i: 'ayu' },
  { n: 'Mai Brat', i: 'ayz' },
  { n: 'Azha', i: 'aza' },
  { n: 'South Azerbaijani', i: 'azb' },
  { n: 'Eastern Durango Nahuatl', i: 'azd' },
  { n: 'San Pedro Amuzgos Amuzgo', i: 'azg' },
  { n: 'North Azerbaijani', i: 'azj' },
  { n: 'Ipalapa Amuzgo', i: 'azm' },
  { n: 'Western Durango Nahuatl', i: 'azn' },
  { n: 'Awing', i: 'azo' },
  { n: 'Faire Atta', i: 'azt' },
  { n: 'Highland Puebla Nahuatl', i: 'azz' },
  { n: 'Babatana', i: 'baa' },
  { n: 'Bainouk-Gunyuño', i: 'bab' },
  { n: 'Badui', i: 'bac' },
  { n: 'Nubaca', i: 'baf' },
  { n: 'Tuki', i: 'bag' },
  { n: 'Bahamas Creole English', i: 'bah' },
  { n: 'Barakai', i: 'baj' },
  { n: 'Bashkir', i: 'bak' },
  { n: 'Bambara', i: 'bam' },
  { n: 'Balinese', i: 'ban' },
  { n: 'Waimaha', i: 'bao' },
  { n: 'Bantawa', i: 'bap' },
  { n: 'Bavarian', i: 'bar' },
  { n: 'Basa (Cameroon)', i: 'bas' },
  { n: 'Bada (Nigeria)', i: 'bau' },
  { n: 'Vengo', i: 'bav' },
  { n: 'Bambili-Bambui', i: 'baw' },
  { n: 'Bamun', i: 'bax' },
  { n: 'Batuley', i: 'bay' },
  { n: 'Baatonum', i: 'bba' },
  { n: 'Barai', i: 'bbb' },
  { n: 'Batak Toba', i: 'bbc' },
  { n: 'Bau', i: 'bbd' },
  { n: 'Bangba', i: 'bbe' },
  { n: 'Baibai', i: 'bbf' },
  { n: 'Barama', i: 'bbg' },
  { n: 'Bugan', i: 'bbh' },
  { n: 'Barombi', i: 'bbi' },
  { n: "Ghomálá'", i: 'bbj' },
  { n: 'Babanki', i: 'bbk' },
  { n: 'Bats', i: 'bbl' },
  { n: 'Babango', i: 'bbm' },
  { n: 'Uneapa', i: 'bbn' },
  { n: 'Northern Bobo Madaré', i: 'bbo' },
  { n: 'West Central Banda', i: 'bbp' },
  { n: 'Bamali', i: 'bbq' },
  { n: 'Girawa', i: 'bbr' },
  { n: 'Bakpinka', i: 'bbs' },
  { n: 'Mburku', i: 'bbt' },
  { n: 'Kulung (Nigeria)', i: 'bbu' },
  { n: 'Karnai', i: 'bbv' },
  { n: 'Baba', i: 'bbw' },
  { n: 'Bubia', i: 'bbx' },
  { n: 'Befang', i: 'bby' },
  { n: 'Central Bai', i: 'bca' },
  { n: 'Bainouk-Samik', i: 'bcb' },
  { n: 'Southern Balochi', i: 'bcc' },
  { n: 'North Babar', i: 'bcd' },
  { n: 'Bamenyam', i: 'bce' },
  { n: 'Bamu', i: 'bcf' },
  { n: 'Baga Pokur', i: 'bcg' },
  { n: 'Bariai', i: 'bch' },
  { n: 'Baoulé', i: 'bci' },
  { n: 'Bardi', i: 'bcj' },
  { n: 'Bunuba', i: 'bck' },
  { n: 'Central Bikol', i: 'bcl' },
  { n: 'Bannoni', i: 'bcm' },
  { n: 'Bali (Nigeria)', i: 'bcn' },
  { n: 'Kaluli', i: 'bco' },
  { n: 'Bali (Democratic Republic of Congo)', i: 'bcp' },
  { n: 'Bench', i: 'bcq' },
  { n: 'Babine', i: 'bcr' },
  { n: 'Kohumono', i: 'bcs' },
  { n: 'Bendi', i: 'bct' },
  { n: 'Awad Bing', i: 'bcu' },
  { n: 'Shoo-Minda-Nye', i: 'bcv' },
  { n: 'Bana', i: 'bcw' },
  { n: 'Bacama', i: 'bcy' },
  { n: 'Bainouk-Gunyaamolo', i: 'bcz' },
  { n: 'Bayot', i: 'bda' },
  { n: 'Basap', i: 'bdb' },
  { n: 'Emberá-Baudó', i: 'bdc' },
  { n: 'Bunama', i: 'bdd' },
  { n: 'Bade', i: 'bde' },
  { n: 'Biage', i: 'bdf' },
  { n: 'Bonggi', i: 'bdg' },
  { n: 'Baka (South Sudan)', i: 'bdh' },
  { n: 'Burun', i: 'bdi' },
  { n: 'Bai (South Sudan)', i: 'bdj' },
  { n: 'Budukh', i: 'bdk' },
  { n: 'Indonesian Bajau', i: 'bdl' },
  { n: 'Buduma', i: 'bdm' },
  { n: 'Baldemu', i: 'bdn' },
  { n: 'Morom', i: 'bdo' },
  { n: 'Bende', i: 'bdp' },
  { n: 'Bahnar', i: 'bdq' },
  { n: 'West Coast Bajau', i: 'bdr' },
  { n: 'Burunge', i: 'bds' },
  { n: 'Bokoto', i: 'bdt' },
  { n: 'Oroko', i: 'bdu' },
  { n: 'Bodo Parja', i: 'bdv' },
  { n: 'Baham', i: 'bdw' },
  { n: 'Budong-Budong', i: 'bdx' },
  { n: 'Bandjalang', i: 'bdy' },
  { n: 'Badeshi', i: 'bdz' },
  { n: 'Beaver', i: 'bea' },
  { n: 'Bebele', i: 'beb' },
  { n: 'Iceve-Maci', i: 'bec' },
  { n: 'Bedoanas', i: 'bed' },
  { n: 'Byangsi', i: 'bee' },
  { n: 'Benabena', i: 'bef' },
  { n: 'Belait', i: 'beg' },
  { n: 'Biali', i: 'beh' },
  { n: "Bekati'", i: 'bei' },
  { n: 'Beja', i: 'bej' },
  { n: 'Bebeli', i: 'bek' },
  { n: 'Belarusian', i: 'bel' },
  { n: 'Bemba (Zambia)', i: 'bem' },
  { n: 'Bengali', i: 'ben' },
  { n: 'Beami', i: 'beo' },
  { n: 'Besoa', i: 'bep' },
  { n: 'Beembe', i: 'beq' },
  { n: 'Besme', i: 'bes' },
  { n: 'Guiberoua Béte', i: 'bet' },
  { n: 'Blagar', i: 'beu' },
  { n: 'Daloa Bété', i: 'bev' },
  { n: 'Betawi', i: 'bew' },
  { n: 'Jur Modo', i: 'bex' },
  { n: 'Beli (Papua New Guinea)', i: 'bey' },
  { n: 'Bena (Tanzania)', i: 'bez' },
  { n: 'Bari', i: 'bfa' },
  { n: 'Pauri Bareli', i: 'bfb' },
  { n: 'Panyi Bai', i: 'bfc' },
  { n: 'Bafut', i: 'bfd' },
  { n: 'Betaf', i: 'bfe' },
  { n: 'Bofi', i: 'bff' },
  { n: 'Busang Kayan', i: 'bfg' },
  { n: 'Blafe', i: 'bfh' },
  { n: 'British Sign Language', i: 'bfi' },
  { n: 'Bafanji', i: 'bfj' },
  { n: 'Ban Khor Sign Language', i: 'bfk' },
  { n: 'Banda-Ndélé', i: 'bfl' },
  { n: 'Mmen', i: 'bfm' },
  { n: 'Bunak', i: 'bfn' },
  { n: 'Malba Birifor', i: 'bfo' },
  { n: 'Beba', i: 'bfp' },
  { n: 'Badaga', i: 'bfq' },
  { n: 'Bazigar', i: 'bfr' },
  { n: 'Southern Bai', i: 'bfs' },
  { n: 'Balti', i: 'bft' },
  { n: 'Gahri', i: 'bfu' },
  { n: 'Bondo', i: 'bfw' },
  { n: 'Bantayanon', i: 'bfx' },
  { n: 'Bagheli', i: 'bfy' },
  { n: 'Mahasu Pahari', i: 'bfz' },
  { n: 'Gwamhi-Wuri', i: 'bga' },
  { n: 'Bobongko', i: 'bgb' },
  { n: 'Haryanvi', i: 'bgc' },
  { n: 'Rathwi Bareli', i: 'bgd' },
  { n: 'Bauria', i: 'bge' },
  { n: 'Bangandu', i: 'bgf' },
  { n: 'Bugun', i: 'bgg' },
  { n: 'Giangan', i: 'bgi' },
  { n: 'Bangolan', i: 'bgj' },
  { n: 'Bit', i: 'bgk' },
  { n: 'Bo (Laos)', i: 'bgl' },
  { n: 'Western Balochi', i: 'bgn' },
  { n: 'Baga Koga', i: 'bgo' },
  { n: 'Eastern Balochi', i: 'bgp' },
  { n: 'Bagri', i: 'bgq' },
  { n: 'Bawm Chin', i: 'bgr' },
  { n: 'Tagabawa', i: 'bgs' },
  { n: 'Bughotu', i: 'bgt' },
  { n: 'Mbongno', i: 'bgu' },
  { n: 'Warkay-Bipim', i: 'bgv' },
  { n: 'Bhatri', i: 'bgw' },
  { n: 'Balkan Gagauz Turkish', i: 'bgx' },
  { n: 'Benggoi', i: 'bgy' },
  { n: 'Banggai', i: 'bgz' },
  { n: 'Bharia', i: 'bha' },
  { n: 'Bhili', i: 'bhb' },
  { n: 'Biga', i: 'bhc' },
  { n: 'Bhadrawahi', i: 'bhd' },
  { n: 'Bhaya', i: 'bhe' },
  { n: 'Odiai', i: 'bhf' },
  { n: 'Binandere', i: 'bhg' },
  { n: 'Bukharic', i: 'bhh' },
  { n: 'Bhilali', i: 'bhi' },
  { n: 'Bahing', i: 'bhj' },
  { n: 'Bimin', i: 'bhl' },
  { n: 'Bathari', i: 'bhm' },
  { n: 'Bohtan Neo-Aramaic', i: 'bhn' },
  { n: 'Bhojpuri', i: 'bho' },
  { n: 'Bima', i: 'bhp' },
  { n: 'Tukang Besi South', i: 'bhq' },
  { n: 'Bara Malagasy', i: 'bhr' },
  { n: 'Buwal', i: 'bhs' },
  { n: 'Bhattiyali', i: 'bht' },
  { n: 'Bhunjia', i: 'bhu' },
  { n: 'Bahau', i: 'bhv' },
  { n: 'Biak', i: 'bhw' },
  { n: 'Bhalay', i: 'bhx' },
  { n: 'Bhele', i: 'bhy' },
  { n: 'Bada (Indonesia)', i: 'bhz' },
  { n: 'Badimaya', i: 'bia' },
  { n: 'Bissa', i: 'bib' },
  { n: 'Bikaru', i: 'bic' },
  { n: 'Bidiyo', i: 'bid' },
  { n: 'Bepour', i: 'bie' },
  { n: 'Biafada', i: 'bif' },
  { n: 'Biangai', i: 'big' },
  { n: 'Vaghat-Ya-Bijim-Legeri', i: 'bij' },
  { n: 'Bile', i: 'bil' },
  { n: 'Bimoba', i: 'bim' },
  { n: 'Bini', i: 'bin' },
  { n: 'Nai', i: 'bio' },
  { n: 'Bila', i: 'bip' },
  { n: 'Bipi', i: 'biq' },
  { n: 'Bisorio', i: 'bir' },
  { n: 'Bislama', i: 'bis' },
  { n: 'Berinomo', i: 'bit' },
  { n: 'Biete', i: 'biu' },
  { n: 'Southern Birifor', i: 'biv' },
  { n: 'Kol (Cameroon)', i: 'biw' },
  { n: 'Bijori', i: 'bix' },
  { n: 'Birhor', i: 'biy' },
  { n: 'Baloi', i: 'biz' },
  { n: 'Budza', i: 'bja' },
  { n: 'Bariji', i: 'bjc' },
  { n: 'Biao-Jiao Mien', i: 'bje' },
  { n: 'Barzani Jewish Neo-Aramaic', i: 'bjf' },
  { n: 'Bidyogo', i: 'bjg' },
  { n: 'Bahinemo', i: 'bjh' },
  { n: 'Burji', i: 'bji' },
  { n: 'Kanauji', i: 'bjj' },
  { n: 'Barok', i: 'bjk' },
  { n: 'Bulu (Papua New Guinea)', i: 'bjl' },
  { n: 'Bajelani', i: 'bjm' },
  { n: 'Banjar', i: 'bjn' },
  { n: 'Mid-Southern Banda', i: 'bjo' },
  { n: 'Fanamaket', i: 'bjp' },
  { n: 'Binumarien', i: 'bjr' },
  { n: 'Bajan', i: 'bjs' },
  { n: 'Balanta-Ganja', i: 'bjt' },
  { n: 'Busuu', i: 'bju' },
  { n: 'Bedjond', i: 'bjv' },
  { n: 'Bakwé', i: 'bjw' },
  { n: 'Banao Itneg', i: 'bjx' },
  { n: 'Baruga', i: 'bjz' },
  { n: 'Kyak', i: 'bka' },
  { n: 'Baka (Cameroon)', i: 'bkc' },
  { n: 'Binukid', i: 'bkd' },
  { n: 'Beeke', i: 'bkf' },
  { n: 'Buraka', i: 'bkg' },
  { n: 'Bakoko', i: 'bkh' },
  { n: 'Baki', i: 'bki' },
  { n: 'Pande', i: 'bkj' },
  { n: 'Brokskat', i: 'bkk' },
  { n: 'Berik', i: 'bkl' },
  { n: 'Kom (Cameroon)', i: 'bkm' },
  { n: 'Bukitan', i: 'bkn' },
  { n: "Kwa'", i: 'bko' },
  { n: 'Boko (Democratic Republic of Congo)', i: 'bkp' },
  { n: 'Bakairí', i: 'bkq' },
  { n: 'Bakumpai', i: 'bkr' },
  { n: 'Northern Sorsoganon', i: 'bks' },
  { n: 'Boloki', i: 'bkt' },
  { n: 'Buhid', i: 'bku' },
  { n: 'Bekwarra', i: 'bkv' },
  { n: 'Bekwel', i: 'bkw' },
  { n: 'Baikeno', i: 'bkx' },
  { n: 'Bokyi', i: 'bky' },
  { n: 'Bungku', i: 'bkz' },
  { n: 'Siksika', i: 'bla' },
  { n: 'Bilua', i: 'blb' },
  { n: 'Bella Coola', i: 'blc' },
  { n: 'Bolango', i: 'bld' },
  { n: 'Balanta-Kentohe', i: 'ble' },
  { n: 'Buol', i: 'blf' },
  { n: 'Balau', i: 'blg' },
  { n: 'Kuwaa', i: 'blh' },
  { n: 'Bolia', i: 'bli' },
  { n: 'Bolongan', i: 'blj' },
  { n: "Pa'o Karen", i: 'blk' },
  { n: 'Beli (South Sudan)', i: 'blm' },
  { n: 'Southern Catanduanes Bikol', i: 'bln' },
  { n: 'Anii', i: 'blo' },
  { n: 'Blablanga', i: 'blp' },
  { n: 'Baluan-Pam', i: 'blq' },
  { n: 'Blang', i: 'blr' },
  { n: 'Balaesang', i: 'bls' },
  { n: 'Tai Dam', i: 'blt' },
  { n: 'Kibala', i: 'blv' },
  { n: 'Balangao', i: 'blw' },
  { n: 'Mag-Indi Ayta', i: 'blx' },
  { n: 'Notre', i: 'bly' },
  { n: 'Balantak', i: 'blz' },
  { n: 'Lame', i: 'bma' },
  { n: 'Bembe', i: 'bmb' },
  { n: 'Biem', i: 'bmc' },
  { n: 'Baga Manduri', i: 'bmd' },
  { n: 'Limassa', i: 'bme' },
  { n: 'Bom-Kim', i: 'bmf' },
  { n: 'Bamwe', i: 'bmg' },
  { n: 'Kein', i: 'bmh' },
  { n: 'Bagirmi', i: 'bmi' },
  { n: 'Bote-Majhi', i: 'bmj' },
  { n: 'Ghayavi', i: 'bmk' },
  { n: 'Bomboli', i: 'bml' },
  { n: 'Northern Betsimisaraka Malagasy', i: 'bmm' },
  { n: 'Bambalang', i: 'bmo' },
  { n: 'Bulgebi', i: 'bmp' },
  { n: 'Bomu', i: 'bmq' },
  { n: 'Muinane', i: 'bmr' },
  { n: 'Bilma Kanuri', i: 'bms' },
  { n: 'Biao Mon', i: 'bmt' },
  { n: 'Somba-Siawari', i: 'bmu' },
  { n: 'Bum', i: 'bmv' },
  { n: 'Bomwali', i: 'bmw' },
  { n: 'Baimak', i: 'bmx' },
  { n: 'Baramu', i: 'bmz' },
  { n: 'Bonerate', i: 'bna' },
  { n: 'Bookan', i: 'bnb' },
  { n: 'Banda (Indonesia)', i: 'bnd' },
  { n: 'Bintauna', i: 'bne' },
  { n: 'Masiwang', i: 'bnf' },
  { n: 'Benga', i: 'bng' },
  { n: 'Bangi', i: 'bni' },
  { n: 'Eastern Tawbuid', i: 'bnj' },
  { n: 'Bierebo', i: 'bnk' },
  { n: 'Boon', i: 'bnl' },
  { n: 'Batanga', i: 'bnm' },
  { n: 'Bunun', i: 'bnn' },
  { n: 'Bantoanon', i: 'bno' },
  { n: 'Bola', i: 'bnp' },
  { n: 'Bantik', i: 'bnq' },
  { n: 'Butmas-Tur', i: 'bnr' },
  { n: 'Bundeli', i: 'bns' },
  { n: 'Bentong', i: 'bnu' },
  { n: 'Bonerif', i: 'bnv' },
  { n: 'Bisis', i: 'bnw' },
  { n: 'Bangubangu', i: 'bnx' },
  { n: 'Bintulu', i: 'bny' },
  { n: 'Beezen', i: 'bnz' },
  { n: 'Bora', i: 'boa' },
  { n: 'Aweer', i: 'bob' },
  { n: 'Tibetan', i: 'bod' },
  { n: 'Mundabli', i: 'boe' },
  { n: 'Bolon', i: 'bof' },
  { n: 'Bamako Sign Language', i: 'bog' },
  { n: 'Boma', i: 'boh' },
  { n: 'Anjam', i: 'boj' },
  { n: 'Bonjo', i: 'bok' },
  { n: 'Bole', i: 'bol' },
  { n: 'Berom', i: 'bom' },
  { n: 'Bine', i: 'bon' },
  { n: 'Tiemacèwè Bozo', i: 'boo' },
  { n: 'Bonkiman', i: 'bop' },
  { n: 'Bogaya', i: 'boq' },
  { n: 'Borôro', i: 'bor' },
  { n: 'Bosnian', i: 'bos' },
  { n: 'Bongo', i: 'bot' },
  { n: 'Bondei', i: 'bou' },
  { n: 'Tuwuli', i: 'bov' },
  { n: 'Buamu', i: 'box' },
  { n: 'Bodo (Central African Republic)', i: 'boy' },
  { n: 'Tiéyaxo Bozo', i: 'boz' },
  { n: 'Daakaka', i: 'bpa' },
  { n: 'Banda-Banda', i: 'bpd' },
  { n: 'Bonggo', i: 'bpg' },
  { n: 'Botlikh', i: 'bph' },
  { n: 'Bagupi', i: 'bpi' },
  { n: 'Binji', i: 'bpj' },
  { n: 'Orowe', i: 'bpk' },
  { n: 'Broome Pearling Lugger Pidgin', i: 'bpl' },
  { n: 'Biyom', i: 'bpm' },
  { n: 'Dzao Min', i: 'bpn' },
  { n: 'Anasi', i: 'bpo' },
  { n: 'Kaure', i: 'bpp' },
  { n: 'Banda Malay', i: 'bpq' },
  { n: 'Koronadal Blaan', i: 'bpr' },
  { n: 'Sarangani Blaan', i: 'bps' },
  { n: 'Bongu', i: 'bpu' },
  { n: 'Bian Marind', i: 'bpv' },
  { n: 'Bo (Papua New Guinea)', i: 'bpw' },
  { n: 'Palya Bareli', i: 'bpx' },
  { n: 'Bishnupriya', i: 'bpy' },
  { n: 'Bilba', i: 'bpz' },
  { n: 'Tchumbuli', i: 'bqa' },
  { n: 'Bagusa', i: 'bqb' },
  { n: 'Boko (Benin)', i: 'bqc' },
  { n: 'Bung', i: 'bqd' },
  { n: 'Bago-Kusuntu', i: 'bqg' },
  { n: 'Baima', i: 'bqh' },
  { n: 'Bakhtiari', i: 'bqi' },
  { n: 'Bandial', i: 'bqj' },
  { n: 'Banda-Mbrès', i: 'bqk' },
  { n: 'Bilakura', i: 'bql' },
  { n: 'Wumboko', i: 'bqm' },
  { n: 'Bulgarian Sign Language', i: 'bqn' },
  { n: 'Balo', i: 'bqo' },
  { n: 'Busa', i: 'bqp' },
  { n: 'Biritai', i: 'bqq' },
  { n: 'Burusu', i: 'bqr' },
  { n: 'Bosngun', i: 'bqs' },
  { n: 'Bamukumbit', i: 'bqt' },
  { n: 'Boguru', i: 'bqu' },
  { n: 'Koro Wachi', i: 'bqv' },
  { n: 'Buru (Nigeria)', i: 'bqw' },
  { n: 'Baangi', i: 'bqx' },
  { n: 'Bengkala Sign Language', i: 'bqy' },
  { n: 'Bakaka', i: 'bqz' },
  { n: 'Braj', i: 'bra' },
  { n: 'Lave', i: 'brb' },
  { n: 'Baraamu', i: 'brd' },
  { n: 'Breton', i: 'bre' },
  { n: 'Bira', i: 'brf' },
  { n: 'Baure', i: 'brg' },
  { n: 'Brahui', i: 'brh' },
  { n: 'Mokpwe', i: 'bri' },
  { n: 'Bieria', i: 'brj' },
  { n: 'Birwa', i: 'brl' },
  { n: 'Barambu', i: 'brm' },
  { n: 'Boruca', i: 'brn' },
  { n: 'Brokkat', i: 'bro' },
  { n: 'Barapasi', i: 'brp' },
  { n: 'Breri', i: 'brq' },
  { n: 'Birao', i: 'brr' },
  { n: 'Baras', i: 'brs' },
  { n: 'Bitare', i: 'brt' },
  { n: 'Eastern Bru', i: 'bru' },
  { n: 'Western Bru', i: 'brv' },
  { n: 'Bellari', i: 'brw' },
  { n: 'Bodo (India)', i: 'brx' },
  { n: 'Burui', i: 'bry' },
  { n: 'Bilbil', i: 'brz' },
  { n: 'Abinomn', i: 'bsa' },
  { n: 'Brunei Bisaya', i: 'bsb' },
  { n: 'Bassari', i: 'bsc' },
  { n: 'Wushi', i: 'bse' },
  { n: 'Bauchi', i: 'bsf' },
  { n: 'Bashkardi', i: 'bsg' },
  { n: 'Kati', i: 'bsh' },
  { n: 'Bassossi', i: 'bsi' },
  { n: 'Bangwinji', i: 'bsj' },
  { n: 'Burushaski', i: 'bsk' },
  { n: 'Busami', i: 'bsm' },
  { n: 'Barasana-Eduria', i: 'bsn' },
  { n: 'Buso', i: 'bso' },
  { n: 'Baga Sitemu', i: 'bsp' },
  { n: 'Bassa', i: 'bsq' },
  { n: 'Bassa-Kontagora', i: 'bsr' },
  { n: 'Akoose', i: 'bss' },
  { n: 'Basketo', i: 'bst' },
  { n: 'Bahonsuai', i: 'bsu' },
  { n: 'Baiso', i: 'bsw' },
  { n: 'Yangkam', i: 'bsx' },
  { n: 'Sabah Bisaya', i: 'bsy' },
  { n: 'Bata', i: 'bta' },
  { n: 'Bati (Cameroon)', i: 'btc' },
  { n: 'Batak Dairi', i: 'btd' },
  { n: 'Birgit', i: 'btf' },
  { n: 'Gagnoa Bété', i: 'btg' },
  { n: 'Biatah Bidayuh', i: 'bth' },
  { n: 'Burate', i: 'bti' },
  { n: 'Bacanese Malay', i: 'btj' },
  { n: 'Batak Mandailing', i: 'btm' },
  { n: 'Ratagnon', i: 'btn' },
  { n: 'Rinconada Bikol', i: 'bto' },
  { n: 'Budibud', i: 'btp' },
  { n: 'Batek', i: 'btq' },
  { n: 'Baetora', i: 'btr' },
  { n: 'Batak Simalungun', i: 'bts' },
  { n: 'Bete-Bendi', i: 'btt' },
  { n: 'Batu', i: 'btu' },
  { n: 'Bateri', i: 'btv' },
  { n: 'Butuanon', i: 'btw' },
  { n: 'Batak Karo', i: 'btx' },
  { n: 'Bobot', i: 'bty' },
  { n: 'Batak Alas-Kluet', i: 'btz' },
  { n: 'Bua', i: 'bub' },
  { n: 'Bushi', i: 'buc' },
  { n: 'Ntcham', i: 'bud' },
  { n: 'Bushoong', i: 'buf' },
  { n: 'Buginese', i: 'bug' },
  { n: 'Younuo Bunu', i: 'buh' },
  { n: 'Bongili', i: 'bui' },
  { n: 'Basa-Gurmana', i: 'buj' },
  { n: 'Bugawac', i: 'buk' },
  { n: 'Bulgarian', i: 'bul' },
  { n: 'Bulu (Cameroon)', i: 'bum' },
  { n: 'Sherbro', i: 'bun' },
  { n: 'Terei', i: 'buo' },
  { n: 'Busoa', i: 'bup' },
  { n: 'Brem', i: 'buq' },
  { n: 'Bokobaru', i: 'bus' },
  { n: 'Bungain', i: 'but' },
  { n: 'Budu', i: 'buu' },
  { n: 'Bun', i: 'buv' },
  { n: 'Bubi', i: 'buw' },
  { n: 'Boghom', i: 'bux' },
  { n: 'Bullom So', i: 'buy' },
  { n: 'Bukwen', i: 'buz' },
  { n: 'Barein', i: 'bva' },
  { n: 'Bube', i: 'bvb' },
  { n: 'Baelelea', i: 'bvc' },
  { n: 'Baeggu', i: 'bvd' },
  { n: 'Berau Malay', i: 'bve' },
  { n: 'Boor', i: 'bvf' },
  { n: 'Bonkeng', i: 'bvg' },
  { n: 'Bure', i: 'bvh' },
  { n: 'Belanda Viri', i: 'bvi' },
  { n: 'Baan', i: 'bvj' },
  { n: 'Bukat', i: 'bvk' },
  { n: 'Bolivian Sign Language', i: 'bvl' },
  { n: 'Bamunka', i: 'bvm' },
  { n: 'Buna', i: 'bvn' },
  { n: 'Bolgo', i: 'bvo' },
  { n: 'Bumang', i: 'bvp' },
  { n: 'Birri', i: 'bvq' },
  { n: 'Burarra', i: 'bvr' },
  { n: 'Bati (Indonesia)', i: 'bvt' },
  { n: 'Bukit Malay', i: 'bvu' },
  { n: 'Boga', i: 'bvw' },
  { n: 'Dibole', i: 'bvx' },
  { n: 'Baybayanon', i: 'bvy' },
  { n: 'Bauzi', i: 'bvz' },
  { n: 'Bwatoo', i: 'bwa' },
  { n: 'Namosi-Naitasiri-Serua', i: 'bwb' },
  { n: 'Bwile', i: 'bwc' },
  { n: 'Bwaidoka', i: 'bwd' },
  { n: 'Bwe Karen', i: 'bwe' },
  { n: 'Boselewa', i: 'bwf' },
  { n: 'Barwe', i: 'bwg' },
  { n: 'Bishuo', i: 'bwh' },
  { n: 'Baniwa', i: 'bwi' },
  { n: 'Láá Láá Bwamu', i: 'bwj' },
  { n: 'Bauwaki', i: 'bwk' },
  { n: 'Bwela', i: 'bwl' },
  { n: 'Biwat', i: 'bwm' },
  { n: 'Wunai Bunu', i: 'bwn' },
  { n: 'Boro (Ethiopia)', i: 'bwo' },
  { n: 'Mandobo Bawah', i: 'bwp' },
  { n: 'Southern Bobo Madaré', i: 'bwq' },
  { n: 'Bura-Pabir', i: 'bwr' },
  { n: 'Bomboma', i: 'bws' },
  { n: 'Bafaw-Balong', i: 'bwt' },
  { n: 'Buli (Ghana)', i: 'bwu' },
  { n: 'Bwa', i: 'bww' },
  { n: 'Bu-Nao Bunu', i: 'bwx' },
  { n: 'Cwi Bwamu', i: 'bwy' },
  { n: 'Bwisi', i: 'bwz' },
  { n: 'Tairaha', i: 'bxa' },
  { n: 'Belanda Bor', i: 'bxb' },
  { n: 'Molengue', i: 'bxc' },
  { n: 'Pela', i: 'bxd' },
  { n: 'Birale', i: 'bxe' },
  { n: 'Bilur', i: 'bxf' },
  { n: 'Bangala', i: 'bxg' },
  { n: 'Buhutu', i: 'bxh' },
  { n: 'Bayungu', i: 'bxj' },
  { n: 'Bukusu', i: 'bxk' },
  { n: 'Jalkunan', i: 'bxl' },
  { n: 'Mongolia Buriat', i: 'bxm' },
  { n: 'Burduna', i: 'bxn' },
  { n: 'Barikanchi', i: 'bxo' },
  { n: 'Bebil', i: 'bxp' },
  { n: 'Beele', i: 'bxq' },
  { n: 'Russia Buriat', i: 'bxr' },
  { n: 'Busam', i: 'bxs' },
  { n: 'China Buriat', i: 'bxu' },
  { n: 'Berakou', i: 'bxv' },
  { n: 'Bankagooma', i: 'bxw' },
  { n: 'Binahari', i: 'bxz' },
  { n: 'Batak', i: 'bya' },
  { n: 'Bikya', i: 'byb' },
  { n: 'Ubaghara', i: 'byc' },
  { n: "Benyadu'", i: 'byd' },
  { n: 'Pouye', i: 'bye' },
  { n: 'Bete', i: 'byf' },
  { n: 'Bhujel', i: 'byh' },
  { n: 'Buyu', i: 'byi' },
  { n: 'Bina (Nigeria)', i: 'byj' },
  { n: 'Biao', i: 'byk' },
  { n: 'Bayono', i: 'byl' },
  { n: 'Bidjara', i: 'bym' },
  { n: 'Bilin', i: 'byn' },
  { n: 'Biyo', i: 'byo' },
  { n: 'Bumaji', i: 'byp' },
  { n: 'Baruya', i: 'byr' },
  { n: 'Burak', i: 'bys' },
  { n: 'Medumba', i: 'byv' },
  { n: 'Belhariya', i: 'byw' },
  { n: 'Qaqet', i: 'byx' },
  { n: 'Banaro', i: 'byz' },
  { n: 'Bandi', i: 'bza' },
  { n: 'Andio', i: 'bzb' },
  { n: 'Southern Betsimisaraka Malagasy', i: 'bzc' },
  { n: 'Bribri', i: 'bzd' },
  { n: 'Jenaama Bozo', i: 'bze' },
  { n: 'Boikin', i: 'bzf' },
  { n: 'Babuza', i: 'bzg' },
  { n: 'Mapos Buang', i: 'bzh' },
  { n: 'Bisu', i: 'bzi' },
  { n: 'Belize Kriol English', i: 'bzj' },
  { n: 'Nicaragua Creole English', i: 'bzk' },
  { n: 'Boano (Sulawesi)', i: 'bzl' },
  { n: 'Bolondo', i: 'bzm' },
  { n: 'Boano (Maluku)', i: 'bzn' },
  { n: 'Bozaba', i: 'bzo' },
  { n: 'Kemberano', i: 'bzp' },
  { n: 'Buli (Indonesia)', i: 'bzq' },
  { n: 'Brazilian Sign Language', i: 'bzs' },
  { n: 'Burmeso', i: 'bzu' },
  { n: 'Naami', i: 'bzv' },
  { n: 'Basa (Nigeria)', i: 'bzw' },
  { n: 'Kɛlɛngaxo Bozo', i: 'bzx' },
  { n: 'Obanliku', i: 'bzy' },
  { n: 'Evant', i: 'bzz' },
  { n: 'Chortí', i: 'caa' },
  { n: 'Garifuna', i: 'cab' },
  { n: 'Chuj', i: 'cac' },
  { n: 'Caddo', i: 'cad' },
  { n: 'Lehar', i: 'cae' },
  { n: 'Southern Carrier', i: 'caf' },
  { n: 'Nivaclé', i: 'cag' },
  { n: 'Cahuarano', i: 'cah' },
  { n: 'Kaqchikel', i: 'cak' },
  { n: 'Carolinian', i: 'cal' },
  { n: 'Cemuhî', i: 'cam' },
  { n: 'Chambri', i: 'can' },
  { n: 'Chácobo', i: 'cao' },
  { n: 'Chipaya', i: 'cap' },
  { n: 'Car Nicobarese', i: 'caq' },
  { n: 'Galibi Carib', i: 'car' },
  { n: 'Tsimané', i: 'cas' },
  { n: 'Catalan', i: 'cat' },
  { n: 'Cavineña', i: 'cav' },
  { n: 'Callawalla', i: 'caw' },
  { n: 'Chiquitano', i: 'cax' },
  { n: 'Cayuga', i: 'cay' },
  { n: 'Cabiyarí', i: 'cbb' },
  { n: 'Carapana', i: 'cbc' },
  { n: 'Carijona', i: 'cbd' },
  { n: 'Chimila', i: 'cbg' },
  { n: 'Chachi', i: 'cbi' },
  { n: 'Ede Cabe', i: 'cbj' },
  { n: 'Chavacano', i: 'cbk' },
  { n: 'Bualkhaw Chin', i: 'cbl' },
  { n: 'Nyahkur', i: 'cbn' },
  { n: 'Izora', i: 'cbo' },
  { n: 'Tsucuba', i: 'cbq' },
  { n: 'Cashibo-Cacataibo', i: 'cbr' },
  { n: 'Cashinahua', i: 'cbs' },
  { n: 'Chayahuita', i: 'cbt' },
  { n: 'Candoshi-Shapra', i: 'cbu' },
  { n: 'Cacua', i: 'cbv' },
  { n: 'Kinabalian', i: 'cbw' },
  { n: 'Carabayo', i: 'cby' },
  { n: 'Chamicuro', i: 'ccc' },
  { n: 'Cafundo Creole', i: 'ccd' },
  { n: 'Chopi', i: 'cce' },
  { n: 'Samba Daka', i: 'ccg' },
  { n: 'Atsam', i: 'cch' },
  { n: 'Kasanga', i: 'ccj' },
  { n: 'Cutchi-Swahili', i: 'ccl' },
  { n: 'Malaccan Creole Malay', i: 'ccm' },
  { n: 'Comaltepec Chinantec', i: 'cco' },
  { n: 'Chakma', i: 'ccp' },
  { n: 'Choni', i: 'cda' },
  { n: 'Chenchu', i: 'cde' },
  { n: 'Chiru', i: 'cdf' },
  { n: 'Chambeali', i: 'cdh' },
  { n: 'Chodri', i: 'cdi' },
  { n: 'Churahi', i: 'cdj' },
  { n: 'Chepang', i: 'cdm' },
  { n: 'Chaudangsi', i: 'cdn' },
  { n: 'Min Dong Chinese', i: 'cdo' },
  { n: 'Cinda-Regi-Tiyal', i: 'cdr' },
  { n: 'Chadian Sign Language', i: 'cds' },
  { n: 'Chadong', i: 'cdy' },
  { n: 'Koda', i: 'cdz' },
  { n: 'Cebuano', i: 'ceb' },
  { n: 'Chamacoco', i: 'ceg' },
  { n: 'Eastern Khumi Chin', i: 'cek' },
  { n: 'Cen', i: 'cen' },
  { n: 'Czech', i: 'ces' },
  { n: 'Centúúm', i: 'cet' },
  { n: 'Ekai Chin', i: 'cey' },
  { n: 'Dijim-Bwilim', i: 'cfa' },
  { n: 'Cara', i: 'cfd' },
  { n: 'Como Karim', i: 'cfg' },
  { n: 'Falam Chin', i: 'cfm' },
  { n: 'Changriwa', i: 'cga' },
  { n: 'Kagayanen', i: 'cgc' },
  { n: 'Chiga', i: 'cgg' },
  { n: 'Chocangacakha', i: 'cgk' },
  { n: 'Chamorro', i: 'cha' },
  { n: 'Highland Oaxaca Chontal', i: 'chd' },
  { n: 'Chechen', i: 'che' },
  { n: 'Tabasco Chontal', i: 'chf' },
  { n: 'Ojitlán Chinantec', i: 'chj' },
  { n: 'Chuukese', i: 'chk' },
  { n: 'Cahuilla', i: 'chl' },
  { n: 'Chinook jargon', i: 'chn' },
  { n: 'Choctaw', i: 'cho' },
  { n: 'Chipewyan', i: 'chp' },
  { n: 'Quiotepec Chinantec', i: 'chq' },
  { n: 'Cherokee', i: 'chr' },
  { n: 'Chuvash', i: 'chv' },
  { n: 'Chuwabu', i: 'chw' },
  { n: 'Chantyal', i: 'chx' },
  { n: 'Cheyenne', i: 'chy' },
  { n: 'Ozumacín Chinantec', i: 'chz' },
  { n: 'Cia-Cia', i: 'cia' },
  { n: 'Ci Gbe', i: 'cib' },
  { n: 'Chickasaw', i: 'cic' },
  { n: 'Cineni', i: 'cie' },
  { n: 'Chinali', i: 'cih' },
  { n: 'Chitkuli Kinnauri', i: 'cik' },
  { n: 'Cimbrian', i: 'cim' },
  { n: 'Cinta Larga', i: 'cin' },
  { n: 'Chiapanec', i: 'cip' },
  { n: 'Tiri', i: 'cir' },
  { n: 'Chippewa', i: 'ciw' },
  { n: 'Chaima', i: 'ciy' },
  { n: 'Western Cham', i: 'cja' },
  { n: 'Chru', i: 'cje' },
  { n: 'Chamalal', i: 'cji' },
  { n: 'Chokwe', i: 'cjk' },
  { n: 'Eastern Cham', i: 'cjm' },
  { n: 'Chenapian', i: 'cjn' },
  { n: 'Ashéninka Pajonal', i: 'cjo' },
  { n: 'Cabécar', i: 'cjp' },
  { n: 'Shor', i: 'cjs' },
  { n: 'Chuave', i: 'cjv' },
  { n: 'Jinyu Chinese', i: 'cjy' },
  { n: 'Central Kurdish', i: 'ckb' },
  { n: 'Chak', i: 'ckh' },
  { n: 'Cibak', i: 'ckl' },
  { n: 'Chakavian', i: 'ckm' },
  { n: 'Kaang Chin', i: 'ckn' },
  { n: 'Anufo', i: 'cko' },
  { n: 'Kajakse', i: 'ckq' },
  { n: 'Kairak', i: 'ckr' },
  { n: 'Tayo', i: 'cks' },
  { n: 'Chukot', i: 'ckt' },
  { n: 'Koasati', i: 'cku' },
  { n: 'Kavalan', i: 'ckv' },
  { n: 'Caka', i: 'ckx' },
  { n: 'Cakfem-Mushere', i: 'cky' },
  { n: 'Cakchiquel-Quiché Mixed Language', i: 'ckz' },
  { n: 'Ron', i: 'cla' },
  { n: 'Chilcotin', i: 'clc' },
  { n: 'Chaldean Neo-Aramaic', i: 'cld' },
  { n: 'Lealao Chinantec', i: 'cle' },
  { n: 'Chilisso', i: 'clh' },
  { n: 'Chakali', i: 'cli' },
  { n: 'Laitu Chin', i: 'clj' },
  { n: 'Idu-Mishmi', i: 'clk' },
  { n: 'Chala', i: 'cll' },
  { n: 'Clallam', i: 'clm' },
  { n: 'Lowland Oaxaca Chontal', i: 'clo' },
  { n: 'Lautu Chin', i: 'clt' },
  { n: 'Caluyanun', i: 'clu' },
  { n: 'Chulym', i: 'clw' },
  { n: 'Eastern Highland Chatino', i: 'cly' },
  { n: 'Maa', i: 'cma' },
  { n: 'Cerma', i: 'cme' },
  { n: 'Emberá-Chamí', i: 'cmi' },
  { n: 'Campalagian', i: 'cml' },
  { n: 'Mandarin Chinese', i: 'cmn' },
  { n: 'Central Mnong', i: 'cmo' },
  { n: 'Mro-Khimi Chin', i: 'cmr' },
  { n: 'Camtho', i: 'cmt' },
  { n: 'Changthang', i: 'cna' },
  { n: 'Chinbon Chin', i: 'cnb' },
  { n: 'Côông', i: 'cnc' },
  { n: 'Northern Qiang', i: 'cng' },
  { n: 'Hakha Chin', i: 'cnh' },
  { n: 'Asháninka', i: 'cni' },
  { n: 'Khumi Chin', i: 'cnk' },
  { n: 'Lalana Chinantec', i: 'cnl' },
  { n: 'Con', i: 'cno' },
  { n: 'Northern Ping Chinese', i: 'cnp' },
  { n: 'Montenegrin', i: 'cnr' },
  { n: 'Central Asmat', i: 'cns' },
  { n: 'Tepetotutla Chinantec', i: 'cnt' },
  { n: 'Chenoua', i: 'cnu' },
  { n: 'Ngawn Chin', i: 'cnw' },
  { n: 'Cocos Islands Malay', i: 'coa' },
  { n: 'Cocopa', i: 'coc' },
  { n: 'Cocama-Cocamilla', i: 'cod' },
  { n: 'Koreguaje', i: 'coe' },
  { n: 'Colorado', i: 'cof' },
  { n: 'Chong', i: 'cog' },
  { n: 'Chonyi-Dzihana-Kauma', i: 'coh' },
  { n: 'Santa Teresa Cora', i: 'cok' },
  { n: 'Columbia-Wenatchi', i: 'col' },
  { n: 'Comanche', i: 'com' },
  { n: 'Cofán', i: 'con' },
  { n: 'Comox', i: 'coo' },
  { n: 'Cornish', i: 'cor' },
  { n: 'Corsican', i: 'cos' },
  { n: 'Caquinte', i: 'cot' },
  { n: 'Wamey', i: 'cou' },
  { n: 'Cao Miao', i: 'cov' },
  { n: 'Nanti', i: 'cox' },
  { n: 'Chochotec', i: 'coz' },
  { n: 'Palantla Chinantec', i: 'cpa' },
  { n: 'Ucayali-Yurúa Ashéninka', i: 'cpb' },
  { n: 'Ajyíninka Apurucayali', i: 'cpc' },
  { n: 'Chinese Pidgin English', i: 'cpi' },
  { n: 'Cherepon', i: 'cpn' },
  { n: 'Kpeego', i: 'cpo' },
  { n: 'Capiznon', i: 'cps' },
  { n: 'Pichis Ashéninka', i: 'cpu' },
  { n: 'Pu-Xian Chinese', i: 'cpx' },
  { n: 'South Ucayali Ashéninka', i: 'cpy' },
  { n: 'Chuanqiandian Cluster Miao', i: 'cqd' },
  { n: 'Chara', i: 'cra' },
  { n: 'Lonwolwol', i: 'crc' },
  { n: "Coeur d'Alene", i: 'crd' },
  { n: 'Michif', i: 'crg' },
  { n: 'Crimean Tatar', i: 'crh' },
  { n: 'Sãotomense', i: 'cri' },
  { n: 'Southern East Cree', i: 'crj' },
  { n: 'Plains Cree', i: 'crk' },
  { n: 'Northern East Cree', i: 'crl' },
  { n: 'Moose Cree', i: 'crm' },
  { n: 'El Nayar Cora', i: 'crn' },
  { n: 'Crow', i: 'cro' },
  { n: "Iyo'wujwa Chorote", i: 'crq' },
  { n: 'Seselwa Creole French', i: 'crs' },
  { n: "Iyojwa'ja Chorote", i: 'crt' },
  { n: 'Chaura', i: 'crv' },
  { n: 'Chrau', i: 'crw' },
  { n: 'Carrier', i: 'crx' },
  { n: 'Cori', i: 'cry' },
  { n: 'Chiltepec Chinantec', i: 'csa' },
  { n: 'Kashubian', i: 'csb' },
  { n: 'Catalan Sign Language', i: 'csc' },
  { n: 'Chiangmai Sign Language', i: 'csd' },
  { n: 'Czech Sign Language', i: 'cse' },
  { n: 'Cuba Sign Language', i: 'csf' },
  { n: 'Chilean Sign Language', i: 'csg' },
  { n: 'Asho Chin', i: 'csh' },
  { n: 'Songlai Chin', i: 'csj' },
  { n: 'Jola-Kasa', i: 'csk' },
  { n: 'Chinese Sign Language', i: 'csl' },
  { n: 'Central Sierra Miwok', i: 'csm' },
  { n: 'Colombian Sign Language', i: 'csn' },
  { n: 'Sochiapam Chinantec', i: 'cso' },
  { n: 'Southern Ping Chinese', i: 'csp' },
  { n: 'Croatia Sign Language', i: 'csq' },
  { n: 'Costa Rican Sign Language', i: 'csr' },
  { n: 'Northern Ohlone', i: 'cst' },
  { n: 'Sumtu Chin', i: 'csv' },
  { n: 'Swampy Cree', i: 'csw' },
  { n: 'Siyin Chin', i: 'csy' },
  { n: 'Coos', i: 'csz' },
  { n: 'Tataltepec Chatino', i: 'cta' },
  { n: 'Tedim Chin', i: 'ctd' },
  { n: 'Tepinapa Chinantec', i: 'cte' },
  { n: 'Chittagonian', i: 'ctg' },
  { n: 'Thaiphum Chin', i: 'cth' },
  { n: 'Tlacoatzintepec Chinantec', i: 'ctl' },
  { n: 'Chhintange', i: 'ctn' },
  { n: 'Emberá-Catío', i: 'cto' },
  { n: 'Western Highland Chatino', i: 'ctp' },
  { n: 'Northern Catanduanes Bikol', i: 'cts' },
  { n: 'Wayanad Chetti', i: 'ctt' },
  { n: 'Chol', i: 'ctu' },
  { n: 'Zacatepec Chatino', i: 'ctz' },
  { n: 'Cua', i: 'cua' },
  { n: 'Cubeo', i: 'cub' },
  { n: 'Usila Chinantec', i: 'cuc' },
  { n: 'Chungmboko', i: 'cug' },
  { n: 'Chuka', i: 'cuh' },
  { n: 'Cuiba', i: 'cui' },
  { n: 'Mashco Piro', i: 'cuj' },
  { n: 'San Blas Kuna', i: 'cuk' },
  { n: 'Culina', i: 'cul' },
  { n: 'Cun', i: 'cuq' },
  { n: 'Chhulung', i: 'cur' },
  { n: 'Teutila Cuicatec', i: 'cut' },
  { n: 'Tai Ya', i: 'cuu' },
  { n: 'Cuvok', i: 'cuv' },
  { n: 'Chukwa', i: 'cuw' },
  { n: 'Tepeuxila Cuicatec', i: 'cux' },
  { n: 'Cuitlatec', i: 'cuy' },
  { n: 'Chug', i: 'cvg' },
  { n: 'Valle Nacional Chinantec', i: 'cvn' },
  { n: 'Kabwa', i: 'cwa' },
  { n: 'Maindo', i: 'cwb' },
  { n: 'Woods Cree', i: 'cwd' },
  { n: 'Kwere', i: 'cwe' },
  { n: 'Chewong', i: 'cwg' },
  { n: 'Kuwaataay', i: 'cwt' },
  { n: 'Nopala Chatino', i: 'cya' },
  { n: 'Welsh', i: 'cym' },
  { n: 'Cuyonon', i: 'cyo' },
  { n: 'Huizhou Chinese', i: 'czh' },
  { n: 'Zenzontepec Chatino', i: 'czn' },
  { n: 'Min Zhong Chinese', i: 'czo' },
  { n: 'Zotung Chin', i: 'czt' },
  { n: 'Dangaléat', i: 'daa' },
  { n: 'Dambi', i: 'dac' },
  { n: 'Marik', i: 'dad' },
  { n: 'Duupa', i: 'dae' },
  { n: 'Dagbani', i: 'dag' },
  { n: 'Gwahatike', i: 'dah' },
  { n: 'Day', i: 'dai' },
  { n: 'Dar Fur Daju', i: 'daj' },
  { n: 'Dakota', i: 'dak' },
  { n: 'Dahalo', i: 'dal' },
  { n: 'Damakawa', i: 'dam' },
  { n: 'Danish', i: 'dan' },
  { n: 'Daai Chin', i: 'dao' },
  { n: 'Dandami Maria', i: 'daq' },
  { n: 'Dargwa', i: 'dar' },
  { n: 'Daho-Doo', i: 'das' },
  { n: 'Dar Sila Daju', i: 'dau' },
  { n: 'Taita', i: 'dav' },
  { n: 'Davawenyo', i: 'daw' },
  { n: 'Dayi', i: 'dax' },
  { n: 'Dao', i: 'daz' },
  { n: 'Bangime', i: 'dba' },
  { n: 'Deno', i: 'dbb' },
  { n: 'Dadiya', i: 'dbd' },
  { n: 'Dabe', i: 'dbe' },
  { n: 'Edopi', i: 'dbf' },
  { n: 'Dogul Dom Dogon', i: 'dbg' },
  { n: 'Doka', i: 'dbi' },
  { n: "Ida'an", i: 'dbj' },
  { n: 'Dyirbal', i: 'dbl' },
  { n: 'Duguri', i: 'dbm' },
  { n: 'Duriankere', i: 'dbn' },
  { n: 'Dulbu', i: 'dbo' },
  { n: 'Duwai', i: 'dbp' },
  { n: 'Daba', i: 'dbq' },
  { n: 'Dabarre', i: 'dbr' },
  { n: 'Ben Tey Dogon', i: 'dbt' },
  { n: 'Bondum Dom Dogon', i: 'dbu' },
  { n: 'Dungu', i: 'dbv' },
  { n: 'Bankan Tey Dogon', i: 'dbw' },
  { n: 'Dibiyaso', i: 'dby' },
  { n: 'Deccan', i: 'dcc' },
  { n: 'Dongotono', i: 'ddd' },
  { n: 'Doondo', i: 'dde' },
  { n: 'Fataluku', i: 'ddg' },
  { n: 'West Goodenough', i: 'ddi' },
  { n: 'Jaru', i: 'ddj' },
  { n: 'Dendi (Benin)', i: 'ddn' },
  { n: 'Dido', i: 'ddo' },
  { n: 'Donno So Dogon', i: 'dds' },
  { n: 'Dawera-Daweloor', i: 'ddw' },
  { n: 'Dagik', i: 'dec' },
  { n: 'Dedua', i: 'ded' },
  { n: 'Dewoin', i: 'dee' },
  { n: 'Dezfuli', i: 'def' },
  { n: 'Degema', i: 'deg' },
  { n: 'Dehwari', i: 'deh' },
  { n: 'Demisa', i: 'dei' },
  { n: 'Dek', i: 'dek' },
  { n: 'Dem', i: 'dem' },
  { n: 'Dendi (Central African Republic)', i: 'deq' },
  { n: 'Deori', i: 'der' },
  { n: 'Desano', i: 'des' },
  { n: 'German', i: 'deu' },
  { n: 'Domung', i: 'dev' },
  { n: 'Dengese', i: 'dez' },
  { n: 'Southern Dagaare', i: 'dga' },
  { n: 'Bunoge Dogon', i: 'dgb' },
  { n: 'Casiguran Dumagat Agta', i: 'dgc' },
  { n: 'Dagaari Dioula', i: 'dgd' },
  { n: 'Degenan', i: 'dge' },
  { n: 'Doga', i: 'dgg' },
  { n: 'Dghwede', i: 'dgh' },
  { n: 'Northern Dagara', i: 'dgi' },
  { n: 'Dagba', i: 'dgk' },
  { n: 'Andaandi', i: 'dgl' },
  { n: 'Dogri (individual language)', i: 'dgo' },
  { n: 'Dogrib', i: 'dgr' },
  { n: 'Dogoso', i: 'dgs' },
  { n: 'Doghoro', i: 'dgx' },
  { n: 'Daga', i: 'dgz' },
  { n: 'Dhundari', i: 'dhd' },
  { n: 'Dhangu-Djangu', i: 'dhg' },
  { n: 'Dhimal', i: 'dhi' },
  { n: 'Dhalandji', i: 'dhl' },
  { n: 'Zemba', i: 'dhm' },
  { n: 'Dhanki', i: 'dhn' },
  { n: 'Dhodia', i: 'dho' },
  { n: 'Dhargari', i: 'dhr' },
  { n: 'Dhaiso', i: 'dhs' },
  { n: 'Dehu', i: 'dhv' },
  { n: 'Dhanwar (Nepal)', i: 'dhw' },
  { n: 'Dhungaloo', i: 'dhx' },
  { n: 'Dia', i: 'dia' },
  { n: 'South Central Dinka', i: 'dib' },
  { n: 'Lakota Dida', i: 'dic' },
  { n: 'Didinga', i: 'did' },
  { n: 'Digo', i: 'dig' },
  { n: 'Kumiai', i: 'dih' },
  { n: 'Dimbong', i: 'dii' },
  { n: 'Dai', i: 'dij' },
  { n: 'Southwestern Dinka', i: 'dik' },
  { n: 'Dilling', i: 'dil' },
  { n: 'Dime', i: 'dim' },
  { n: 'Dibo', i: 'dio' },
  { n: 'Northeastern Dinka', i: 'dip' },
  { n: 'Dimli (individual language)', i: 'diq' },
  { n: 'Dirim', i: 'dir' },
  { n: 'Dimasa', i: 'dis' },
  { n: 'Diriku', i: 'diu' },
  { n: 'Dhivehi', i: 'div' },
  { n: 'Northwestern Dinka', i: 'diw' },
  { n: 'Dixon Reef', i: 'dix' },
  { n: 'Diuwe', i: 'diy' },
  { n: 'Ding', i: 'diz' },
  { n: 'Djinba', i: 'djb' },
  { n: 'Dar Daju Daju', i: 'djc' },
  { n: 'Djamindjung', i: 'djd' },
  { n: 'Zarma', i: 'dje' },
  { n: 'Djinang', i: 'dji' },
  { n: 'Djeebbana', i: 'djj' },
  { n: 'Eastern Maroon Creole', i: 'djk' },
  { n: 'Jamsay Dogon', i: 'djm' },
  { n: 'Jawoyn', i: 'djn' },
  { n: 'Jangkang', i: 'djo' },
  { n: 'Djambarrpuyngu', i: 'djr' },
  { n: 'Kapriman', i: 'dju' },
  { n: 'Dakpakha', i: 'dka' },
  { n: 'Dakka', i: 'dkk' },
  { n: 'Kuijau', i: 'dkr' },
  { n: 'Southeastern Dinka', i: 'dks' },
  { n: 'Mazagway', i: 'dkx' },
  { n: 'Dolgan', i: 'dlg' },
  { n: 'Dahalik', i: 'dlk' },
  { n: 'Darlong', i: 'dln' },
  { n: 'Duma', i: 'dma' },
  { n: 'Mombo Dogon', i: 'dmb' },
  { n: 'Gavak', i: 'dmc' },
  { n: 'Dugwor', i: 'dme' },
  { n: 'Upper Kinabatangan', i: 'dmg' },
  { n: 'Domaaki', i: 'dmk' },
  { n: 'Dameli', i: 'dml' },
  { n: 'Dama', i: 'dmm' },
  { n: 'Kemedzung', i: 'dmo' },
  { n: 'East Damar', i: 'dmr' },
  { n: 'Dampelas', i: 'dms' },
  { n: 'Dubu', i: 'dmu' },
  { n: 'Dumpas', i: 'dmv' },
  { n: 'Mudburra', i: 'dmw' },
  { n: 'Dema', i: 'dmx' },
  { n: 'Demta', i: 'dmy' },
  { n: 'Upper Grand Valley Dani', i: 'dna' },
  { n: 'Daonda', i: 'dnd' },
  { n: 'Ndendeule', i: 'dne' },
  { n: 'Dungan', i: 'dng' },
  { n: 'Lower Grand Valley Dani', i: 'dni' },
  { n: 'Dan', i: 'dnj' },
  { n: 'Dengka', i: 'dnk' },
  { n: 'Dzùùngoo', i: 'dnn' },
  { n: 'Ndrulo', i: 'dno' },
  { n: 'Danaru', i: 'dnr' },
  { n: 'Mid Grand Valley Dani', i: 'dnt' },
  { n: 'Danau', i: 'dnu' },
  { n: 'Danu', i: 'dnv' },
  { n: 'Western Dani', i: 'dnw' },
  { n: 'Dení', i: 'dny' },
  { n: 'Dom', i: 'doa' },
  { n: 'Dobu', i: 'dob' },
  { n: 'Northern Dong', i: 'doc' },
  { n: 'Doe', i: 'doe' },
  { n: 'Domu', i: 'dof' },
  { n: 'Dong', i: 'doh' },
  { n: 'Dondo', i: 'dok' },
  { n: 'Doso', i: 'dol' },
  { n: 'Toura (Papua New Guinea)', i: 'don' },
  { n: 'Dongo', i: 'doo' },
  { n: 'Lukpa', i: 'dop' },
  { n: 'Dominican Sign Language', i: 'doq' },
  { n: "Dori'o", i: 'dor' },
  { n: 'Dogosé', i: 'dos' },
  { n: 'Dass', i: 'dot' },
  { n: 'Dombe', i: 'dov' },
  { n: 'Doyayo', i: 'dow' },
  { n: 'Bussa', i: 'dox' },
  { n: 'Dompo', i: 'doy' },
  { n: 'Dorze', i: 'doz' },
  { n: 'Papar', i: 'dpp' },
  { n: 'Dair', i: 'drb' },
  { n: 'Minderico', i: 'drc' },
  { n: 'Darmiya', i: 'drd' },
  { n: 'Dolpo', i: 'dre' },
  { n: 'Rungus', i: 'drg' },
  { n: "C'Lela", i: 'dri' },
  { n: 'Paakantyi', i: 'drl' },
  { n: 'West Damar', i: 'drn' },
  { n: 'Daro-Matu Melanau', i: 'dro' },
  { n: 'Gedeo', i: 'drs' },
  { n: 'Drents', i: 'drt' },
  { n: 'Rukai', i: 'dru' },
  { n: 'Darai', i: 'dry' },
  { n: 'Lower Sorbian', i: 'dsb' },
  { n: 'Dutch Sign Language', i: 'dse' },
  { n: 'Daasanach', i: 'dsh' },
  { n: 'Disa', i: 'dsi' },
  { n: 'Danish Sign Language', i: 'dsl' },
  { n: 'Desiya', i: 'dso' },
  { n: 'Tadaksahak', i: 'dsq' },
  { n: 'Daur', i: 'dta' },
  { n: 'Labuk-Kinabatangan Kadazan', i: 'dtb' },
  { n: 'Ditidaht', i: 'dtd' },
  { n: 'Ana Tinga Dogon', i: 'dti' },
  { n: 'Tene Kan Dogon', i: 'dtk' },
  { n: 'Tomo Kan Dogon', i: 'dtm' },
  { n: 'Daatsʼíin', i: 'dtn' },
  { n: 'Tommo So Dogon', i: 'dto' },
  { n: 'Kadazan Dusun', i: 'dtp' },
  { n: 'Lotud', i: 'dtr' },
  { n: 'Toro So Dogon', i: 'dts' },
  { n: 'Toro Tegu Dogon', i: 'dtt' },
  { n: 'Tebul Ure Dogon', i: 'dtu' },
  { n: 'Dotyali', i: 'dty' },
  { n: 'Duala', i: 'dua' },
  { n: 'Dubli', i: 'dub' },
  { n: 'Duna', i: 'duc' },
  { n: 'Umiray Dumaget Agta', i: 'due' },
  { n: 'Dumbea', i: 'duf' },
  { n: 'Duruma', i: 'dug' },
  { n: 'Dungra Bhil', i: 'duh' },
  { n: 'Dumun', i: 'dui' },
  { n: 'Uyajitaya', i: 'duk' },
  { n: 'Alabat Island Agta', i: 'dul' },
  { n: 'Dusun Deyah', i: 'dun' },
  { n: 'Dupaninan Agta', i: 'duo' },
  { n: 'Duano', i: 'dup' },
  { n: 'Dusun Malang', i: 'duq' },
  { n: 'Dii', i: 'dur' },
  { n: 'Dumi', i: 'dus' },
  { n: 'Drung', i: 'duu' },
  { n: 'Duvle', i: 'duv' },
  { n: 'Dusun Witu', i: 'duw' },
  { n: 'Duungooma', i: 'dux' },
  { n: 'Duau', i: 'dva' },
  { n: 'Diri', i: 'dwa' },
  { n: 'Dawik Kui', i: 'dwk' },
  { n: 'Dawro', i: 'dwr' },
  { n: 'Dhuwal', i: 'dwu' },
  { n: 'Dawawa', i: 'dww' },
  { n: 'Dhuwaya', i: 'dwy' },
  { n: 'Dewas Rai', i: 'dwz' },
  { n: 'Dyan', i: 'dya' },
  { n: 'Djimini Senoufo', i: 'dyi' },
  { n: 'Yanda Dom Dogon', i: 'dym' },
  { n: 'Dyangadi', i: 'dyn' },
  { n: 'Jola-Fonyi', i: 'dyo' },
  { n: 'Dyula', i: 'dyu' },
  { n: 'Djabugay', i: 'dyy' },
  { n: 'Tunzu', i: 'dza' },
  { n: 'Dazaga', i: 'dzg' },
  { n: 'Dzalakha', i: 'dzl' },
  { n: 'Dzando', i: 'dzn' },
  { n: 'Dzongkha', i: 'dzo' },
  { n: 'Beginci', i: 'ebc' },
  { n: 'Ebughu', i: 'ebg' },
  { n: 'Eastern Bontok', i: 'ebk' },
  { n: 'Teke-Ebo', i: 'ebo' },
  { n: 'Ebrié', i: 'ebr' },
  { n: 'Embu', i: 'ebu' },
  { n: 'Ecuadorian Sign Language', i: 'ecs' },
  { n: 'E', i: 'eee' },
  { n: 'Efai', i: 'efa' },
  { n: 'Efe', i: 'efe' },
  { n: 'Efik', i: 'efi' },
  { n: 'Ega', i: 'ega' },
  { n: 'Emilian', i: 'egl' },
  { n: 'Eggon', i: 'ego' },
  { n: 'Ehueun', i: 'ehu' },
  { n: 'Eipomek', i: 'eip' },
  { n: 'Eitiep', i: 'eit' },
  { n: 'Askopan', i: 'eiv' },
  { n: 'Ejamat', i: 'eja' },
  { n: 'Ekajuk', i: 'eka' },
  { n: 'Ekit', i: 'eke' },
  { n: 'Ekari', i: 'ekg' },
  { n: 'Eki', i: 'eki' },
  { n: 'Standard Estonian', i: 'ekk' },
  { n: 'Kol (Bangladesh)', i: 'ekl' },
  { n: 'Elip', i: 'ekm' },
  { n: 'Koti', i: 'eko' },
  { n: 'Ekpeye', i: 'ekp' },
  { n: 'Yace', i: 'ekr' },
  { n: 'Eastern Kayah', i: 'eky' },
  { n: 'Elepi', i: 'ele' },
  { n: 'El Hugeirat', i: 'elh' },
  { n: 'Elkei', i: 'elk' },
  { n: 'Modern Greek (1453-)', i: 'ell' },
  { n: 'Eleme', i: 'elm' },
  { n: 'El Molo', i: 'elo' },
  { n: 'Elu', i: 'elu' },
  { n: 'Emai-Iuleha-Ora', i: 'ema' },
  { n: 'Embaloh', i: 'emb' },
  { n: 'Emerillon', i: 'eme' },
  { n: 'Eastern Meohang', i: 'emg' },
  { n: 'Mussau-Emira', i: 'emi' },
  { n: 'Eastern Maninkakan', i: 'emk' },
  { n: 'Eman', i: 'emn' },
  { n: 'Northern Emberá', i: 'emp' },
  { n: 'Pacific Gulf Yupik', i: 'ems' },
  { n: 'Eastern Muria', i: 'emu' },
  { n: 'Emplawas', i: 'emw' },
  { n: 'Erromintxela', i: 'emx' },
  { n: 'Apali', i: 'ena' },
  { n: 'Markweeta', i: 'enb' },
  { n: 'En', i: 'enc' },
  { n: 'Ende', i: 'end' },
  { n: 'Forest Enets', i: 'enf' },
  { n: 'English', i: 'eng' },
  { n: 'Tundra Enets', i: 'enh' },
  { n: 'Enlhet', i: 'enl' },
  { n: 'Engenni', i: 'enn' },
  { n: 'Enggano', i: 'eno' },
  { n: 'Enga', i: 'enq' },
  { n: 'Emumu', i: 'enr' },
  { n: 'Enu', i: 'enu' },
  { n: 'Enwan (Edu State)', i: 'env' },
  { n: 'Enwan (Akwa Ibom State)', i: 'enw' },
  { n: 'Enxet', i: 'enx' },
  { n: "Beti (Côte d'Ivoire)", i: 'eot' },
  { n: 'Epie', i: 'epi' },
  { n: 'Eravallan', i: 'era' },
  { n: 'Sie', i: 'erg' },
  { n: 'Eruwa', i: 'erh' },
  { n: 'Ogea', i: 'eri' },
  { n: 'South Efate', i: 'erk' },
  { n: 'Horpa', i: 'ero' },
  { n: 'Ersu', i: 'ers' },
  { n: 'Eritai', i: 'ert' },
  { n: 'Erokwanas', i: 'erw' },
  { n: 'Ese Ejja', i: 'ese' },
  { n: 'Aheri Gondi', i: 'esg' },
  { n: 'Eshtehardi', i: 'esh' },
  { n: 'North Alaskan Inupiatun', i: 'esi' },
  { n: 'Northwest Alaska Inupiatun', i: 'esk' },
  { n: 'Egypt Sign Language', i: 'esl' },
  { n: 'Salvadoran Sign Language', i: 'esn' },
  { n: 'Estonian Sign Language', i: 'eso' },
  { n: 'Central Siberian Yupik', i: 'ess' },
  { n: 'Central Yupik', i: 'esu' },
  { n: 'Eskayan', i: 'esy' },
  { n: 'Etebi', i: 'etb' },
  { n: 'Ethiopian Sign Language', i: 'eth' },
  { n: 'Eton (Vanuatu)', i: 'etn' },
  { n: 'Eton (Cameroon)', i: 'eto' },
  { n: 'Edolo', i: 'etr' },
  { n: 'Yekhee', i: 'ets' },
  { n: 'Ejagham', i: 'etu' },
  { n: 'Eten', i: 'etx' },
  { n: 'Semimi', i: 'etz' },
  { n: 'Basque', i: 'eus' },
  { n: 'Even', i: 'eve' },
  { n: 'Uvbie', i: 'evh' },
  { n: 'Evenki', i: 'evn' },
  { n: 'Ewe', i: 'ewe' },
  { n: 'Ewondo', i: 'ewo' },
  { n: 'Extremaduran', i: 'ext' },
  { n: 'Keiyo', i: 'eyo' },
  { n: 'Ezaa', i: 'eza' },
  { n: 'Uzekwe', i: 'eze' },
  { n: 'Fasu', i: 'faa' },
  { n: "Fa d'Ambu", i: 'fab' },
  { n: 'Wagi', i: 'fad' },
  { n: 'Fagani', i: 'faf' },
  { n: 'Finongan', i: 'fag' },
  { n: 'Baissa Fali', i: 'fah' },
  { n: 'Faiwol', i: 'fai' },
  { n: 'Faita', i: 'faj' },
  { n: 'Fang (Cameroon)', i: 'fak' },
  { n: 'South Fali', i: 'fal' },
  { n: 'Fam', i: 'fam' },
  { n: 'Fang (Equatorial Guinea)', i: 'fan' },
  { n: 'Faroese', i: 'fao' },
  { n: 'Paloor', i: 'fap' },
  { n: 'Fataleka', i: 'far' },
  { n: 'Fanti', i: 'fat' },
  { n: 'Fayu', i: 'fau' },
  { n: 'Fala', i: 'fax' },
  { n: 'Southwestern Fars', i: 'fay' },
  { n: 'Northwestern Fars', i: 'faz' },
  { n: 'West Albay Bikol', i: 'fbl' },
  { n: 'Quebec Sign Language', i: 'fcs' },
  { n: 'Feroge', i: 'fer' },
  { n: 'Foia Foia', i: 'ffi' },
  { n: 'Maasina Fulfulde', i: 'ffm' },
  { n: 'Fongoro', i: 'fgr' },
  { n: 'Nobiin', i: 'fia' },
  { n: 'Fyer', i: 'fie' },
  { n: 'Faifi', i: 'fif' },
  { n: 'Fijian', i: 'fij' },
  { n: 'Filipino', i: 'fil' },
  { n: 'Finnish', i: 'fin' },
  { n: 'Fipa', i: 'fip' },
  { n: 'Firan', i: 'fir' },
  { n: 'Tornedalen Finnish', i: 'fit' },
  { n: 'Fiwaga', i: 'fiw' },
  { n: 'Kirya-Konzəl', i: 'fkk' },
  { n: 'Kven Finnish', i: 'fkv' },
  { n: "Kalispel-Pend d'Oreille", i: 'fla' },
  { n: 'Foau', i: 'flh' },
  { n: 'Fali', i: 'fli' },
  { n: 'North Fali', i: 'fll' },
  { n: 'Fuliiru', i: 'flr' },
  { n: 'Flaaitaal', i: 'fly' },
  { n: "Fe'fe'", i: 'fmp' },
  { n: 'Far Western Muria', i: 'fmu' },
  { n: 'Fanbak', i: 'fnb' },
  { n: 'Fanagalo', i: 'fng' },
  { n: 'Fania', i: 'fni' },
  { n: 'Foodo', i: 'fod' },
  { n: 'Foi', i: 'foi' },
  { n: 'Foma', i: 'fom' },
  { n: 'Fon', i: 'fon' },
  { n: 'Fore', i: 'for' },
  { n: 'Fernando Po Creole English', i: 'fpe' },
  { n: 'Fas', i: 'fqs' },
  { n: 'French', i: 'fra' },
  { n: 'Cajun French', i: 'frc' },
  { n: 'Fordata', i: 'frd' },
  { n: 'Arpitan', i: 'frp' },
  { n: 'Forak', i: 'frq' },
  { n: 'Northern Frisian', i: 'frr' },
  { n: 'Eastern Frisian', i: 'frs' },
  { n: 'Fortsenal', i: 'frt' },
  { n: 'Western Frisian', i: 'fry' },
  { n: 'Finnish Sign Language', i: 'fse' },
  { n: 'French Sign Language', i: 'fsl' },
  { n: 'Finland-Swedish Sign Language', i: 'fss' },
  { n: 'Adamawa Fulfulde', i: 'fub' },
  { n: 'Pulaar', i: 'fuc' },
  { n: 'East Futuna', i: 'fud' },
  { n: 'Borgu Fulfulde', i: 'fue' },
  { n: 'Pular', i: 'fuf' },
  { n: 'Western Niger Fulfulde', i: 'fuh' },
  { n: 'Bagirmi Fulfulde', i: 'fui' },
  { n: 'Ko', i: 'fuj' },
  { n: 'Fum', i: 'fum' },
  { n: 'Fulniô', i: 'fun' },
  { n: 'Central-Eastern Niger Fulfulde', i: 'fuq' },
  { n: 'Friulian', i: 'fur' },
  { n: 'Futuna-Aniwa', i: 'fut' },
  { n: 'Furu', i: 'fuu' },
  { n: 'Nigerian Fulfulde', i: 'fuv' },
  { n: 'Fuyug', i: 'fuy' },
  { n: 'Fur', i: 'fvr' },
  { n: 'Fwâi', i: 'fwa' },
  { n: 'Fwe', i: 'fwe' },
  { n: 'Ga', i: 'gaa' },
  { n: 'Gabri', i: 'gab' },
  { n: 'Mixed Great Andamanese', i: 'gac' },
  { n: 'Gaddang', i: 'gad' },
  { n: 'Guarequena', i: 'gae' },
  { n: 'Gende', i: 'gaf' },
  { n: 'Gagauz', i: 'gag' },
  { n: 'Alekano', i: 'gah' },
  { n: 'Borei', i: 'gai' },
  { n: 'Gadsup', i: 'gaj' },
  { n: 'Gamkonora', i: 'gak' },
  { n: 'Galolen', i: 'gal' },
  { n: 'Kandawo', i: 'gam' },
  { n: 'Gan Chinese', i: 'gan' },
  { n: 'Gants', i: 'gao' },
  { n: 'Gal', i: 'gap' },
  { n: "Gata'", i: 'gaq' },
  { n: 'Galeya', i: 'gar' },
  { n: 'Adiwasi Garasia', i: 'gas' },
  { n: 'Kenati', i: 'gat' },
  { n: 'Mudhili Gadaba', i: 'gau' },
  { n: 'Nobonob', i: 'gaw' },
  { n: 'Borana-Arsi-Guji Oromo', i: 'gax' },
  { n: 'Gayo', i: 'gay' },
  { n: 'West Central Oromo', i: 'gaz' },
  { n: 'Kaytetye', i: 'gbb' },
  { n: 'Karajarri', i: 'gbd' },
  { n: 'Niksek', i: 'gbe' },
  { n: 'Gaikundi', i: 'gbf' },
  { n: 'Gbanziri', i: 'gbg' },
  { n: 'Defi Gbe', i: 'gbh' },
  { n: 'Galela', i: 'gbi' },
  { n: 'Bodo Gadaba', i: 'gbj' },
  { n: 'Gaddi', i: 'gbk' },
  { n: 'Gamit', i: 'gbl' },
  { n: 'Garhwali', i: 'gbm' },
  { n: "Mo'da", i: 'gbn' },
  { n: 'Northern Grebo', i: 'gbo' },
  { n: 'Gbaya-Bossangoa', i: 'gbp' },
  { n: 'Gbaya-Bozoum', i: 'gbq' },
  { n: 'Gbagyi', i: 'gbr' },
  { n: 'Gbesi Gbe', i: 'gbs' },
  { n: 'Gagadu', i: 'gbu' },
  { n: 'Gbanu', i: 'gbv' },
  { n: 'Gabi-Gabi', i: 'gbw' },
  { n: 'Eastern Xwla Gbe', i: 'gbx' },
  { n: 'Gbari', i: 'gby' },
  { n: 'Zoroastrian Dari', i: 'gbz' },
  { n: 'Mali', i: 'gcc' },
  { n: 'Guadeloupean Creole French', i: 'gcf' },
  { n: 'Grenadian Creole English', i: 'gcl' },
  { n: 'Gaina', i: 'gcn' },
  { n: 'Guianese Creole French', i: 'gcr' },
  { n: 'Colonia Tovar German', i: 'gct' },
  { n: 'Gade Lohar', i: 'gda' },
  { n: 'Pottangi Ollar Gadaba', i: 'gdb' },
  { n: 'Gedaged', i: 'gdd' },
  { n: 'Gude', i: 'gde' },
  { n: 'Guduf-Gava', i: 'gdf' },
  { n: "Ga'dang", i: 'gdg' },
  { n: 'Gadjerawang', i: 'gdh' },
  { n: 'Gundi', i: 'gdi' },
  { n: 'Gurdjar', i: 'gdj' },
  { n: 'Gadang', i: 'gdk' },
  { n: 'Dirasha', i: 'gdl' },
  { n: 'Laal', i: 'gdm' },
  { n: 'Umanakaina', i: 'gdn' },
  { n: 'Ghodoberi', i: 'gdo' },
  { n: 'Mehri', i: 'gdq' },
  { n: 'Wipi', i: 'gdr' },
  { n: 'Ghandruk Sign Language', i: 'gds' },
  { n: 'Gudu', i: 'gdu' },
  { n: 'Godwari', i: 'gdx' },
  { n: 'Geruma', i: 'gea' },
  { n: 'Kire', i: 'geb' },
  { n: 'Gboloo Grebo', i: 'gec' },
  { n: 'Gade', i: 'ged' },
  { n: 'Gerai', i: 'gef' },
  { n: 'Gengle', i: 'geg' },
  { n: 'Hutterite German', i: 'geh' },
  { n: 'Gebe', i: 'gei' },
  { n: 'Gen', i: 'gej' },
  { n: 'Ywom', i: 'gek' },
  { n: "ut-Ma'in", i: 'gel' },
  { n: 'Geme', i: 'geq' },
  { n: 'Geser-Gorom', i: 'ges' },
  { n: 'Eviya', i: 'gev' },
  { n: 'Gera', i: 'gew' },
  { n: 'Garre', i: 'gex' },
  { n: 'Enya', i: 'gey' },
  { n: 'Patpatar', i: 'gfk' },
  { n: 'Gao', i: 'gga' },
  { n: 'Gbii', i: 'ggb' },
  { n: 'Gurr-goni', i: 'gge' },
  { n: 'Gurgula', i: 'ggg' },
  { n: 'Ganglau', i: 'ggl' },
  { n: 'Gitua', i: 'ggt' },
  { n: 'Gagu', i: 'ggu' },
  { n: 'Gogodala', i: 'ggw' },
  { n: 'Ghadamès', i: 'gha' },
  { n: 'Southern Ghale', i: 'ghe' },
  { n: 'Northern Ghale', i: 'ghh' },
  { n: 'Geko Karen', i: 'ghk' },
  { n: 'Ghulfan', i: 'ghl' },
  { n: 'Ghanongga', i: 'ghn' },
  { n: 'Ghera', i: 'ghr' },
  { n: 'Guhu-Samane', i: 'ghs' },
  { n: 'Kuke', i: 'ght' },
  { n: 'Kija', i: 'gia' },
  { n: 'Gibanawa', i: 'gib' },
  { n: 'Gail', i: 'gic' },
  { n: 'Gidar', i: 'gid' },
  { n: 'Gaɓogbo', i: 'gie' },
  { n: 'Goaria', i: 'gig' },
  { n: 'Githabul', i: 'gih' },
  { n: 'Gilbertese', i: 'gil' },
  { n: 'Gimi (Eastern Highlands)', i: 'gim' },
  { n: 'Hinukh', i: 'gin' },
  { n: 'Gimi (West New Britain)', i: 'gip' },
  { n: 'Green Gelao', i: 'giq' },
  { n: 'Red Gelao', i: 'gir' },
  { n: 'North Giziga', i: 'gis' },
  { n: 'Gitxsan', i: 'git' },
  { n: 'Mulao', i: 'giu' },
  { n: 'White Gelao', i: 'giw' },
  { n: 'Gilima', i: 'gix' },
  { n: 'Giyug', i: 'giy' },
  { n: 'South Giziga', i: 'giz' },
  { n: 'Geji', i: 'gji' },
  { n: 'Kachi Koli', i: 'gjk' },
  { n: 'Gonja', i: 'gjn' },
  { n: 'Gurindji Kriol', i: 'gjr' },
  { n: 'Gujari', i: 'gju' },
  { n: 'Guya', i: 'gka' },
  { n: 'Magɨ (Madang Province)', i: 'gkd' },
  { n: 'Ndai', i: 'gke' },
  { n: 'Gokana', i: 'gkn' },
  { n: 'Guinea Kpelle', i: 'gkp' },
  { n: 'Scottish Gaelic', i: 'gla' },
  { n: 'Bon Gula', i: 'glc' },
  { n: 'Nanai', i: 'gld' },
  { n: 'Irish', i: 'gle' },
  { n: 'Galician', i: 'glg' },
  { n: 'Northwest Pashai', i: 'glh' },
  { n: 'Gula Iro', i: 'glj' },
  { n: 'Gilaki', i: 'glk' },
  { n: 'Galambu', i: 'glo' },
  { n: 'Glaro-Twabo', i: 'glr' },
  { n: 'Gula (Chad)', i: 'glu' },
  { n: 'Manx', i: 'glv' },
  { n: 'Glavda', i: 'glw' },
  { n: "Gula'alaa", i: 'gmb' },
  { n: 'Mághdì', i: 'gmd' },
  { n: 'Magɨyi', i: 'gmg' },
  { n: 'Gbaya-Mbodomo', i: 'gmm' },
  { n: 'Gimnime', i: 'gmn' },
  { n: 'Mirning', i: 'gmr' },
  { n: 'Gumalu', i: 'gmu' },
  { n: 'Gamo', i: 'gmv' },
  { n: 'Magoma', i: 'gmx' },
  { n: 'Mgbolizhia', i: 'gmz' },
  { n: 'Kaansa', i: 'gna' },
  { n: 'Gangte', i: 'gnb' },
  { n: 'Zulgo-Gemzek', i: 'gnd' },
  { n: 'Ganang', i: 'gne' },
  { n: 'Ngangam', i: 'gng' },
  { n: 'Lere', i: 'gnh' },
  { n: 'Gooniyandi', i: 'gni' },
  { n: 'Ngen', i: 'gnj' },
  { n: 'ǁGana', i: 'gnk' },
  { n: 'Ginuman', i: 'gnm' },
  { n: 'Gumatj', i: 'gnn' },
  { n: 'Northern Gondi', i: 'gno' },
  { n: 'Gana', i: 'gnq' },
  { n: 'Guntai', i: 'gnt' },
  { n: 'Gnau', i: 'gnu' },
  { n: 'Western Bolivian Guaraní', i: 'gnw' },
  { n: 'Ganzi', i: 'gnz' },
  { n: 'Guro', i: 'goa' },
  { n: 'Playero', i: 'gob' },
  { n: 'Gorakor', i: 'goc' },
  { n: 'Godié', i: 'god' },
  { n: 'Gongduk', i: 'goe' },
  { n: 'Gofa', i: 'gof' },
  { n: 'Gogo', i: 'gog' },
  { n: 'Gobasi', i: 'goi' },
  { n: 'Gowlan', i: 'goj' },
  { n: 'Gowli', i: 'gok' },
  { n: 'Gola', i: 'gol' },
  { n: 'Goan Konkani', i: 'gom' },
  { n: 'Gone Dau', i: 'goo' },
  { n: 'Yeretuar', i: 'gop' },
  { n: 'Gorap', i: 'goq' },
  { n: 'Gorontalo', i: 'gor' },
  { n: 'Gronings', i: 'gos' },
  { n: 'Gavar', i: 'gou' },
  { n: 'Gorowa', i: 'gow' },
  { n: 'Gobu', i: 'gox' },
  { n: 'Goundo', i: 'goy' },
  { n: 'Gozarkhani', i: 'goz' },
  { n: 'Gupa-Abawa', i: 'gpa' },
  { n: 'Ghanaian Pidgin English', i: 'gpe' },
  { n: 'Taiap', i: 'gpn' },
  { n: "Ga'anda", i: 'gqa' },
  { n: 'Guiqiong', i: 'gqi' },
  { n: 'Gor', i: 'gqr' },
  { n: 'Qau', i: 'gqu' },
  { n: 'Rajput Garasia', i: 'gra' },
  { n: 'Guruntum-Mbaaru', i: 'grd' },
  { n: 'Madi', i: 'grg' },
  { n: 'Gbiri-Niragu', i: 'grh' },
  { n: 'Ghari', i: 'gri' },
  { n: 'Southern Grebo', i: 'grj' },
  { n: 'Kota Marudu Talantang', i: 'grm' },
  { n: 'Groma', i: 'gro' },
  { n: 'Gorovu', i: 'grq' },
  { n: 'Taznatit', i: 'grr' },
  { n: 'Gresi', i: 'grs' },
  { n: 'Garo', i: 'grt' },
  { n: 'Kistane', i: 'gru' },
  { n: 'Central Grebo', i: 'grv' },
  { n: 'Gweda', i: 'grw' },
  { n: 'Guriaso', i: 'grx' },
  { n: 'Barclayville Grebo', i: 'gry' },
  { n: 'Guramalum', i: 'grz' },
  { n: 'Ghanaian Sign Language', i: 'gse' },
  { n: 'German Sign Language', i: 'gsg' },
  { n: 'Gusilay', i: 'gsl' },
  { n: 'Guatemalan Sign Language', i: 'gsm' },
  { n: 'Nema', i: 'gsn' },
  { n: 'Southwest Gbaya', i: 'gso' },
  { n: 'Wasembo', i: 'gsp' },
  { n: 'Greek Sign Language', i: 'gss' },
  { n: 'Swiss German', i: 'gsw' },
  { n: 'Guató', i: 'gta' },
  { n: 'Shiki', i: 'gua' },
  { n: 'Guajajára', i: 'gub' },
  { n: 'Wayuu', i: 'guc' },
  { n: 'Yocoboué Dida', i: 'gud' },
  { n: 'Gurindji', i: 'gue' },
  { n: 'Gupapuyngu', i: 'guf' },
  { n: 'Paraguayan Guaraní', i: 'gug' },
  { n: 'Guahibo', i: 'guh' },
  { n: 'Eastern Bolivian Guaraní', i: 'gui' },
  { n: 'Gujarati', i: 'guj' },
  { n: 'Gumuz', i: 'guk' },
  { n: 'Sea Island Creole English', i: 'gul' },
  { n: 'Guambiano', i: 'gum' },
  { n: 'Mbyá Guaraní', i: 'gun' },
  { n: 'Guayabero', i: 'guo' },
  { n: 'Gunwinggu', i: 'gup' },
  { n: 'Aché', i: 'guq' },
  { n: 'Farefare', i: 'gur' },
  { n: 'Guinean Sign Language', i: 'gus' },
  { n: 'Maléku Jaíka', i: 'gut' },
  { n: 'Yanomamö', i: 'guu' },
  { n: 'Gun', i: 'guw' },
  { n: 'Gourmanchéma', i: 'gux' },
  { n: 'Gusii', i: 'guz' },
  { n: 'Guana (Paraguay)', i: 'gva' },
  { n: 'Guanano', i: 'gvc' },
  { n: 'Duwet', i: 'gve' },
  { n: 'Golin', i: 'gvf' },
  { n: 'Guajá', i: 'gvj' },
  { n: 'Gulay', i: 'gvl' },
  { n: 'Gurmana', i: 'gvm' },
  { n: 'Kuku-Yalanji', i: 'gvn' },
  { n: 'Gavião Do Jiparaná', i: 'gvo' },
  { n: 'Pará Gavião', i: 'gvp' },
  { n: 'Gurung', i: 'gvr' },
  { n: 'Gumawana', i: 'gvs' },
  { n: 'Mbato', i: 'gwa' },
  { n: 'Gwa', i: 'gwb' },
  { n: 'Gawri', i: 'gwc' },
  { n: 'Gawwada', i: 'gwd' },
  { n: 'Gweno', i: 'gwe' },
  { n: 'Gowro', i: 'gwf' },
  { n: 'Moo', i: 'gwg' },
  { n: 'Gwichʼin', i: 'gwi' },
  { n: 'ǀGwi', i: 'gwj' },
  { n: 'Gwandara', i: 'gwn' },
  { n: 'Gwere', i: 'gwr' },
  { n: 'Gawar-Bati', i: 'gwt' },
  { n: 'Kwini', i: 'gww' },
  { n: 'Gua', i: 'gwx' },
  { n: 'Wè Southern', i: 'gxx' },
  { n: 'Northwest Gbaya', i: 'gya' },
  { n: 'Garus', i: 'gyb' },
  { n: 'Kayardild', i: 'gyd' },
  { n: 'Gyem', i: 'gye' },
  { n: 'Gbayi', i: 'gyg' },
  { n: 'Gyele', i: 'gyi' },
  { n: 'Gayil', i: 'gyl' },
  { n: 'Ngäbere', i: 'gym' },
  { n: 'Guyanese Creole English', i: 'gyn' },
  { n: 'Gyalsumdo', i: 'gyo' },
  { n: 'Guarayu', i: 'gyr' },
  { n: 'Ganza', i: 'gza' },
  { n: 'Gazi', i: 'gzi' },
  { n: 'Gane', i: 'gzn' },
  { n: 'Han', i: 'haa' },
  { n: 'Hanoi Sign Language', i: 'hab' },
  { n: 'Gurani', i: 'hac' },
  { n: 'Hatam', i: 'had' },
  { n: 'Eastern Oromo', i: 'hae' },
  { n: 'Haiphong Sign Language', i: 'haf' },
  { n: 'Hanga', i: 'hag' },
  { n: 'Hahon', i: 'hah' },
  { n: 'Hajong', i: 'haj' },
  { n: 'Hakka Chinese', i: 'hak' },
  { n: 'Halang', i: 'hal' },
  { n: 'Hewa', i: 'ham' },
  { n: 'Hangaza', i: 'han' },
  { n: 'Hakö', i: 'hao' },
  { n: 'Hupla', i: 'hap' },
  { n: 'Ha', i: 'haq' },
  { n: 'Harari', i: 'har' },
  { n: 'Haisla', i: 'has' },
  { n: 'Haitian', i: 'hat' },
  { n: 'Hausa', i: 'hau' },
  { n: 'Havu', i: 'hav' },
  { n: 'Hawaiian', i: 'haw' },
  { n: 'Southern Haida', i: 'hax' },
  { n: 'Haya', i: 'hay' },
  { n: 'Hazaragi', i: 'haz' },
  { n: 'Hamba', i: 'hba' },
  { n: 'Huba', i: 'hbb' },
  { n: 'Heiban', i: 'hbn' },
  { n: 'Habu', i: 'hbu' },
  { n: 'Andaman Creole Hindi', i: 'hca' },
  { n: 'Huichol', i: 'hch' },
  { n: 'Northern Haida', i: 'hdn' },
  { n: 'Honduras Sign Language', i: 'hds' },
  { n: 'Hadiyya', i: 'hdy' },
  { n: 'Northern Qiandong Miao', i: 'hea' },
  { n: 'Hebrew', i: 'heb' },
  { n: 'Herdé', i: 'hed' },
  { n: 'Helong', i: 'heg' },
  { n: 'Hehe', i: 'heh' },
  { n: 'Heiltsuk', i: 'hei' },
  { n: 'Hemba', i: 'hem' },
  { n: 'Herero', i: 'her' },
  { n: 'Haiǁom', i: 'hgm' },
  { n: 'Haigwai', i: 'hgw' },
  { n: 'Hoia Hoia', i: 'hhi' },
  { n: 'Kerak', i: 'hhr' },
  { n: 'Hoyahoya', i: 'hhy' },
  { n: 'Lamang', i: 'hia' },
  { n: 'Hidatsa', i: 'hid' },
  { n: 'Fiji Hindi', i: 'hif' },
  { n: 'Kamwe', i: 'hig' },
  { n: 'Pamosu', i: 'hih' },
  { n: 'Hinduri', i: 'hii' },
  { n: 'Hijuk', i: 'hij' },
  { n: 'Seit-Kaitetu', i: 'hik' },
  { n: 'Hiligaynon', i: 'hil' },
  { n: 'Hindi', i: 'hin' },
  { n: 'Tsoa', i: 'hio' },
  { n: 'Himarimã', i: 'hir' },
  { n: 'Hiw', i: 'hiw' },
  { n: 'Hixkaryána', i: 'hix' },
  { n: 'Haji', i: 'hji' },
  { n: 'Kahe', i: 'hka' },
  { n: 'Hunde', i: 'hke' },
  { n: 'Hunjara-Kaina Ke', i: 'hkk' },
  { n: 'Mel-Khaonh', i: 'hkn' },
  { n: 'Hong Kong Sign Language', i: 'hks' },
  { n: 'Halia', i: 'hla' },
  { n: 'Halbi', i: 'hlb' },
  { n: 'Halang Doan', i: 'hld' },
  { n: 'Hlersu', i: 'hle' },
  { n: 'Matu Chin', i: 'hlt' },
  { n: 'Southern Mashan Hmong', i: 'hma' },
  { n: 'Humburi Senni Songhay', i: 'hmb' },
  { n: 'Central Huishui Hmong', i: 'hmc' },
  { n: 'Large Flowery Miao', i: 'hmd' },
  { n: 'Eastern Huishui Hmong', i: 'hme' },
  { n: 'Hmong Don', i: 'hmf' },
  { n: 'Southwestern Guiyang Hmong', i: 'hmg' },
  { n: 'Southwestern Huishui Hmong', i: 'hmh' },
  { n: 'Northern Huishui Hmong', i: 'hmi' },
  { n: 'Ge', i: 'hmj' },
  { n: 'Luopohe Hmong', i: 'hml' },
  { n: 'Central Mashan Hmong', i: 'hmm' },
  { n: 'Hiri Motu', i: 'hmo' },
  { n: 'Northern Mashan Hmong', i: 'hmp' },
  { n: 'Eastern Qiandong Miao', i: 'hmq' },
  { n: 'Hmar', i: 'hmr' },
  { n: 'Southern Qiandong Miao', i: 'hms' },
  { n: 'Hamtai', i: 'hmt' },
  { n: 'Hamap', i: 'hmu' },
  { n: 'Hmong Dô', i: 'hmv' },
  { n: 'Western Mashan Hmong', i: 'hmw' },
  { n: 'Southern Guiyang Hmong', i: 'hmy' },
  { n: 'Hmong Shua', i: 'hmz' },
  { n: 'Mina (Cameroon)', i: 'hna' },
  { n: 'Southern Hindko', i: 'hnd' },
  { n: 'Chhattisgarhi', i: 'hne' },
  { n: 'Hungu', i: 'hng' },
  { n: 'ǁAni', i: 'hnh' },
  { n: 'Hani', i: 'hni' },
  { n: 'Hmong Njua', i: 'hnj' },
  { n: 'Hanunoo', i: 'hnn' },
  { n: 'Northern Hindko', i: 'hno' },
  { n: 'Caribbean Hindustani', i: 'hns' },
  { n: 'Hung', i: 'hnu' },
  { n: 'Hoava', i: 'hoa' },
  { n: 'Mari (Madang Province)', i: 'hob' },
  { n: 'Ho', i: 'hoc' },
  { n: 'Horom', i: 'hoe' },
  { n: 'Hobyót', i: 'hoh' },
  { n: 'Holikachuk', i: 'hoi' },
  { n: 'Hadothi', i: 'hoj' },
  { n: 'Holu', i: 'hol' },
  { n: 'Holoholo', i: 'hoo' },
  { n: 'Hopi', i: 'hop' },
  { n: 'Ho Chi Minh City Sign Language', i: 'hos' },
  { n: 'Hote', i: 'hot' },
  { n: 'Hovongan', i: 'hov' },
  { n: 'Honi', i: 'how' },
  { n: 'Holiya', i: 'hoy' },
  { n: 'Hozo', i: 'hoz' },
  { n: "Hawai'i Sign Language (HSL)", i: 'hps' },
  { n: 'Hrangkhol', i: 'hra' },
  { n: 'Niwer Mil', i: 'hrc' },
  { n: 'Hre', i: 'hre' },
  { n: 'Haruku', i: 'hrk' },
  { n: 'Horned Miao', i: 'hrm' },
  { n: 'Haroi', i: 'hro' },
  { n: 'Hértevin', i: 'hrt' },
  { n: 'Hruso', i: 'hru' },
  { n: 'Croatian', i: 'hrv' },
  { n: 'Warwar Feni', i: 'hrw' },
  { n: 'Hunsrik', i: 'hrx' },
  { n: 'Harzani', i: 'hrz' },
  { n: 'Upper Sorbian', i: 'hsb' },
  { n: 'Hungarian Sign Language', i: 'hsh' },
  { n: 'Hausa Sign Language', i: 'hsl' },
  { n: 'Xiang Chinese', i: 'hsn' },
  { n: 'Harsusi', i: 'hss' },
  { n: 'Minica Huitoto', i: 'hto' },
  { n: 'Hadza', i: 'hts' },
  { n: 'Hitu', i: 'htu' },
  { n: 'Huambisa', i: 'hub' },
  { n: 'ǂHua', i: 'huc' },
  { n: 'Huaulu', i: 'hud' },
  { n: 'San Francisco Del Mar Huave', i: 'hue' },
  { n: 'Humene', i: 'huf' },
  { n: 'Huachipaeri', i: 'hug' },
  { n: 'Huilliche', i: 'huh' },
  { n: 'Huli', i: 'hui' },
  { n: 'Northern Guiyang Hmong', i: 'huj' },
  { n: 'Hula', i: 'hul' },
  { n: 'Hungana', i: 'hum' },
  { n: 'Hungarian', i: 'hun' },
  { n: 'Hu', i: 'huo' },
  { n: 'Hupa', i: 'hup' },
  { n: 'Tsat', i: 'huq' },
  { n: 'Halkomelem', i: 'hur' },
  { n: 'Huastec', i: 'hus' },
  { n: 'Humla', i: 'hut' },
  { n: 'Murui Huitoto', i: 'huu' },
  { n: 'San Mateo Del Mar Huave', i: 'huv' },
  { n: 'Nüpode Huitoto', i: 'hux' },
  { n: 'Hulaulá', i: 'huy' },
  { n: 'Hunzib', i: 'huz' },
  { n: 'Haitian Vodoun Culture Language', i: 'hvc' },
  { n: 'San Dionisio Del Mar Huave', i: 'hve' },
  { n: 'Haveke', i: 'hvk' },
  { n: 'Sabu', i: 'hvn' },
  { n: 'Santa María Del Mar Huave', i: 'hvv' },
  { n: 'Wané', i: 'hwa' },
  { n: "Hawai'i Creole English", i: 'hwc' },
  { n: 'Hwana', i: 'hwo' },
  { n: 'Hya', i: 'hya' },
  { n: 'Armenian', i: 'hye' },
  { n: 'Western Armenian', i: 'hyw' },
  { n: 'Iaai', i: 'iai' },
  { n: 'Iatmul', i: 'ian' },
  { n: 'Purari', i: 'iar' },
  { n: 'Iban', i: 'iba' },
  { n: 'Ibibio', i: 'ibb' },
  { n: 'Iwaidja', i: 'ibd' },
  { n: 'Akpes', i: 'ibe' },
  { n: 'Ibanag', i: 'ibg' },
  { n: 'Bih', i: 'ibh' },
  { n: 'Ibaloi', i: 'ibl' },
  { n: 'Agoi', i: 'ibm' },
  { n: 'Ibino', i: 'ibn' },
  { n: 'Igbo', i: 'ibo' },
  { n: 'Ibuoro', i: 'ibr' },
  { n: 'Ibu', i: 'ibu' },
  { n: 'Ibani', i: 'iby' },
  { n: 'Ede Ica', i: 'ica' },
  { n: 'Etkywan', i: 'ich' },
  { n: 'Icelandic Sign Language', i: 'icl' },
  { n: 'Islander Creole English', i: 'icr' },
  { n: 'Idakho-Isukha-Tiriki', i: 'ida' },
  { n: 'Indo-Portuguese', i: 'idb' },
  { n: 'Idon', i: 'idc' },
  { n: 'Ede Idaca', i: 'idd' },
  { n: 'Idere', i: 'ide' },
  { n: 'Idi', i: 'idi' },
  { n: 'Indri', i: 'idr' },
  { n: 'Idesa', i: 'ids' },
  { n: 'Idaté', i: 'idt' },
  { n: 'Idoma', i: 'idu' },
  { n: 'Amganad Ifugao', i: 'ifa' },
  { n: 'Batad Ifugao', i: 'ifb' },
  { n: 'Ifè', i: 'ife' },
  { n: 'Tuwali Ifugao', i: 'ifk' },
  { n: 'Teke-Fuumu', i: 'ifm' },
  { n: 'Mayoyao Ifugao', i: 'ifu' },
  { n: 'Keley-I Kallahan', i: 'ify' },
  { n: 'Ebira', i: 'igb' },
  { n: 'Igede', i: 'ige' },
  { n: 'Igana', i: 'igg' },
  { n: 'Igala', i: 'igl' },
  { n: 'Kanggape', i: 'igm' },
  { n: 'Ignaciano', i: 'ign' },
  { n: 'Isebe', i: 'igo' },
  { n: 'Igwe', i: 'igw' },
  { n: 'Iha Based Pidgin', i: 'ihb' },
  { n: 'Ihievbe', i: 'ihi' },
  { n: 'Iha', i: 'ihp' },
  { n: 'Sichuan Yi', i: 'iii' },
  { n: 'Izon', i: 'ijc' },
  { n: 'Biseni', i: 'ije' },
  { n: 'Ede Ije', i: 'ijj' },
  { n: 'Kalabari', i: 'ijn' },
  { n: 'Southeast Ijo', i: 'ijs' },
  { n: 'Eastern Canadian Inuktitut', i: 'ike' },
  { n: 'Iko', i: 'iki' },
  { n: 'Ika', i: 'ikk' },
  { n: 'Ikulu', i: 'ikl' },
  { n: 'Olulumo-Ikom', i: 'iko' },
  { n: 'Ikpeshi', i: 'ikp' },
  { n: 'Inuit Sign Language', i: 'iks' },
  { n: 'Inuinnaqtun', i: 'ikt' },
  { n: 'Iku-Gora-Ankwa', i: 'ikv' },
  { n: 'Ikwere', i: 'ikw' },
  { n: 'Ik', i: 'ikx' },
  { n: 'Ikizu', i: 'ikz' },
  { n: 'Ile Ape', i: 'ila' },
  { n: 'Ila', i: 'ilb' },
  { n: 'Ili Turki', i: 'ili' },
  { n: 'Ilongot', i: 'ilk' },
  { n: 'Iranun (Malaysia)', i: 'ilm' },
  { n: 'Iloko', i: 'ilo' },
  { n: 'Iranun (Philippines)', i: 'ilp' },
  { n: 'International Sign', i: 'ils' },
  { n: "Ili'uun", i: 'ilu' },
  { n: 'Ilue', i: 'ilv' },
  { n: 'Mala Malasar', i: 'ima' },
  { n: 'Anamgura', i: 'imi' },
  { n: 'Imonda', i: 'imn' },
  { n: 'Imbongu', i: 'imo' },
  { n: 'Imroing', i: 'imr' },
  { n: 'Inga', i: 'inb' },
  { n: 'Indonesian', i: 'ind' },
  { n: "Degexit'an", i: 'ing' },
  { n: 'Ingush', i: 'inh' },
  { n: 'Jungle Inga', i: 'inj' },
  { n: 'Indonesian Sign Language', i: 'inl' },
  { n: 'Isinai', i: 'inn' },
  { n: 'Inoke-Yate', i: 'ino' },
  { n: 'Iñapari', i: 'inp' },
  { n: 'Indian Sign Language', i: 'ins' },
  { n: 'Intha', i: 'int' },
  { n: 'Inor', i: 'ior' },
  { n: 'Tuma-Irumu', i: 'iou' },
  { n: 'Ipili', i: 'ipi' },
  { n: 'Ipiko', i: 'ipo' },
  { n: 'Iquito', i: 'iqu' },
  { n: 'Ikwo', i: 'iqw' },
  { n: 'Iresim', i: 'ire' },
  { n: 'Irarutu', i: 'irh' },
  { n: 'Rigwe', i: 'iri' },
  { n: 'Iraqw', i: 'irk' },
  { n: 'Irántxe', i: 'irn' },
  { n: 'Ir', i: 'irr' },
  { n: 'Irula', i: 'iru' },
  { n: 'Kamberau', i: 'irx' },
  { n: 'Iraya', i: 'iry' },
  { n: 'Isabi', i: 'isa' },
  { n: 'Isconahua', i: 'isc' },
  { n: 'Isnag', i: 'isd' },
  { n: 'Italian Sign Language', i: 'ise' },
  { n: 'Irish Sign Language', i: 'isg' },
  { n: 'Esan', i: 'ish' },
  { n: 'Nkem-Nkum', i: 'isi' },
  { n: 'Ishkashimi', i: 'isk' },
  { n: 'Icelandic', i: 'isl' },
  { n: 'Masimasi', i: 'ism' },
  { n: 'Isanzu', i: 'isn' },
  { n: 'Isoko', i: 'iso' },
  { n: 'Israeli Sign Language', i: 'isr' },
  { n: 'Istriot', i: 'ist' },
  { n: 'Isu (Menchum Division)', i: 'isu' },
  { n: 'Italian', i: 'ita' },
  { n: 'Binongan Itneg', i: 'itb' },
  { n: 'Southern Tidung', i: 'itd' },
  { n: 'Inlaod Itneg', i: 'iti' },
  { n: 'Judeo-Italian', i: 'itk' },
  { n: 'Itelmen', i: 'itl' },
  { n: 'Itu Mbon Uzo', i: 'itm' },
  { n: 'Itonama', i: 'ito' },
  { n: 'Iteri', i: 'itr' },
  { n: 'Isekiri', i: 'its' },
  { n: 'Maeng Itneg', i: 'itt' },
  { n: 'Itawit', i: 'itv' },
  { n: 'Ito', i: 'itw' },
  { n: 'Itik', i: 'itx' },
  { n: 'Moyadan Itneg', i: 'ity' },
  { n: 'Itzá', i: 'itz' },
  { n: 'Iu Mien', i: 'ium' },
  { n: 'Ibatan', i: 'ivb' },
  { n: 'Ivatan', i: 'ivv' },
  { n: 'I-Wak', i: 'iwk' },
  { n: 'Iwam', i: 'iwm' },
  { n: 'Iwur', i: 'iwo' },
  { n: 'Sepik Iwam', i: 'iws' },
  { n: 'Ixcatec', i: 'ixc' },
  { n: 'Ixil', i: 'ixl' },
  { n: 'Iyayu', i: 'iya' },
  { n: 'Mesaka', i: 'iyo' },
  { n: 'Yaka (Congo)', i: 'iyx' },
  { n: 'Ingrian', i: 'izh' },
  { n: 'Izere', i: 'izr' },
  { n: 'Izii', i: 'izz' },
  { n: 'Jamamadí', i: 'jaa' },
  { n: 'Hyam', i: 'jab' },
  { n: "Popti'", i: 'jac' },
  { n: 'Jahanka', i: 'jad' },
  { n: 'Yabem', i: 'jae' },
  { n: 'Jara', i: 'jaf' },
  { n: 'Jah Hut', i: 'jah' },
  { n: 'Zazao', i: 'jaj' },
  { n: 'Jakun', i: 'jak' },
  { n: 'Yalahatan', i: 'jal' },
  { n: 'Jamaican Creole English', i: 'jam' },
  { n: 'Yanyuwa', i: 'jao' },
  { n: 'Yaqay', i: 'jaq' },
  { n: 'New Caledonian Javanese', i: 'jas' },
  { n: 'Jakati', i: 'jat' },
  { n: 'Yaur', i: 'jau' },
  { n: 'Javanese', i: 'jav' },
  { n: 'Jambi Malay', i: 'jax' },
  { n: 'Yan-nhangu', i: 'jay' },
  { n: 'Jawe', i: 'jaz' },
  { n: 'Judeo-Berber', i: 'jbe' },
  { n: 'Arandai', i: 'jbj' },
  { n: 'Barikewa', i: 'jbk' },
  { n: 'Nafusi', i: 'jbn' },
  { n: 'Jofotek-Bromnya', i: 'jbr' },
  { n: 'Jabutí', i: 'jbt' },
  { n: 'Jukun Takum', i: 'jbu' },
  { n: 'Jamaican Country Sign Language', i: 'jcs' },
  { n: 'Krymchak', i: 'jct' },
  { n: 'Jad', i: 'jda' },
  { n: 'Jadgali', i: 'jdg' },
  { n: 'Judeo-Tat', i: 'jdt' },
  { n: 'Jebero', i: 'jeb' },
  { n: 'Jerung', i: 'jee' },
  { n: 'Jeh', i: 'jeh' },
  { n: 'Yei', i: 'jei' },
  { n: 'Jeri Kuo', i: 'jek' },
  { n: 'Yelmek', i: 'jel' },
  { n: 'Dza', i: 'jen' },
  { n: 'Jere', i: 'jer' },
  { n: 'Manem', i: 'jet' },
  { n: 'Jonkor Bourmataguil', i: 'jeu' },
  { n: 'Judeo-Georgian', i: 'jge' },
  { n: 'Gwak', i: 'jgk' },
  { n: 'Ngomba', i: 'jgo' },
  { n: 'Jehai', i: 'jhi' },
  { n: 'Jhankot Sign Language', i: 'jhs' },
  { n: 'Jina', i: 'jia' },
  { n: 'Jibu', i: 'jib' },
  { n: 'Tol', i: 'jic' },
  { n: 'Bu', i: 'jid' },
  { n: 'Jilbe', i: 'jie' },
  { n: 'Jingulu', i: 'jig' },
  { n: 'sTodsde', i: 'jih' },
  { n: 'Jiiddu', i: 'jii' },
  { n: 'Jilim', i: 'jil' },
  { n: 'Jimi (Cameroon)', i: 'jim' },
  { n: 'Jiamao', i: 'jio' },
  { n: 'Guanyinqiao', i: 'jiq' },
  { n: 'Jita', i: 'jit' },
  { n: 'Youle Jinuo', i: 'jiu' },
  { n: 'Shuar', i: 'jiv' },
  { n: 'Buyuan Jinuo', i: 'jiy' },
  { n: 'Jejueo', i: 'jje' },
  { n: 'Bankal', i: 'jjr' },
  { n: 'Kaera', i: 'jka' },
  { n: 'Mobwa Karen', i: 'jkm' },
  { n: 'Kubo', i: 'jko' },
  { n: 'Paku Karen', i: 'jkp' },
  { n: 'Koro (India)', i: 'jkr' },
  { n: 'Labir', i: 'jku' },
  { n: 'Ngile', i: 'jle' },
  { n: 'Jamaican Sign Language', i: 'jls' },
  { n: 'Dima', i: 'jma' },
  { n: 'Zumbun', i: 'jmb' },
  { n: 'Machame', i: 'jmc' },
  { n: 'Yamdena', i: 'jmd' },
  { n: 'Jimi (Nigeria)', i: 'jmi' },
  { n: 'Jumli', i: 'jml' },
  { n: 'Makuri Naga', i: 'jmn' },
  { n: 'Kamara', i: 'jmr' },
  { n: 'Mashi (Nigeria)', i: 'jms' },
  { n: 'Mouwase', i: 'jmw' },
  { n: 'Western Juxtlahuaca Mixtec', i: 'jmx' },
  { n: 'Jangshung', i: 'jna' },
  { n: 'Jandavra', i: 'jnd' },
  { n: 'Janji', i: 'jni' },
  { n: 'Yemsa', i: 'jnj' },
  { n: 'Rawat', i: 'jnl' },
  { n: 'Jaunsari', i: 'jns' },
  { n: 'Joba', i: 'job' },
  { n: 'Wojenaka', i: 'jod' },
  { n: 'Jogi', i: 'jog' },
  { n: 'Jordanian Sign Language', i: 'jos' },
  { n: 'Jowulu', i: 'jow' },
  { n: 'Japanese', i: 'jpn' },
  { n: 'Judeo-Persian', i: 'jpr' },
  { n: 'Jaqaru', i: 'jqr' },
  { n: 'Jarai', i: 'jra' },
  { n: 'Jiru', i: 'jrr' },
  { n: 'Jorto', i: 'jrt' },
  { n: 'Japrería', i: 'jru' },
  { n: 'Japanese Sign Language', i: 'jsl' },
  { n: 'Júma', i: 'jua' },
  { n: 'Wannu', i: 'jub' },
  { n: 'Worodougou', i: 'jud' },
  { n: 'Hõne', i: 'juh' },
  { n: 'Wapan', i: 'juk' },
  { n: 'Jirel', i: 'jul' },
  { n: 'Jumjum', i: 'jum' },
  { n: 'Juang', i: 'jun' },
  { n: 'Jiba', i: 'juo' },
  { n: 'Hupdë', i: 'jup' },
  { n: 'Jurúna', i: 'jur' },
  { n: 'Jumla Sign Language', i: 'jus' },
  { n: 'Ju', i: 'juu' },
  { n: 'Wãpha', i: 'juw' },
  { n: 'Juray', i: 'juy' },
  { n: 'Javindo', i: 'jvd' },
  { n: 'Caribbean Javanese', i: 'jvn' },
  { n: 'Jwira-Pepesa', i: 'jwi' },
  { n: 'Jiarong', i: 'jya' },
  { n: 'Judeo-Yemeni Arabic', i: 'jye' },
  { n: 'Jaya', i: 'jyy' },
  { n: 'Kara-Kalpak', i: 'kaa' },
  { n: 'Kabyle', i: 'kab' },
  { n: 'Kachin', i: 'kac' },
  { n: 'Adara', i: 'kad' },
  { n: 'Katso', i: 'kaf' },
  { n: 'Kajaman', i: 'kag' },
  { n: 'Kara (Central African Republic)', i: 'kah' },
  { n: 'Karekare', i: 'kai' },
  { n: 'Jju', i: 'kaj' },
  { n: 'Kalanguya', i: 'kak' },
  { n: 'Kalaallisut', i: 'kal' },
  { n: 'Kamba (Kenya)', i: 'kam' },
  { n: 'Kannada', i: 'kan' },
  { n: 'Xaasongaxango', i: 'kao' },
  { n: 'Bezhta', i: 'kap' },
  { n: 'Capanahua', i: 'kaq' },
  { n: 'Kashmiri', i: 'kas' },
  { n: 'Georgian', i: 'kat' },
  { n: 'Katukína', i: 'kav' },
  { n: 'Kao', i: 'kax' },
  { n: 'Kamayurá', i: 'kay' },
  { n: 'Kazakh', i: 'kaz' },
  { n: 'Kadiwéu', i: 'kbc' },
  { n: 'Kabardian', i: 'kbd' },
  { n: 'Kanju', i: 'kbe' },
  { n: 'Khamba', i: 'kbg' },
  { n: 'Camsá', i: 'kbh' },
  { n: 'Kaptiau', i: 'kbi' },
  { n: 'Kari', i: 'kbj' },
  { n: 'Grass Koiari', i: 'kbk' },
  { n: 'Kanembu', i: 'kbl' },
  { n: 'Iwal', i: 'kbm' },
  { n: 'Kare (Central African Republic)', i: 'kbn' },
  { n: 'Keliko', i: 'kbo' },
  { n: 'Kabiyè', i: 'kbp' },
  { n: 'Kamano', i: 'kbq' },
  { n: 'Kafa', i: 'kbr' },
  { n: 'Kande', i: 'kbs' },
  { n: 'Abadi', i: 'kbt' },
  { n: 'Kabutra', i: 'kbu' },
  { n: 'Dera (Indonesia)', i: 'kbv' },
  { n: 'Kaiep', i: 'kbw' },
  { n: 'Ap Ma', i: 'kbx' },
  { n: 'Manga Kanuri', i: 'kby' },
  { n: 'Duhwa', i: 'kbz' },
  { n: 'Khanty', i: 'kca' },
  { n: 'Kawacha', i: 'kcb' },
  { n: 'Lubila', i: 'kcc' },
  { n: 'Ngkâlmpw Kanum', i: 'kcd' },
  { n: 'Kaivi', i: 'kce' },
  { n: 'Ukaan', i: 'kcf' },
  { n: 'Tyap', i: 'kcg' },
  { n: 'Vono', i: 'kch' },
  { n: 'Kamantan', i: 'kci' },
  { n: 'Kobiana', i: 'kcj' },
  { n: 'Kalanga', i: 'kck' },
  { n: 'Kela (Papua New Guinea)', i: 'kcl' },
  { n: 'Gula (Central African Republic)', i: 'kcm' },
  { n: 'Nubi', i: 'kcn' },
  { n: 'Kinalakna', i: 'kco' },
  { n: 'Kanga', i: 'kcp' },
  { n: 'Kamo', i: 'kcq' },
  { n: 'Katla', i: 'kcr' },
  { n: 'Koenoem', i: 'kcs' },
  { n: 'Kaian', i: 'kct' },
  { n: 'Kami (Tanzania)', i: 'kcu' },
  { n: 'Kete', i: 'kcv' },
  { n: 'Kabwari', i: 'kcw' },
  { n: 'Kachama-Ganjule', i: 'kcx' },
  { n: 'Korandje', i: 'kcy' },
  { n: 'Konongo', i: 'kcz' },
  { n: 'Kutu', i: 'kdc' },
  { n: 'Yankunytjatjara', i: 'kdd' },
  { n: 'Makonde', i: 'kde' },
  { n: 'Mamusi', i: 'kdf' },
  { n: 'Seba', i: 'kdg' },
  { n: 'Tem', i: 'kdh' },
  { n: 'Kumam', i: 'kdi' },
  { n: 'Karamojong', i: 'kdj' },
  { n: 'Numèè', i: 'kdk' },
  { n: 'Tsikimba', i: 'kdl' },
  { n: 'Kagoma', i: 'kdm' },
  { n: 'Kunda', i: 'kdn' },
  { n: 'Kaningdon-Nindem', i: 'kdp' },
  { n: 'Koch', i: 'kdq' },
  { n: 'Karaim', i: 'kdr' },
  { n: 'Kuy', i: 'kdt' },
  { n: 'Kadaru', i: 'kdu' },
  { n: 'Koneraw', i: 'kdw' },
  { n: 'Kam', i: 'kdx' },
  { n: 'Keder', i: 'kdy' },
  { n: 'Kwaja', i: 'kdz' },
  { n: 'Kabuverdianu', i: 'kea' },
  { n: 'Kélé', i: 'keb' },
  { n: 'Keiga', i: 'kec' },
  { n: 'Kerewe', i: 'ked' },
  { n: 'Eastern Keres', i: 'kee' },
  { n: 'Kpessi', i: 'kef' },
  { n: 'Tese', i: 'keg' },
  { n: 'Keak', i: 'keh' },
  { n: 'Kei', i: 'kei' },
  { n: 'Kadar', i: 'kej' },
  { n: 'Kekchí', i: 'kek' },
  { n: 'Kela (Democratic Republic of Congo)', i: 'kel' },
  { n: 'Kemak', i: 'kem' },
  { n: 'Kenyang', i: 'ken' },
  { n: 'Kakwa', i: 'keo' },
  { n: 'Kaikadi', i: 'kep' },
  { n: 'Kamar', i: 'keq' },
  { n: 'Kera', i: 'ker' },
  { n: 'Kugbo', i: 'kes' },
  { n: 'Ket', i: 'ket' },
  { n: 'Akebu', i: 'keu' },
  { n: 'Kanikkaran', i: 'kev' },
  { n: 'West Kewa', i: 'kew' },
  { n: 'Kukna', i: 'kex' },
  { n: 'Kupia', i: 'key' },
  { n: 'Kukele', i: 'kez' },
  { n: 'Kodava', i: 'kfa' },
  { n: 'Northwestern Kolami', i: 'kfb' },
  { n: 'Konda-Dora', i: 'kfc' },
  { n: 'Korra Koraga', i: 'kfd' },
  { n: 'Kota (India)', i: 'kfe' },
  { n: 'Koya', i: 'kff' },
  { n: 'Kudiya', i: 'kfg' },
  { n: 'Kurichiya', i: 'kfh' },
  { n: 'Kannada Kurumba', i: 'kfi' },
  { n: 'Kemiehua', i: 'kfj' },
  { n: 'Kinnauri', i: 'kfk' },
  { n: 'Kung', i: 'kfl' },
  { n: 'Khunsari', i: 'kfm' },
  { n: 'Kuk', i: 'kfn' },
  { n: "Koro (Côte d'Ivoire)", i: 'kfo' },
  { n: 'Korwa', i: 'kfp' },
  { n: 'Korku', i: 'kfq' },
  { n: 'Kachhi', i: 'kfr' },
  { n: 'Bilaspuri', i: 'kfs' },
  { n: 'Kanjari', i: 'kft' },
  { n: 'Katkari', i: 'kfu' },
  { n: 'Kurmukar', i: 'kfv' },
  { n: 'Kharam Naga', i: 'kfw' },
  { n: 'Kullu Pahari', i: 'kfx' },
  { n: 'Kumaoni', i: 'kfy' },
  { n: 'Koromfé', i: 'kfz' },
  { n: 'Koyaga', i: 'kga' },
  { n: 'Kawe', i: 'kgb' },
  { n: 'Komering', i: 'kge' },
  { n: 'Kube', i: 'kgf' },
  { n: 'Kusunda', i: 'kgg' },
  { n: 'Selangor Sign Language', i: 'kgi' },
  { n: 'Gamale Kham', i: 'kgj' },
  { n: 'Kaiwá', i: 'kgk' },
  { n: 'Karingani', i: 'kgn' },
  { n: 'Krongo', i: 'kgo' },
  { n: 'Kaingang', i: 'kgp' },
  { n: 'Kamoro', i: 'kgq' },
  { n: 'Abun', i: 'kgr' },
  { n: 'Kumbainggar', i: 'kgs' },
  { n: 'Somyev', i: 'kgt' },
  { n: 'Kobol', i: 'kgu' },
  { n: 'Karas', i: 'kgv' },
  { n: 'Karon Dori', i: 'kgw' },
  { n: 'Kamaru', i: 'kgx' },
  { n: 'Kyerung', i: 'kgy' },
  { n: 'Khasi', i: 'kha' },
  { n: 'Lü', i: 'khb' },
  { n: 'Tukang Besi North', i: 'khc' },
  { n: 'Bädi Kanum', i: 'khd' },
  { n: 'Korowai', i: 'khe' },
  { n: 'Khuen', i: 'khf' },
  { n: 'Khams Tibetan', i: 'khg' },
  { n: 'Kehu', i: 'khh' },
  { n: 'Kuturmi', i: 'khj' },
  { n: 'Halh Mongolian', i: 'khk' },
  { n: 'Lusi', i: 'khl' },
  { n: 'Khmer', i: 'khm' },
  { n: 'Khandesi', i: 'khn' },
  { n: 'Kapori', i: 'khp' },
  { n: 'Koyra Chiini Songhay', i: 'khq' },
  { n: 'Kharia', i: 'khr' },
  { n: 'Kasua', i: 'khs' },
  { n: 'Khamti', i: 'kht' },
  { n: 'Nkhumbi', i: 'khu' },
  { n: 'Khvarshi', i: 'khv' },
  { n: 'Khowar', i: 'khw' },
  { n: 'Kanu', i: 'khx' },
  { n: 'Kele (Democratic Republic of Congo)', i: 'khy' },
  { n: 'Keapara', i: 'khz' },
  { n: 'Kim', i: 'kia' },
  { n: 'Koalib', i: 'kib' },
  { n: 'Kickapoo', i: 'kic' },
  { n: 'Koshin', i: 'kid' },
  { n: 'Kibet', i: 'kie' },
  { n: 'Eastern Parbate Kham', i: 'kif' },
  { n: 'Kimaama', i: 'kig' },
  { n: 'Kilmeri', i: 'kih' },
  { n: 'Kilivila', i: 'kij' },
  { n: 'Kikuyu', i: 'kik' },
  { n: 'Kariya', i: 'kil' },
  { n: 'Karagas', i: 'kim' },
  { n: 'Kinyarwanda', i: 'kin' },
  { n: 'Kiowa', i: 'kio' },
  { n: 'Sheshi Kham', i: 'kip' },
  { n: 'Kosadle', i: 'kiq' },
  { n: 'Kirghiz', i: 'kir' },
  { n: 'Kis', i: 'kis' },
  { n: 'Agob', i: 'kit' },
  { n: 'Kirmanjki (individual language)', i: 'kiu' },
  { n: 'Kimbu', i: 'kiv' },
  { n: 'Northeast Kiwai', i: 'kiw' },
  { n: 'Khiamniungan Naga', i: 'kix' },
  { n: 'Kirikiri', i: 'kiy' },
  { n: 'Kisi', i: 'kiz' },
  { n: 'Mlap', i: 'kja' },
  { n: "Q'anjob'al", i: 'kjb' },
  { n: 'Coastal Konjo', i: 'kjc' },
  { n: 'Southern Kiwai', i: 'kjd' },
  { n: 'Kisar', i: 'kje' },
  { n: 'Khmu', i: 'kjg' },
  { n: 'Khakas', i: 'kjh' },
  { n: 'Zabana', i: 'kji' },
  { n: 'Khinalugh', i: 'kjj' },
  { n: 'Highland Konjo', i: 'kjk' },
  { n: 'Western Parbate Kham', i: 'kjl' },
  { n: 'Kháng', i: 'kjm' },
  { n: 'Kunjen', i: 'kjn' },
  { n: 'Harijan Kinnauri', i: 'kjo' },
  { n: 'Pwo Eastern Karen', i: 'kjp' },
  { n: 'Western Keres', i: 'kjq' },
  { n: 'Kurudu', i: 'kjr' },
  { n: 'East Kewa', i: 'kjs' },
  { n: 'Phrae Pwo Karen', i: 'kjt' },
  { n: 'Kashaya', i: 'kju' },
  { n: 'Ramopa', i: 'kjx' },
  { n: 'Erave', i: 'kjy' },
  { n: 'Bumthangkha', i: 'kjz' },
  { n: 'Kakanda', i: 'kka' },
  { n: 'Kwerisa', i: 'kkb' },
  { n: 'Odoodee', i: 'kkc' },
  { n: 'Kinuku', i: 'kkd' },
  { n: 'Kakabe', i: 'kke' },
  { n: 'Kalaktang Monpa', i: 'kkf' },
  { n: 'Mabaka Valley Kalinga', i: 'kkg' },
  { n: 'Khün', i: 'kkh' },
  { n: 'Kagulu', i: 'kki' },
  { n: 'Kako', i: 'kkj' },
  { n: 'Kokota', i: 'kkk' },
  { n: 'Kosarek Yale', i: 'kkl' },
  { n: 'Kiong', i: 'kkm' },
  { n: 'Kon Keu', i: 'kkn' },
  { n: 'Karko', i: 'kko' },
  { n: 'Gugubera', i: 'kkp' },
  { n: 'Kaeku', i: 'kkq' },
  { n: 'Kir-Balar', i: 'kkr' },
  { n: 'Giiwo', i: 'kks' },
  { n: 'Koi', i: 'kkt' },
  { n: 'Tumi', i: 'kku' },
  { n: 'Kangean', i: 'kkv' },
  { n: 'Teke-Kukuya', i: 'kkw' },
  { n: 'Kohin', i: 'kkx' },
  { n: 'Guugu Yimidhirr', i: 'kky' },
  { n: 'Kaska', i: 'kkz' },
  { n: 'Kiliwa', i: 'klb' },
  { n: 'Kolbila', i: 'klc' },
  { n: 'Gamilaraay', i: 'kld' },
  { n: 'Kulung (Nepal)', i: 'kle' },
  { n: 'Kendeje', i: 'klf' },
  { n: 'Tagakaulo', i: 'klg' },
  { n: 'Weliki', i: 'klh' },
  { n: 'Kalumpang', i: 'kli' },
  { n: 'Khalaj', i: 'klj' },
  { n: 'Kono (Nigeria)', i: 'klk' },
  { n: 'Kagan Kalagan', i: 'kll' },
  { n: 'Migum', i: 'klm' },
  { n: 'Kapya', i: 'klo' },
  { n: 'Kamasa', i: 'klp' },
  { n: 'Rumu', i: 'klq' },
  { n: 'Khaling', i: 'klr' },
  { n: 'Kalasha', i: 'kls' },
  { n: 'Nukna', i: 'klt' },
  { n: 'Klao', i: 'klu' },
  { n: 'Maskelynes', i: 'klv' },
  { n: 'Tado', i: 'klw' },
  { n: 'Koluwawa', i: 'klx' },
  { n: 'Kalao', i: 'kly' },
  { n: 'Kabola', i: 'klz' },
  { n: 'Konni', i: 'kma' },
  { n: 'Kimbundu', i: 'kmb' },
  { n: 'Southern Dong', i: 'kmc' },
  { n: 'Majukayang Kalinga', i: 'kmd' },
  { n: 'Bakole', i: 'kme' },
  { n: 'Kare (Papua New Guinea)', i: 'kmf' },
  { n: 'Kâte', i: 'kmg' },
  { n: 'Kalam', i: 'kmh' },
  { n: 'Kami (Nigeria)', i: 'kmi' },
  { n: 'Kumarbhag Paharia', i: 'kmj' },
  { n: 'Limos Kalinga', i: 'kmk' },
  { n: 'Tanudan Kalinga', i: 'kml' },
  { n: 'Kom (India)', i: 'kmm' },
  { n: 'Awtuw', i: 'kmn' },
  { n: 'Kwoma', i: 'kmo' },
  { n: 'Gimme', i: 'kmp' },
  { n: 'Kwama', i: 'kmq' },
  { n: 'Northern Kurdish', i: 'kmr' },
  { n: 'Kamasau', i: 'kms' },
  { n: 'Kemtuik', i: 'kmt' },
  { n: 'Kanite', i: 'kmu' },
  { n: 'Karipúna Creole French', i: 'kmv' },
  { n: 'Komo (Democratic Republic of Congo)', i: 'kmw' },
  { n: 'Waboda', i: 'kmx' },
  { n: 'Koma', i: 'kmy' },
  { n: 'Khorasani Turkish', i: 'kmz' },
  { n: 'Dera (Nigeria)', i: 'kna' },
  { n: 'Lubuagan Kalinga', i: 'knb' },
  { n: 'Central Kanuri', i: 'knc' },
  { n: 'Konda', i: 'knd' },
  { n: 'Kankanaey', i: 'kne' },
  { n: 'Mankanya', i: 'knf' },
  { n: 'Koongo', i: 'kng' },
  { n: 'Kanufi', i: 'kni' },
  { n: 'Western Kanjobal', i: 'knj' },
  { n: 'Kuranko', i: 'knk' },
  { n: 'Keninjal', i: 'knl' },
  { n: 'Kanamarí', i: 'knm' },
  { n: 'Konkani (individual language)', i: 'knn' },
  { n: 'Kono (Sierra Leone)', i: 'kno' },
  { n: 'Kwanja', i: 'knp' },
  { n: 'Kintaq', i: 'knq' },
  { n: 'Kaningra', i: 'knr' },
  { n: 'Kensiu', i: 'kns' },
  { n: 'Panoan Katukína', i: 'knt' },
  { n: 'Kono (Guinea)', i: 'knu' },
  { n: 'Tabo', i: 'knv' },
  { n: 'Kung-Ekoka', i: 'knw' },
  { n: 'Kendayan', i: 'knx' },
  { n: 'Kanyok', i: 'kny' },
  { n: 'Kalamsé', i: 'knz' },
  { n: 'Konomala', i: 'koa' },
  { n: 'Kodi', i: 'kod' },
  { n: 'Kacipo-Balesi', i: 'koe' },
  { n: 'Cogui', i: 'kog' },
  { n: 'Koyo', i: 'koh' },
  { n: 'Komi-Permyak', i: 'koi' },
  { n: 'Kol (Papua New Guinea)', i: 'kol' },
  { n: 'Konzo', i: 'koo' },
  { n: 'Waube', i: 'kop' },
  { n: 'Kota (Gabon)', i: 'koq' },
  { n: 'Korean', i: 'kor' },
  { n: 'Kosraean', i: 'kos' },
  { n: 'Lagwan', i: 'kot' },
  { n: 'Koke', i: 'kou' },
  { n: 'Kudu-Camo', i: 'kov' },
  { n: 'Kugama', i: 'kow' },
  { n: 'Koyukon', i: 'koy' },
  { n: 'Korak', i: 'koz' },
  { n: 'Kutto', i: 'kpa' },
  { n: 'Mullu Kurumba', i: 'kpb' },
  { n: 'Curripaco', i: 'kpc' },
  { n: 'Koba', i: 'kpd' },
  { n: 'Komba', i: 'kpf' },
  { n: 'Kapingamarangi', i: 'kpg' },
  { n: 'Kplang', i: 'kph' },
  { n: 'Kofei', i: 'kpi' },
  { n: 'Karajá', i: 'kpj' },
  { n: 'Kpan', i: 'kpk' },
  { n: 'Kpala', i: 'kpl' },
  { n: 'Koho', i: 'kpm' },
  { n: 'Ikposo', i: 'kpo' },
  { n: 'Korupun-Sela', i: 'kpq' },
  { n: 'Korafe-Yegha', i: 'kpr' },
  { n: 'Tehit', i: 'kps' },
  { n: 'Karata', i: 'kpt' },
  { n: 'Kafoa', i: 'kpu' },
  { n: 'Komi-Zyrian', i: 'kpv' },
  { n: 'Kobon', i: 'kpw' },
  { n: 'Mountain Koiali', i: 'kpx' },
  { n: 'Koryak', i: 'kpy' },
  { n: 'Kupsabiny', i: 'kpz' },
  { n: 'Mum', i: 'kqa' },
  { n: 'Kovai', i: 'kqb' },
  { n: 'Doromu-Koki', i: 'kqc' },
  { n: 'Koy Sanjaq Surat', i: 'kqd' },
  { n: 'Kalagan', i: 'kqe' },
  { n: 'Kakabai', i: 'kqf' },
  { n: 'Khe', i: 'kqg' },
  { n: 'Kisankasa', i: 'kqh' },
  { n: 'Koitabu', i: 'kqi' },
  { n: 'Koromira', i: 'kqj' },
  { n: 'Kotafon Gbe', i: 'kqk' },
  { n: 'Kyenele', i: 'kql' },
  { n: 'Khisa', i: 'kqm' },
  { n: 'Kaonde', i: 'kqn' },
  { n: 'Eastern Krahn', i: 'kqo' },
  { n: 'Kimré', i: 'kqp' },
  { n: 'Krenak', i: 'kqq' },
  { n: 'Kimaragang', i: 'kqr' },
  { n: 'Northern Kissi', i: 'kqs' },
  { n: 'Klias River Kadazan', i: 'kqt' },
  { n: 'Okolod', i: 'kqv' },
  { n: 'Kandas', i: 'kqw' },
  { n: 'Mser', i: 'kqx' },
  { n: 'Koorete', i: 'kqy' },
  { n: 'Kumhali', i: 'kra' },
  { n: 'Karachay-Balkar', i: 'krc' },
  { n: 'Kairui-Midiki', i: 'krd' },
  { n: 'Panará', i: 'kre' },
  { n: 'Koro (Vanuatu)', i: 'krf' },
  { n: 'Kurama', i: 'krh' },
  { n: 'Krio', i: 'kri' },
  { n: 'Kinaray-A', i: 'krj' },
  { n: 'Karelian', i: 'krl' },
  { n: 'Sapo', i: 'krn' },
  { n: 'Korop', i: 'krp' },
  { n: 'Krung', i: 'krr' },
  { n: 'Gbaya (Sudan)', i: 'krs' },
  { n: 'Tumari Kanuri', i: 'krt' },
  { n: 'Kurukh', i: 'kru' },
  { n: 'Kavet', i: 'krv' },
  { n: 'Western Krahn', i: 'krw' },
  { n: 'Karon', i: 'krx' },
  { n: 'Kryts', i: 'kry' },
  { n: 'Sota Kanum', i: 'krz' },
  { n: 'Shuwa-Zamani', i: 'ksa' },
  { n: 'Shambala', i: 'ksb' },
  { n: 'Southern Kalinga', i: 'ksc' },
  { n: 'Kuanua', i: 'ksd' },
  { n: 'Kuni', i: 'kse' },
  { n: 'Bafia', i: 'ksf' },
  { n: 'Kusaghe', i: 'ksg' },
  { n: 'Kölsch', i: 'ksh' },
  { n: 'Krisa', i: 'ksi' },
  { n: 'Uare', i: 'ksj' },
  { n: 'Kansa', i: 'ksk' },
  { n: 'Kumalu', i: 'ksl' },
  { n: 'Kumba', i: 'ksm' },
  { n: 'Kasiguranin', i: 'ksn' },
  { n: 'Kofa', i: 'kso' },
  { n: 'Kaba', i: 'ksp' },
  { n: 'Kwaami', i: 'ksq' },
  { n: 'Borong', i: 'ksr' },
  { n: 'Southern Kisi', i: 'kss' },
  { n: 'Winyé', i: 'kst' },
  { n: 'Khamyang', i: 'ksu' },
  { n: 'Kusu', i: 'ksv' },
  { n: "S'gaw Karen", i: 'ksw' },
  { n: 'Kedang', i: 'ksx' },
  { n: 'Kharia Thar', i: 'ksy' },
  { n: 'Kodaku', i: 'ksz' },
  { n: 'Katua', i: 'kta' },
  { n: 'Kambaata', i: 'ktb' },
  { n: 'Kholok', i: 'ktc' },
  { n: 'Kokata', i: 'ktd' },
  { n: 'Nubri', i: 'kte' },
  { n: 'Kwami', i: 'ktf' },
  { n: 'Karanga', i: 'kth' },
  { n: 'North Muyu', i: 'kti' },
  { n: 'Plapo Krumen', i: 'ktj' },
  { n: 'Koroshi', i: 'ktl' },
  { n: 'Kurti', i: 'ktm' },
  { n: 'Karitiâna', i: 'ktn' },
  { n: 'Kuot', i: 'kto' },
  { n: 'Kaduo', i: 'ktp' },
  { n: 'South Muyu', i: 'kts' },
  { n: 'Ketum', i: 'ktt' },
  { n: 'Kituba (Democratic Republic of Congo)', i: 'ktu' },
  { n: 'Eastern Katu', i: 'ktv' },
  { n: 'Kaxararí', i: 'ktx' },
  { n: 'Kango (Bas-Uélé District)', i: 'kty' },
  { n: 'Juǀʼhoan', i: 'ktz' },
  { n: 'Kuanyama', i: 'kua' },
  { n: 'Kutep', i: 'kub' },
  { n: 'Kwinsu', i: 'kuc' },
  { n: "'Auhelawa", i: 'kud' },
  { n: 'Kuman (Papua New Guinea)', i: 'kue' },
  { n: 'Western Katu', i: 'kuf' },
  { n: 'Kupa', i: 'kug' },
  { n: 'Kushi', i: 'kuh' },
  { n: 'Kuikúro-Kalapálo', i: 'kui' },
  { n: 'Kuria', i: 'kuj' },
  { n: "Kepo'", i: 'kuk' },
  { n: 'Kulere', i: 'kul' },
  { n: 'Kumyk', i: 'kum' },
  { n: 'Kunama', i: 'kun' },
  { n: 'Kumukio', i: 'kuo' },
  { n: 'Kunimaipa', i: 'kup' },
  { n: 'Karipuna', i: 'kuq' },
  { n: 'Kusaal', i: 'kus' },
  { n: 'Kutenai', i: 'kut' },
  { n: 'Upper Kuskokwim', i: 'kuu' },
  { n: 'Kur', i: 'kuv' },
  { n: 'Kpagua', i: 'kuw' },
  { n: 'Kukatja', i: 'kux' },
  { n: "Kuuku-Ya'u", i: 'kuy' },
  { n: 'Bagvalal', i: 'kva' },
  { n: 'Kubu', i: 'kvb' },
  { n: 'Kove', i: 'kvc' },
  { n: 'Kui (Indonesia)', i: 'kvd' },
  { n: 'Kalabakan', i: 'kve' },
  { n: 'Kabalai', i: 'kvf' },
  { n: 'Kuni-Boazi', i: 'kvg' },
  { n: 'Komodo', i: 'kvh' },
  { n: 'Kwang', i: 'kvi' },
  { n: 'Psikye', i: 'kvj' },
  { n: 'Korean Sign Language', i: 'kvk' },
  { n: 'Kayaw', i: 'kvl' },
  { n: 'Kendem', i: 'kvm' },
  { n: 'Border Kuna', i: 'kvn' },
  { n: 'Dobel', i: 'kvo' },
  { n: 'Kompane', i: 'kvp' },
  { n: 'Geba Karen', i: 'kvq' },
  { n: 'Kerinci', i: 'kvr' },
  { n: 'Lahta Karen', i: 'kvt' },
  { n: 'Yinbaw Karen', i: 'kvu' },
  { n: 'Kola', i: 'kvv' },
  { n: 'Wersing', i: 'kvw' },
  { n: 'Parkari Koli', i: 'kvx' },
  { n: 'Yintale Karen', i: 'kvy' },
  { n: 'Tsakwambo', i: 'kvz' },
  { n: 'Dâw', i: 'kwa' },
  { n: 'Kwa', i: 'kwb' },
  { n: 'Likwala', i: 'kwc' },
  { n: 'Kwaio', i: 'kwd' },
  { n: 'Kwerba', i: 'kwe' },
  { n: "Kwara'ae", i: 'kwf' },
  { n: 'Sara Kaba Deme', i: 'kwg' },
  { n: 'Kowiai', i: 'kwh' },
  { n: 'Awa-Cuaiquer', i: 'kwi' },
  { n: 'Kwanga', i: 'kwj' },
  { n: 'Kwakiutl', i: 'kwk' },
  { n: 'Kofyar', i: 'kwl' },
  { n: 'Kwambi', i: 'kwm' },
  { n: 'Kwangali', i: 'kwn' },
  { n: 'Kwomtari', i: 'kwo' },
  { n: 'Kodia', i: 'kwp' },
  { n: 'Kwer', i: 'kwr' },
  { n: 'Kwese', i: 'kws' },
  { n: 'Kwesten', i: 'kwt' },
  { n: 'Kwakum', i: 'kwu' },
  { n: 'Sara Kaba Náà', i: 'kwv' },
  { n: 'Kwinti', i: 'kww' },
  { n: 'Khirwar', i: 'kwx' },
  { n: 'San Salvador Kongo', i: 'kwy' },
  { n: 'Kairiru', i: 'kxa' },
  { n: 'Krobu', i: 'kxb' },
  { n: 'Konso', i: 'kxc' },
  { n: 'Brunei', i: 'kxd' },
  { n: 'Manumanaw Karen', i: 'kxf' },
  { n: 'Karo (Ethiopia)', i: 'kxh' },
  { n: 'Keningau Murut', i: 'kxi' },
  { n: 'Kulfa', i: 'kxj' },
  { n: 'Zayein Karen', i: 'kxk' },
  { n: 'Northern Khmer', i: 'kxm' },
  { n: 'Kanowit-Tanjong Melanau', i: 'kxn' },
  { n: 'Wadiyara Koli', i: 'kxp' },
  { n: 'Smärky Kanum', i: 'kxq' },
  { n: 'Koro (Papua New Guinea)', i: 'kxr' },
  { n: 'Kangjia', i: 'kxs' },
  { n: 'Koiwat', i: 'kxt' },
  { n: 'Kuvi', i: 'kxv' },
  { n: 'Konai', i: 'kxw' },
  { n: 'Likuba', i: 'kxx' },
  { n: 'Kayong', i: 'kxy' },
  { n: 'Kerewo', i: 'kxz' },
  { n: 'Kwaya', i: 'kya' },
  { n: 'Butbut Kalinga', i: 'kyb' },
  { n: 'Kyaka', i: 'kyc' },
  { n: 'Karey', i: 'kyd' },
  { n: 'Krache', i: 'kye' },
  { n: 'Kouya', i: 'kyf' },
  { n: 'Keyagana', i: 'kyg' },
  { n: 'Karok', i: 'kyh' },
  { n: 'Kiput', i: 'kyi' },
  { n: 'Karao', i: 'kyj' },
  { n: 'Kamayo', i: 'kyk' },
  { n: 'Kalapuya', i: 'kyl' },
  { n: 'Kpatili', i: 'kym' },
  { n: 'Northern Binukidnon', i: 'kyn' },
  { n: 'Kelon', i: 'kyo' },
  { n: 'Kang', i: 'kyp' },
  { n: 'Kenga', i: 'kyq' },
  { n: 'Kuruáya', i: 'kyr' },
  { n: 'Baram Kayan', i: 'kys' },
  { n: 'Kayagar', i: 'kyt' },
  { n: 'Western Kayah', i: 'kyu' },
  { n: 'Kayort', i: 'kyv' },
  { n: 'Kudmali', i: 'kyw' },
  { n: 'Rapoisi', i: 'kyx' },
  { n: 'Kambaira', i: 'kyy' },
  { n: 'Kayabí', i: 'kyz' },
  { n: 'Western Karaboro', i: 'kza' },
  { n: 'Kaibobo', i: 'kzb' },
  { n: 'Bondoukou Kulango', i: 'kzc' },
  { n: 'Kadai', i: 'kzd' },
  { n: 'Kosena', i: 'kze' },
  { n: "Da'a Kaili", i: 'kzf' },
  { n: 'Kikai', i: 'kzg' },
  { n: 'Kelabit', i: 'kzi' },
  { n: 'Kayeli', i: 'kzl' },
  { n: 'Kais', i: 'kzm' },
  { n: 'Kokola', i: 'kzn' },
  { n: 'Kaningi', i: 'kzo' },
  { n: 'Kaidipang', i: 'kzp' },
  { n: 'Kaike', i: 'kzq' },
  { n: 'Karang', i: 'kzr' },
  { n: 'Sugut Dusun', i: 'kzs' },
  { n: 'Kayupulau', i: 'kzu' },
  { n: 'Komyandaret', i: 'kzv' },
  { n: 'Kango (Tshopo District)', i: 'kzy' },
  { n: 'Kalabra', i: 'kzz' },
  { n: 'Southern Subanen', i: 'laa' },
  { n: 'Lacandon', i: 'lac' },
  { n: 'Ladino', i: 'lad' },
  { n: 'Pattani', i: 'lae' },
  { n: 'Lafofa', i: 'laf' },
  { n: 'Langi', i: 'lag' },
  { n: 'Lambya', i: 'lai' },
  { n: 'Lango (Uganda)', i: 'laj' },
  { n: 'Laka (Nigeria)', i: 'lak' },
  { n: 'Lalia', i: 'lal' },
  { n: 'Lamba', i: 'lam' },
  { n: 'Laru', i: 'lan' },
  { n: 'Lao', i: 'lao' },
  { n: 'Laka (Chad)', i: 'lap' },
  { n: 'Qabiao', i: 'laq' },
  { n: 'Larteh', i: 'lar' },
  { n: 'Lama (Togo)', i: 'las' },
  { n: 'Laba', i: 'lau' },
  { n: 'Lauje', i: 'law' },
  { n: 'Tiwa', i: 'lax' },
  { n: 'Lama Bai', i: 'lay' },
  { n: 'Label', i: 'lbb' },
  { n: 'Lakkia', i: 'lbc' },
  { n: 'Lak', i: 'lbe' },
  { n: 'Tinani', i: 'lbf' },
  { n: 'Laopang', i: 'lbg' },
  { n: "La'bi", i: 'lbi' },
  { n: 'Ladakhi', i: 'lbj' },
  { n: 'Central Bontok', i: 'lbk' },
  { n: 'Libon Bikol', i: 'lbl' },
  { n: 'Lodhi', i: 'lbm' },
  { n: 'Rmeet', i: 'lbn' },
  { n: 'Laven', i: 'lbo' },
  { n: 'Wampar', i: 'lbq' },
  { n: 'Lohorung', i: 'lbr' },
  { n: 'Libyan Sign Language', i: 'lbs' },
  { n: 'Lachi', i: 'lbt' },
  { n: 'Labu', i: 'lbu' },
  { n: 'Lavatbura-Lamusong', i: 'lbv' },
  { n: 'Tolaki', i: 'lbw' },
  { n: 'Lawangan', i: 'lbx' },
  { n: 'Lardil', i: 'lbz' },
  { n: 'Legenyem', i: 'lcc' },
  { n: 'Lola', i: 'lcd' },
  { n: 'Loncong', i: 'lce' },
  { n: 'Lubu', i: 'lcf' },
  { n: 'Luchazi', i: 'lch' },
  { n: 'Lisela', i: 'lcl' },
  { n: 'Tungag', i: 'lcm' },
  { n: 'Western Lawa', i: 'lcp' },
  { n: 'Luhu', i: 'lcq' },
  { n: 'Lisabata-Nuniali', i: 'lcs' },
  { n: 'Kla-Dan', i: 'lda' },
  { n: 'Dũya', i: 'ldb' },
  { n: 'Luri', i: 'ldd' },
  { n: 'Lenyima', i: 'ldg' },
  { n: 'Lamja-Dengsa-Tola', i: 'ldh' },
  { n: 'Laari', i: 'ldi' },
  { n: 'Lemoro', i: 'ldj' },
  { n: 'Leelau', i: 'ldk' },
  { n: 'Kaan', i: 'ldl' },
  { n: 'Landoma', i: 'ldm' },
  { n: 'Loo', i: 'ldo' },
  { n: 'Tso', i: 'ldp' },
  { n: 'Lufu', i: 'ldq' },
  { n: 'Lega-Shabunda', i: 'lea' },
  { n: 'Lala-Bisa', i: 'leb' },
  { n: 'Leco', i: 'lec' },
  { n: 'Lendu', i: 'led' },
  { n: 'Lyélé', i: 'lee' },
  { n: 'Lelemi', i: 'lef' },
  { n: 'Lenje', i: 'leh' },
  { n: 'Lemio', i: 'lei' },
  { n: 'Lengola', i: 'lej' },
  { n: 'Leipon', i: 'lek' },
  { n: 'Lele (Democratic Republic of Congo)', i: 'lel' },
  { n: 'Nomaande', i: 'lem' },
  { n: 'Leti (Cameroon)', i: 'leo' },
  { n: 'Lepcha', i: 'lep' },
  { n: 'Lembena', i: 'leq' },
  { n: 'Lenkau', i: 'ler' },
  { n: 'Lese', i: 'les' },
  { n: 'Lesing-Gelimi', i: 'let' },
  { n: 'Kara (Papua New Guinea)', i: 'leu' },
  { n: 'Lamma', i: 'lev' },
  { n: 'Ledo Kaili', i: 'lew' },
  { n: 'Luang', i: 'lex' },
  { n: 'Lemolang', i: 'ley' },
  { n: 'Lezghian', i: 'lez' },
  { n: 'Lefa', i: 'lfa' },
  { n: 'Lungga', i: 'lga' },
  { n: 'Laghu', i: 'lgb' },
  { n: 'Lugbara', i: 'lgg' },
  { n: 'Laghuu', i: 'lgh' },
  { n: 'Lengilu', i: 'lgi' },
  { n: 'Lingarak', i: 'lgk' },
  { n: 'Wala', i: 'lgl' },
  { n: 'Lega-Mwenga', i: 'lgm' },
  { n: "T'apo", i: 'lgn' },
  { n: 'Logba', i: 'lgq' },
  { n: 'Lengo', i: 'lgr' },
  { n: 'Pahi', i: 'lgt' },
  { n: 'Longgu', i: 'lgu' },
  { n: 'Ligenza', i: 'lgz' },
  { n: 'Laha (Viet Nam)', i: 'lha' },
  { n: 'Laha (Indonesia)', i: 'lhh' },
  { n: 'Lahu Shi', i: 'lhi' },
  { n: 'Lahul Lohar', i: 'lhl' },
  { n: 'Lhomi', i: 'lhm' },
  { n: 'Lahanan', i: 'lhn' },
  { n: 'Lhokpu', i: 'lhp' },
  { n: 'Lo-Toga', i: 'lht' },
  { n: 'Lahu', i: 'lhu' },
  { n: 'West-Central Limba', i: 'lia' },
  { n: 'Likum', i: 'lib' },
  { n: 'Hlai', i: 'lic' },
  { n: 'Nyindrou', i: 'lid' },
  { n: 'Likila', i: 'lie' },
  { n: 'Limbu', i: 'lif' },
  { n: 'Ligbi', i: 'lig' },
  { n: 'Lihir', i: 'lih' },
  { n: 'Ligurian', i: 'lij' },
  { n: 'Lika', i: 'lik' },
  { n: 'Lillooet', i: 'lil' },
  { n: 'Limburgan', i: 'lim' },
  { n: 'Lingala', i: 'lin' },
  { n: 'Liki', i: 'lio' },
  { n: 'Sekpele', i: 'lip' },
  { n: 'Libido', i: 'liq' },
  { n: 'Liberian English', i: 'lir' },
  { n: 'Lisu', i: 'lis' },
  { n: 'Lithuanian', i: 'lit' },
  { n: 'Logorik', i: 'liu' },
  { n: 'Liv', i: 'liv' },
  { n: 'Col', i: 'liw' },
  { n: 'Liabuku', i: 'lix' },
  { n: 'Banda-Bambari', i: 'liy' },
  { n: 'Libinza', i: 'liz' },
  { n: 'Rampi', i: 'lje' },
  { n: 'Laiyolo', i: 'lji' },
  { n: "Li'o", i: 'ljl' },
  { n: 'Lampung Api', i: 'ljp' },
  { n: 'Yirandali', i: 'ljw' },
  { n: 'Lakalei', i: 'lka' },
  { n: 'Kabras', i: 'lkb' },
  { n: 'Kucong', i: 'lkc' },
  { n: 'Lakondê', i: 'lkd' },
  { n: 'Kenyi', i: 'lke' },
  { n: 'Lakha', i: 'lkh' },
  { n: 'Laki', i: 'lki' },
  { n: 'Remun', i: 'lkj' },
  { n: 'Laeko-Libuat', i: 'lkl' },
  { n: 'Lakon', i: 'lkn' },
  { n: 'Khayo', i: 'lko' },
  { n: 'Päri', i: 'lkr' },
  { n: 'Kisa', i: 'lks' },
  { n: 'Lakota', i: 'lkt' },
  { n: 'Lokoya', i: 'lky' },
  { n: 'Lala-Roba', i: 'lla' },
  { n: 'Lolo', i: 'llb' },
  { n: 'Lele (Guinea)', i: 'llc' },
  { n: 'Ladin', i: 'lld' },
  { n: 'Lele (Papua New Guinea)', i: 'lle' },
  { n: 'Lole', i: 'llg' },
  { n: 'Lamu', i: 'llh' },
  { n: 'Teke-Laali', i: 'lli' },
  { n: 'Lilau', i: 'lll' },
  { n: 'Lasalimu', i: 'llm' },
  { n: 'Lele (Chad)', i: 'lln' },
  { n: 'North Efate', i: 'llp' },
  { n: 'Lolak', i: 'llq' },
  { n: 'Lithuanian Sign Language', i: 'lls' },
  { n: 'Lau', i: 'llu' },
  { n: 'Lauan', i: 'llx' },
  { n: 'East Limba', i: 'lma' },
  { n: 'Merei', i: 'lmb' },
  { n: 'Lumun', i: 'lmd' },
  { n: 'Pévé', i: 'lme' },
  { n: 'South Lembata', i: 'lmf' },
  { n: 'Lamogai', i: 'lmg' },
  { n: 'Lambichhong', i: 'lmh' },
  { n: 'Lombi', i: 'lmi' },
  { n: 'West Lembata', i: 'lmj' },
  { n: 'Lamkang', i: 'lmk' },
  { n: 'Hano', i: 'lml' },
  { n: 'Lambadi', i: 'lmn' },
  { n: 'Lombard', i: 'lmo' },
  { n: 'Limbum', i: 'lmp' },
  { n: 'Lamatuka', i: 'lmq' },
  { n: 'Lamalera', i: 'lmr' },
  { n: 'Lamenu', i: 'lmu' },
  { n: 'Lomaiviti', i: 'lmv' },
  { n: 'Lake Miwok', i: 'lmw' },
  { n: 'Laimbue', i: 'lmx' },
  { n: 'Lamboya', i: 'lmy' },
  { n: 'Langbashe', i: 'lna' },
  { n: 'Mbalanhu', i: 'lnb' },
  { n: 'Lundayeh', i: 'lnd' },
  { n: 'Lanoh', i: 'lnh' },
  { n: "Daantanai'", i: 'lni' },
  { n: 'South Central Banda', i: 'lnl' },
  { n: 'Langam', i: 'lnm' },
  { n: 'Lorediakarkar', i: 'lnn' },
  { n: 'Lango (South Sudan)', i: 'lno' },
  { n: "Lamnso'", i: 'lns' },
  { n: 'Longuda', i: 'lnu' },
  { n: 'Lonzo', i: 'lnz' },
  { n: 'Loloda', i: 'loa' },
  { n: 'Lobi', i: 'lob' },
  { n: 'Inonhan', i: 'loc' },
  { n: 'Saluan', i: 'loe' },
  { n: 'Logol', i: 'lof' },
  { n: 'Logo', i: 'log' },
  { n: 'Narim', i: 'loh' },
  { n: "Loma (Côte d'Ivoire)", i: 'loi' },
  { n: 'Lou', i: 'loj' },
  { n: 'Loko', i: 'lok' },
  { n: 'Mongo', i: 'lol' },
  { n: 'Loma (Liberia)', i: 'lom' },
  { n: 'Malawi Lomwe', i: 'lon' },
  { n: 'Lombo', i: 'loo' },
  { n: 'Lopa', i: 'lop' },
  { n: 'Lobala', i: 'loq' },
  { n: 'Téén', i: 'lor' },
  { n: 'Loniu', i: 'los' },
  { n: 'Otuho', i: 'lot' },
  { n: 'Louisiana Creole', i: 'lou' },
  { n: 'Lopi', i: 'lov' },
  { n: 'Tampias Lobu', i: 'low' },
  { n: 'Loun', i: 'lox' },
  { n: 'Loke', i: 'loy' },
  { n: 'Lozi', i: 'loz' },
  { n: 'Lelepa', i: 'lpa' },
  { n: 'Lepki', i: 'lpe' },
  { n: 'Long Phuri Naga', i: 'lpn' },
  { n: 'Lipo', i: 'lpo' },
  { n: 'Lopit', i: 'lpx' },
  { n: "Rara Bakati'", i: 'lra' },
  { n: 'Northern Luri', i: 'lrc' },
  { n: 'Marachi', i: 'lri' },
  { n: 'Loarki', i: 'lrk' },
  { n: 'Lari', i: 'lrl' },
  { n: 'Marama', i: 'lrm' },
  { n: 'Lorang', i: 'lrn' },
  { n: 'Laro', i: 'lro' },
  { n: 'Southern Yamphu', i: 'lrr' },
  { n: 'Larantuka Malay', i: 'lrt' },
  { n: 'Larevat', i: 'lrv' },
  { n: 'Lemerig', i: 'lrz' },
  { n: 'Lasgerdi', i: 'lsa' },
  { n: 'Lishana Deni', i: 'lsd' },
  { n: 'Lusengo', i: 'lse' },
  { n: 'Lish', i: 'lsh' },
  { n: 'Lashi', i: 'lsi' },
  { n: 'Latvian Sign Language', i: 'lsl' },
  { n: 'Saamia', i: 'lsm' },
  { n: 'Tibetan Sign Language', i: 'lsn' },
  { n: 'Laos Sign Language', i: 'lso' },
  { n: 'Panamanian Sign Language', i: 'lsp' },
  { n: 'Aruop', i: 'lsr' },
  { n: 'Lasi', i: 'lss' },
  { n: 'Trinidad and Tobago Sign Language', i: 'lst' },
  { n: 'Sivia Sign Language', i: 'lsv' },
  { n: 'Mauritian Sign Language', i: 'lsy' },
  { n: 'Latgalian', i: 'ltg' },
  { n: 'Thur', i: 'lth' },
  { n: 'Leti (Indonesia)', i: 'lti' },
  { n: 'Latundê', i: 'ltn' },
  { n: 'Tsotso', i: 'lto' },
  { n: 'Tachoni', i: 'lts' },
  { n: 'Latu', i: 'ltu' },
  { n: 'Luxembourgish', i: 'ltz' },
  { n: 'Luba-Lulua', i: 'lua' },
  { n: 'Luba-Katanga', i: 'lub' },
  { n: 'Aringa', i: 'luc' },
  { n: 'Ludian', i: 'lud' },
  { n: 'Luvale', i: 'lue' },
  { n: 'Laua', i: 'luf' },
  { n: 'Ganda', i: 'lug' },
  { n: 'Luna', i: 'luj' },
  { n: 'Lunanakha', i: 'luk' },
  { n: "Olu'bo", i: 'lul' },
  { n: 'Luimbi', i: 'lum' },
  { n: 'Lunda', i: 'lun' },
  { n: 'Luo (Kenya and Tanzania)', i: 'luo' },
  { n: 'Lumbu', i: 'lup' },
  { n: 'Lucumi', i: 'luq' },
  { n: 'Laura', i: 'lur' },
  { n: 'Lushai', i: 'lus' },
  { n: 'Lushootseed', i: 'lut' },
  { n: 'Lumba-Yakkha', i: 'luu' },
  { n: 'Luwati', i: 'luv' },
  { n: 'Luo (Cameroon)', i: 'luw' },
  { n: 'Southern Luri', i: 'luz' },
  { n: "Maku'a", i: 'lva' },
  { n: 'Lavi', i: 'lvi' },
  { n: 'Lavukaleve', i: 'lvk' },
  { n: 'Standard Latvian', i: 'lvs' },
  { n: 'Levuka', i: 'lvu' },
  { n: 'Lwalu', i: 'lwa' },
  { n: 'Lewo Eleng', i: 'lwe' },
  { n: 'Wanga', i: 'lwg' },
  { n: 'White Lachi', i: 'lwh' },
  { n: 'Eastern Lawa', i: 'lwl' },
  { n: 'Laomian', i: 'lwm' },
  { n: 'Luwo', i: 'lwo' },
  { n: 'Malawian Sign Language', i: 'lws' },
  { n: 'Lewotobi', i: 'lwt' },
  { n: 'Lawu', i: 'lwu' },
  { n: 'Lewo', i: 'lww' },
  { n: 'Layakha', i: 'lya' },
  { n: 'Lyngngam', i: 'lyg' },
  { n: 'Luyana', i: 'lyn' },
  { n: 'Litzlitz', i: 'lzl' },
  { n: 'Leinong Naga', i: 'lzn' },
  { n: 'Laz', i: 'lzz' },
  { n: 'San Jerónimo Tecóatl Mazatec', i: 'maa' },
  { n: 'Yutanduchi Mixtec', i: 'mab' },
  { n: 'Madurese', i: 'mad' },
  { n: 'Bo-Rukul', i: 'mae' },
  { n: 'Mafa', i: 'maf' },
  { n: 'Magahi', i: 'mag' },
  { n: 'Marshallese', i: 'mah' },
  { n: 'Maithili', i: 'mai' },
  { n: 'Jalapa De Díaz Mazatec', i: 'maj' },
  { n: 'Makasar', i: 'mak' },
  { n: 'Malayalam', i: 'mal' },
  { n: 'Mam', i: 'mam' },
  { n: 'Chiquihuitlán Mazatec', i: 'maq' },
  { n: 'Marathi', i: 'mar' },
  { n: 'Masai', i: 'mas' },
  { n: 'San Francisco Matlatzinca', i: 'mat' },
  { n: 'Huautla Mazatec', i: 'mau' },
  { n: 'Sateré-Mawé', i: 'mav' },
  { n: 'Mampruli', i: 'maw' },
  { n: 'North Moluccan Malay', i: 'max' },
  { n: 'Central Mazahua', i: 'maz' },
  { n: 'Higaonon', i: 'mba' },
  { n: 'Western Bukidnon Manobo', i: 'mbb' },
  { n: 'Macushi', i: 'mbc' },
  { n: 'Dibabawon Manobo', i: 'mbd' },
  { n: 'Baba Malay', i: 'mbf' },
  { n: 'Mangseng', i: 'mbh' },
  { n: 'Ilianen Manobo', i: 'mbi' },
  { n: 'Nadëb', i: 'mbj' },
  { n: 'Malol', i: 'mbk' },
  { n: 'Maxakalí', i: 'mbl' },
  { n: 'Ombamba', i: 'mbm' },
  { n: 'Macaguán', i: 'mbn' },
  { n: 'Mbo (Cameroon)', i: 'mbo' },
  { n: 'Malayo', i: 'mbp' },
  { n: 'Maisin', i: 'mbq' },
  { n: 'Nukak Makú', i: 'mbr' },
  { n: 'Sarangani Manobo', i: 'mbs' },
  { n: 'Matigsalug Manobo', i: 'mbt' },
  { n: 'Mbula-Bwazza', i: 'mbu' },
  { n: 'Mbulungish', i: 'mbv' },
  { n: 'Maring', i: 'mbw' },
  { n: 'Mari (East Sepik Province)', i: 'mbx' },
  { n: 'Memoni', i: 'mby' },
  { n: 'Amoltepec Mixtec', i: 'mbz' },
  { n: 'Maca', i: 'mca' },
  { n: 'Machiguenga', i: 'mcb' },
  { n: 'Bitur', i: 'mcc' },
  { n: 'Sharanahua', i: 'mcd' },
  { n: 'Itundujia Mixtec', i: 'mce' },
  { n: 'Matsés', i: 'mcf' },
  { n: 'Mapoyo', i: 'mcg' },
  { n: 'Maquiritari', i: 'mch' },
  { n: 'Mese', i: 'mci' },
  { n: 'Mvanip', i: 'mcj' },
  { n: 'Mbunda', i: 'mck' },
  { n: 'Malaccan Creole Portuguese', i: 'mcm' },
  { n: 'Masana', i: 'mcn' },
  { n: 'Coatlán Mixe', i: 'mco' },
  { n: 'Makaa', i: 'mcp' },
  { n: 'Ese', i: 'mcq' },
  { n: 'Menya', i: 'mcr' },
  { n: 'Mambai', i: 'mcs' },
  { n: 'Mengisa', i: 'mct' },
  { n: 'Cameroon Mambila', i: 'mcu' },
  { n: 'Minanibai', i: 'mcv' },
  { n: 'Mawa (Chad)', i: 'mcw' },
  { n: 'Mpiemo', i: 'mcx' },
  { n: 'South Watut', i: 'mcy' },
  { n: 'Mawan', i: 'mcz' },
  { n: 'Mada (Nigeria)', i: 'mda' },
  { n: 'Morigi', i: 'mdb' },
  { n: 'Male (Papua New Guinea)', i: 'mdc' },
  { n: 'Mbum', i: 'mdd' },
  { n: 'Maba (Chad)', i: 'mde' },
  { n: 'Moksha', i: 'mdf' },
  { n: 'Massalat', i: 'mdg' },
  { n: 'Maguindanaon', i: 'mdh' },
  { n: 'Mamvu', i: 'mdi' },
  { n: 'Mangbetu', i: 'mdj' },
  { n: 'Mangbutu', i: 'mdk' },
  { n: 'Maltese Sign Language', i: 'mdl' },
  { n: 'Mayogo', i: 'mdm' },
  { n: 'Mbati', i: 'mdn' },
  { n: 'Mbala', i: 'mdp' },
  { n: 'Mbole', i: 'mdq' },
  { n: 'Mandar', i: 'mdr' },
  { n: 'Maria (Papua New Guinea)', i: 'mds' },
  { n: 'Mbere', i: 'mdt' },
  { n: 'Mboko', i: 'mdu' },
  { n: 'Santa Lucía Monteverde Mixtec', i: 'mdv' },
  { n: 'Mbosi', i: 'mdw' },
  { n: 'Dizin', i: 'mdx' },
  { n: 'Male (Ethiopia)', i: 'mdy' },
  { n: 'Suruí Do Pará', i: 'mdz' },
  { n: 'Menka', i: 'mea' },
  { n: 'Ikobi', i: 'meb' },
  { n: 'Marra', i: 'mec' },
  { n: 'Melpa', i: 'med' },
  { n: 'Mengen', i: 'mee' },
  { n: 'Megam', i: 'mef' },
  { n: 'Southwestern Tlaxiaco Mixtec', i: 'meh' },
  { n: 'Midob', i: 'mei' },
  { n: 'Meyah', i: 'mej' },
  { n: 'Mekeo', i: 'mek' },
  { n: 'Central Melanau', i: 'mel' },
  { n: 'Mende (Sierra Leone)', i: 'men' },
  { n: 'Kedah Malay', i: 'meo' },
  { n: 'Miriwoong', i: 'mep' },
  { n: 'Merey', i: 'meq' },
  { n: 'Meru', i: 'mer' },
  { n: 'Masmaje', i: 'mes' },
  { n: 'Mato', i: 'met' },
  { n: 'Motu', i: 'meu' },
  { n: 'Mano', i: 'mev' },
  { n: 'Maaka', i: 'mew' },
  { n: 'Hassaniyya', i: 'mey' },
  { n: 'Menominee', i: 'mez' },
  { n: 'Pattani Malay', i: 'mfa' },
  { n: 'Bangka', i: 'mfb' },
  { n: 'Mba', i: 'mfc' },
  { n: 'Mendankwe-Nkwen', i: 'mfd' },
  { n: 'Morisyen', i: 'mfe' },
  { n: 'Naki', i: 'mff' },
  { n: 'Mogofin', i: 'mfg' },
  { n: 'Matal', i: 'mfh' },
  { n: 'Wandala', i: 'mfi' },
  { n: 'Mefele', i: 'mfj' },
  { n: 'North Mofu', i: 'mfk' },
  { n: 'Putai', i: 'mfl' },
  { n: 'Marghi South', i: 'mfm' },
  { n: 'Cross River Mbembe', i: 'mfn' },
  { n: 'Mbe', i: 'mfo' },
  { n: 'Makassar Malay', i: 'mfp' },
  { n: 'Moba', i: 'mfq' },
  { n: 'Marrithiyel', i: 'mfr' },
  { n: 'Mexican Sign Language', i: 'mfs' },
  { n: 'Mokerang', i: 'mft' },
  { n: 'Mbwela', i: 'mfu' },
  { n: 'Mandjak', i: 'mfv' },
  { n: 'Melo', i: 'mfx' },
  { n: 'Mayo', i: 'mfy' },
  { n: 'Mabaan', i: 'mfz' },
  { n: 'Mararit', i: 'mgb' },
  { n: 'Morokodo', i: 'mgc' },
  { n: 'Moru', i: 'mgd' },
  { n: 'Mango', i: 'mge' },
  { n: 'Maklew', i: 'mgf' },
  { n: 'Mpumpong', i: 'mgg' },
  { n: 'Makhuwa-Meetto', i: 'mgh' },
  { n: 'Lijili', i: 'mgi' },
  { n: 'Abureni', i: 'mgj' },
  { n: 'Mawes', i: 'mgk' },
  { n: 'Maleu-Kilenge', i: 'mgl' },
  { n: 'Mambae', i: 'mgm' },
  { n: 'Mbangi', i: 'mgn' },
  { n: "Meta'", i: 'mgo' },
  { n: 'Eastern Magar', i: 'mgp' },
  { n: 'Malila', i: 'mgq' },
  { n: 'Mambwe-Lungu', i: 'mgr' },
  { n: 'Manda (Tanzania)', i: 'mgs' },
  { n: 'Mongol', i: 'mgt' },
  { n: 'Mailu', i: 'mgu' },
  { n: 'Matengo', i: 'mgv' },
  { n: 'Matumbi', i: 'mgw' },
  { n: 'Mbunga', i: 'mgy' },
  { n: 'Mbugwe', i: 'mgz' },
  { n: 'Manda (India)', i: 'mha' },
  { n: 'Mahongwe', i: 'mhb' },
  { n: 'Mocho', i: 'mhc' },
  { n: 'Mbugu', i: 'mhd' },
  { n: 'Besisi', i: 'mhe' },
  { n: 'Mamaa', i: 'mhf' },
  { n: 'Margu', i: 'mhg' },
  { n: "Ma'di", i: 'mhi' },
  { n: 'Mogholi', i: 'mhj' },
  { n: 'Mungaka', i: 'mhk' },
  { n: 'Mauwake', i: 'mhl' },
  { n: 'Makhuwa-Moniga', i: 'mhm' },
  { n: 'Mócheno', i: 'mhn' },
  { n: 'Mashi (Zambia)', i: 'mho' },
  { n: 'Balinese Malay', i: 'mhp' },
  { n: 'Mandan', i: 'mhq' },
  { n: 'Eastern Mari', i: 'mhr' },
  { n: 'Buru (Indonesia)', i: 'mhs' },
  { n: 'Mandahuaca', i: 'mht' },
  { n: 'Digaro-Mishmi', i: 'mhu' },
  { n: 'Mbukushu', i: 'mhw' },
  { n: 'Maru', i: 'mhx' },
  { n: "Ma'anyan", i: 'mhy' },
  { n: 'Mor (Mor Islands)', i: 'mhz' },
  { n: 'Miami', i: 'mia' },
  { n: 'Atatláhuca Mixtec', i: 'mib' },
  { n: "Mi'kmaq", i: 'mic' },
  { n: 'Mandaic', i: 'mid' },
  { n: 'Ocotepec Mixtec', i: 'mie' },
  { n: 'Mofu-Gudur', i: 'mif' },
  { n: 'San Miguel El Grande Mixtec', i: 'mig' },
  { n: 'Chayuco Mixtec', i: 'mih' },
  { n: 'Chigmecatitlán Mixtec', i: 'mii' },
  { n: 'Abar', i: 'mij' },
  { n: 'Mikasuki', i: 'mik' },
  { n: 'Peñoles Mixtec', i: 'mil' },
  { n: 'Alacatlatzala Mixtec', i: 'mim' },
  { n: 'Minangkabau', i: 'min' },
  { n: 'Pinotepa Nacional Mixtec', i: 'mio' },
  { n: 'Apasco-Apoala Mixtec', i: 'mip' },
  { n: 'Mískito', i: 'miq' },
  { n: 'Isthmus Mixe', i: 'mir' },
  { n: 'Southern Puebla Mixtec', i: 'mit' },
  { n: 'Cacaloxtepec Mixtec', i: 'miu' },
  { n: 'Akoye', i: 'miw' },
  { n: 'Mixtepec Mixtec', i: 'mix' },
  { n: 'Ayutla Mixtec', i: 'miy' },
  { n: 'Coatzospan Mixtec', i: 'miz' },
  { n: 'Makalero', i: 'mjb' },
  { n: 'San Juan Colorado Mixtec', i: 'mjc' },
  { n: 'Northwest Maidu', i: 'mjd' },
  { n: 'Tu', i: 'mjg' },
  { n: 'Mwera (Nyasa)', i: 'mjh' },
  { n: 'Kim Mun', i: 'mji' },
  { n: 'Mawak', i: 'mjj' },
  { n: 'Matukar', i: 'mjk' },
  { n: 'Mandeali', i: 'mjl' },
  { n: 'Medebur', i: 'mjm' },
  { n: 'Ma (Papua New Guinea)', i: 'mjn' },
  { n: 'Malankuravan', i: 'mjo' },
  { n: 'Malapandaram', i: 'mjp' },
  { n: 'Malavedan', i: 'mjr' },
  { n: 'Miship', i: 'mjs' },
  { n: 'Sauria Paharia', i: 'mjt' },
  { n: 'Manna-Dora', i: 'mju' },
  { n: 'Mannan', i: 'mjv' },
  { n: 'Karbi', i: 'mjw' },
  { n: 'Mahali', i: 'mjx' },
  { n: 'Majhi', i: 'mjz' },
  { n: 'Mbre', i: 'mka' },
  { n: 'Mal Paharia', i: 'mkb' },
  { n: 'Siliput', i: 'mkc' },
  { n: 'Macedonian', i: 'mkd' },
  { n: 'Mawchi', i: 'mke' },
  { n: 'Miya', i: 'mkf' },
  { n: 'Mak (China)', i: 'mkg' },
  { n: 'Dhatki', i: 'mki' },
  { n: 'Mokilese', i: 'mkj' },
  { n: 'Byep', i: 'mkk' },
  { n: 'Mokole', i: 'mkl' },
  { n: 'Moklen', i: 'mkm' },
  { n: 'Kupang Malay', i: 'mkn' },
  { n: 'Mingang Doso', i: 'mko' },
  { n: 'Moikodi', i: 'mkp' },
  { n: 'Malas', i: 'mkr' },
  { n: 'Silacayoapan Mixtec', i: 'mks' },
  { n: 'Vamale', i: 'mkt' },
  { n: 'Konyanka Maninka', i: 'mku' },
  { n: 'Mafea', i: 'mkv' },
  { n: 'Kituba (Congo)', i: 'mkw' },
  { n: 'Kinamiging Manobo', i: 'mkx' },
  { n: 'East Makian', i: 'mky' },
  { n: 'Makasae', i: 'mkz' },
  { n: 'Malo', i: 'mla' },
  { n: 'Mbule', i: 'mlb' },
  { n: 'Cao Lan', i: 'mlc' },
  { n: 'Manambu', i: 'mle' },
  { n: 'Mal', i: 'mlf' },
  { n: 'Mape', i: 'mlh' },
  { n: 'Malimpung', i: 'mli' },
  { n: 'Miltu', i: 'mlj' },
  { n: 'Ilwana', i: 'mlk' },
  { n: 'Malua Bay', i: 'mll' },
  { n: 'Mulam', i: 'mlm' },
  { n: 'Malango', i: 'mln' },
  { n: 'Mlomp', i: 'mlo' },
  { n: 'Bargam', i: 'mlp' },
  { n: 'Western Maninkakan', i: 'mlq' },
  { n: 'Vame', i: 'mlr' },
  { n: 'Masalit', i: 'mls' },
  { n: 'Maltese', i: 'mlt' },
  { n: "To'abaita", i: 'mlu' },
  { n: 'Motlav', i: 'mlv' },
  { n: 'Moloko', i: 'mlw' },
  { n: 'Malfaxal', i: 'mlx' },
  { n: 'Malaynon', i: 'mlz' },
  { n: 'Mama', i: 'mma' },
  { n: 'Momina', i: 'mmb' },
  { n: 'Michoacán Mazahua', i: 'mmc' },
  { n: 'Maonan', i: 'mmd' },
  { n: 'Mae', i: 'mme' },
  { n: 'Mundat', i: 'mmf' },
  { n: 'North Ambrym', i: 'mmg' },
  { n: 'Mehináku', i: 'mmh' },
  { n: 'Musar', i: 'mmi' },
  { n: 'Majhwar', i: 'mmj' },
  { n: 'Mukha-Dora', i: 'mmk' },
  { n: 'Man Met', i: 'mml' },
  { n: 'Maii', i: 'mmm' },
  { n: 'Mamanwa', i: 'mmn' },
  { n: 'Mangga Buang', i: 'mmo' },
  { n: 'Siawi', i: 'mmp' },
  { n: 'Musak', i: 'mmq' },
  { n: 'Western Xiangxi Miao', i: 'mmr' },
  { n: 'Malalamai', i: 'mmt' },
  { n: 'Mmaala', i: 'mmu' },
  { n: 'Emae', i: 'mmw' },
  { n: 'Madak', i: 'mmx' },
  { n: 'Migaama', i: 'mmy' },
  { n: 'Mabaale', i: 'mmz' },
  { n: 'Mbula', i: 'mna' },
  { n: 'Muna', i: 'mnb' },
  { n: 'Manchu', i: 'mnc' },
  { n: 'Mondé', i: 'mnd' },
  { n: 'Naba', i: 'mne' },
  { n: 'Mundani', i: 'mnf' },
  { n: 'Eastern Mnong', i: 'mng' },
  { n: 'Mono (Democratic Republic of Congo)', i: 'mnh' },
  { n: 'Manipuri', i: 'mni' },
  { n: 'Munji', i: 'mnj' },
  { n: 'Mandinka', i: 'mnk' },
  { n: 'Tiale', i: 'mnl' },
  { n: 'Mapena', i: 'mnm' },
  { n: 'Southern Mnong', i: 'mnn' },
  { n: 'Min Bei Chinese', i: 'mnp' },
  { n: 'Minriq', i: 'mnq' },
  { n: 'Mono (USA)', i: 'mnr' },
  { n: 'Mansi', i: 'mns' },
  { n: 'Mer', i: 'mnu' },
  { n: 'Rennell-Bellona', i: 'mnv' },
  { n: 'Mon', i: 'mnw' },
  { n: 'Manikion', i: 'mnx' },
  { n: 'Manyawa', i: 'mny' },
  { n: 'Moni', i: 'mnz' },
  { n: 'Mwan', i: 'moa' },
  { n: 'Mocoví', i: 'moc' },
  { n: 'Innu', i: 'moe' },
  { n: 'Mongondow', i: 'mog' },
  { n: 'Mohawk', i: 'moh' },
  { n: 'Mboi', i: 'moi' },
  { n: 'Monzombo', i: 'moj' },
  { n: 'Morori', i: 'mok' },
  { n: 'Monom', i: 'moo' },
  { n: 'Mopán Maya', i: 'mop' },
  { n: 'Mor (Bomberai Peninsula)', i: 'moq' },
  { n: 'Moro', i: 'mor' },
  { n: 'Mossi', i: 'mos' },
  { n: 'Barí', i: 'mot' },
  { n: 'Mogum', i: 'mou' },
  { n: 'Mohave', i: 'mov' },
  { n: 'Moi (Congo)', i: 'mow' },
  { n: 'Molima', i: 'mox' },
  { n: 'Shekkacho', i: 'moy' },
  { n: 'Mukulu', i: 'moz' },
  { n: 'Mpoto', i: 'mpa' },
  { n: 'Malak Malak', i: 'mpb' },
  { n: 'Mangarrayi', i: 'mpc' },
  { n: 'Machinere', i: 'mpd' },
  { n: 'Majang', i: 'mpe' },
  { n: 'Marba', i: 'mpg' },
  { n: 'Maung', i: 'mph' },
  { n: 'Mpade', i: 'mpi' },
  { n: 'Martu Wangka', i: 'mpj' },
  { n: 'Mbara (Chad)', i: 'mpk' },
  { n: 'Middle Watut', i: 'mpl' },
  { n: 'Yosondúa Mixtec', i: 'mpm' },
  { n: 'Mindiri', i: 'mpn' },
  { n: 'Miu', i: 'mpo' },
  { n: 'Migabac', i: 'mpp' },
  { n: 'Matís', i: 'mpq' },
  { n: 'Vangunu', i: 'mpr' },
  { n: 'Dadibi', i: 'mps' },
  { n: 'Mian', i: 'mpt' },
  { n: 'Makuráp', i: 'mpu' },
  { n: 'Mungkip', i: 'mpv' },
  { n: 'Mapidian', i: 'mpw' },
  { n: 'Misima-Panaeati', i: 'mpx' },
  { n: 'Mapia', i: 'mpy' },
  { n: 'Mpi', i: 'mpz' },
  { n: 'Maba (Indonesia)', i: 'mqa' },
  { n: 'Mbuko', i: 'mqb' },
  { n: 'Mangole', i: 'mqc' },
  { n: 'Matepi', i: 'mqe' },
  { n: 'Momuna', i: 'mqf' },
  { n: 'Kota Bangun Kutai Malay', i: 'mqg' },
  { n: 'Tlazoyaltepec Mixtec', i: 'mqh' },
  { n: 'Mariri', i: 'mqi' },
  { n: 'Mamasa', i: 'mqj' },
  { n: 'Rajah Kabunsuwan Manobo', i: 'mqk' },
  { n: 'Mbelime', i: 'mql' },
  { n: 'South Marquesan', i: 'mqm' },
  { n: 'Moronene', i: 'mqn' },
  { n: 'Modole', i: 'mqo' },
  { n: 'Manipa', i: 'mqp' },
  { n: 'Minokok', i: 'mqq' },
  { n: 'Mander', i: 'mqr' },
  { n: 'West Makian', i: 'mqs' },
  { n: 'Mok', i: 'mqt' },
  { n: 'Mandari', i: 'mqu' },
  { n: 'Mosimo', i: 'mqv' },
  { n: 'Murupi', i: 'mqw' },
  { n: 'Mamuju', i: 'mqx' },
  { n: 'Manggarai', i: 'mqy' },
  { n: 'Pano', i: 'mqz' },
  { n: 'Mlabri', i: 'mra' },
  { n: 'Marino', i: 'mrb' },
  { n: 'Maricopa', i: 'mrc' },
  { n: 'Western Magar', i: 'mrd' },
  { n: 'Elseng', i: 'mrf' },
  { n: 'Mising', i: 'mrg' },
  { n: 'Mara Chin', i: 'mrh' },
  { n: 'Maori', i: 'mri' },
  { n: 'Western Mari', i: 'mrj' },
  { n: 'Hmwaveke', i: 'mrk' },
  { n: 'Mortlockese', i: 'mrl' },
  { n: 'Merlav', i: 'mrm' },
  { n: 'Cheke Holo', i: 'mrn' },
  { n: 'Mru', i: 'mro' },
  { n: 'Morouas', i: 'mrp' },
  { n: 'North Marquesan', i: 'mrq' },
  { n: 'Maria (India)', i: 'mrr' },
  { n: 'Maragus', i: 'mrs' },
  { n: 'Marghi Central', i: 'mrt' },
  { n: 'Mono (Cameroon)', i: 'mru' },
  { n: 'Mangareva', i: 'mrv' },
  { n: 'Maranao', i: 'mrw' },
  { n: 'Maremgi', i: 'mrx' },
  { n: 'Mandaya', i: 'mry' },
  { n: 'Marind', i: 'mrz' },
  { n: 'Masbatenyo', i: 'msb' },
  { n: 'Sankaran Maninka', i: 'msc' },
  { n: 'Yucatec Maya Sign Language', i: 'msd' },
  { n: 'Musey', i: 'mse' },
  { n: 'Mekwei', i: 'msf' },
  { n: 'Moraid', i: 'msg' },
  { n: 'Masikoro Malagasy', i: 'msh' },
  { n: 'Sabah Malay', i: 'msi' },
  { n: 'Ma (Democratic Republic of Congo)', i: 'msj' },
  { n: 'Mansaka', i: 'msk' },
  { n: 'Molof', i: 'msl' },
  { n: 'Agusan Manobo', i: 'msm' },
  { n: 'Vurës', i: 'msn' },
  { n: 'Mombum', i: 'mso' },
  { n: 'Caac', i: 'msq' },
  { n: 'Mongolian Sign Language', i: 'msr' },
  { n: 'West Masela', i: 'mss' },
  { n: 'Musom', i: 'msu' },
  { n: 'Maslam', i: 'msv' },
  { n: 'Mansoanka', i: 'msw' },
  { n: 'Moresada', i: 'msx' },
  { n: 'Aruamu', i: 'msy' },
  { n: 'Momare', i: 'msz' },
  { n: 'Cotabato Manobo', i: 'mta' },
  { n: 'Anyin Morofo', i: 'mtb' },
  { n: 'Munit', i: 'mtc' },
  { n: 'Mualang', i: 'mtd' },
  { n: 'Mono (Solomon Islands)', i: 'mte' },
  { n: 'Murik (Papua New Guinea)', i: 'mtf' },
  { n: 'Una', i: 'mtg' },
  { n: 'Munggui', i: 'mth' },
  { n: 'Maiwa (Papua New Guinea)', i: 'mti' },
  { n: 'Moskona', i: 'mtj' },
  { n: "Mbe'", i: 'mtk' },
  { n: 'Montol', i: 'mtl' },
  { n: 'Totontepec Mixe', i: 'mto' },
  { n: 'Wichí Lhamtés Nocten', i: 'mtp' },
  { n: 'Muong', i: 'mtq' },
  { n: 'Mewari', i: 'mtr' },
  { n: 'Yora', i: 'mts' },
  { n: 'Mota', i: 'mtt' },
  { n: 'Tututepec Mixtec', i: 'mtu' },
  { n: "Asaro'o", i: 'mtv' },
  { n: 'Southern Binukidnon', i: 'mtw' },
  { n: 'Tidaá Mixtec', i: 'mtx' },
  { n: 'Nabi', i: 'mty' },
  { n: 'Mundang', i: 'mua' },
  { n: 'Mubi', i: 'mub' },
  { n: 'Ajumbu', i: 'muc' },
  { n: 'Mednyj Aleut', i: 'mud' },
  { n: 'Media Lengua', i: 'mue' },
  { n: 'Musgu', i: 'mug' },
  { n: 'Mündü', i: 'muh' },
  { n: 'Musi', i: 'mui' },
  { n: 'Mabire', i: 'muj' },
  { n: 'Mugom', i: 'muk' },
  { n: 'Maiwala', i: 'mum' },
  { n: 'Nyong', i: 'muo' },
  { n: 'Malvi', i: 'mup' },
  { n: 'Eastern Xiangxi Miao', i: 'muq' },
  { n: 'Murle', i: 'mur' },
  { n: 'Creek', i: 'mus' },
  { n: 'Western Muria', i: 'mut' },
  { n: 'Yaaku', i: 'muu' },
  { n: 'Muthuvan', i: 'muv' },
  { n: 'Bo-Ung', i: 'mux' },
  { n: 'Muyang', i: 'muy' },
  { n: 'Mursi', i: 'muz' },
  { n: 'Manam', i: 'mva' },
  { n: 'Mamboru', i: 'mvd' },
  { n: 'Marwari (Pakistan)', i: 'mve' },
  { n: 'Peripheral Mongolian', i: 'mvf' },
  { n: 'Yucuañe Mixtec', i: 'mvg' },
  { n: 'Mulgi', i: 'mvh' },
  { n: 'Miyako', i: 'mvi' },
  { n: 'Mekmek', i: 'mvk' },
  { n: 'Muya', i: 'mvm' },
  { n: 'Minaveha', i: 'mvn' },
  { n: 'Marovo', i: 'mvo' },
  { n: 'Duri', i: 'mvp' },
  { n: 'Moere', i: 'mvq' },
  { n: 'Marau', i: 'mvr' },
  { n: 'Massep', i: 'mvs' },
  { n: 'Mpotovoro', i: 'mvt' },
  { n: 'Marfa', i: 'mvu' },
  { n: 'Tagal Murut', i: 'mvv' },
  { n: 'Machinga', i: 'mvw' },
  { n: 'Meoswar', i: 'mvx' },
  { n: 'Indus Kohistani', i: 'mvy' },
  { n: 'Mesqan', i: 'mvz' },
  { n: 'Mwatebu', i: 'mwa' },
  { n: 'Juwal', i: 'mwb' },
  { n: 'Are', i: 'mwc' },
  { n: 'Mwera (Chimwera)', i: 'mwe' },
  { n: 'Murrinh-Patha', i: 'mwf' },
  { n: 'Aiklep', i: 'mwg' },
  { n: 'Mouk-Aria', i: 'mwh' },
  { n: 'Labo', i: 'mwi' },
  { n: 'Kita Maninkakan', i: 'mwk' },
  { n: 'Mirandese', i: 'mwl' },
  { n: 'Sar', i: 'mwm' },
  { n: 'Nyamwanga', i: 'mwn' },
  { n: 'Central Maewo', i: 'mwo' },
  { n: 'Kala Lagaw Ya', i: 'mwp' },
  { n: 'Mün Chin', i: 'mwq' },
  { n: 'Mwimbi-Muthambi', i: 'mws' },
  { n: 'Moken', i: 'mwt' },
  { n: 'Mentawai', i: 'mwv' },
  { n: 'Hmong Daw', i: 'mww' },
  { n: 'Moingi', i: 'mwz' },
  { n: 'Northwest Oaxaca Mixtec', i: 'mxa' },
  { n: 'Tezoatlán Mixtec', i: 'mxb' },
  { n: 'Manyika', i: 'mxc' },
  { n: 'Modang', i: 'mxd' },
  { n: 'Mele-Fila', i: 'mxe' },
  { n: 'Malgbe', i: 'mxf' },
  { n: 'Mbangala', i: 'mxg' },
  { n: 'Mvuba', i: 'mxh' },
  { n: 'Miju-Mishmi', i: 'mxj' },
  { n: 'Monumbo', i: 'mxk' },
  { n: 'Maxi Gbe', i: 'mxl' },
  { n: 'Meramera', i: 'mxm' },
  { n: 'Moi (Indonesia)', i: 'mxn' },
  { n: 'Mbowe', i: 'mxo' },
  { n: 'Tlahuitoltepec Mixe', i: 'mxp' },
  { n: 'Juquila Mixe', i: 'mxq' },
  { n: 'Murik (Malaysia)', i: 'mxr' },
  { n: 'Huitepec Mixtec', i: 'mxs' },
  { n: 'Jamiltepec Mixtec', i: 'mxt' },
  { n: 'Mada (Cameroon)', i: 'mxu' },
  { n: 'Metlatónoc Mixtec', i: 'mxv' },
  { n: 'Namo', i: 'mxw' },
  { n: 'Mahou', i: 'mxx' },
  { n: 'Southeastern Nochixtlán Mixtec', i: 'mxy' },
  { n: 'Central Masela', i: 'mxz' },
  { n: 'Burmese', i: 'mya' },
  { n: 'Mbay', i: 'myb' },
  { n: 'Mayeka', i: 'myc' },
  { n: 'Myene', i: 'mye' },
  { n: 'Bambassi', i: 'myf' },
  { n: 'Manta', i: 'myg' },
  { n: 'Makah', i: 'myh' },
  { n: 'Mangayat', i: 'myj' },
  { n: 'Mamara Senoufo', i: 'myk' },
  { n: 'Moma', i: 'myl' },
  { n: "Me'en", i: 'mym' },
  { n: 'Anfillo', i: 'myo' },
  { n: 'Pirahã', i: 'myp' },
  { n: 'Muniche', i: 'myr' },
  { n: 'Mundurukú', i: 'myu' },
  { n: 'Erzya', i: 'myv' },
  { n: 'Muyuw', i: 'myw' },
  { n: 'Masaaba', i: 'myx' },
  { n: 'Macuna', i: 'myy' },
  { n: 'Santa María Zacatepec Mixtec', i: 'mza' },
  { n: 'Tumzabt', i: 'mzb' },
  { n: 'Madagascar Sign Language', i: 'mzc' },
  { n: 'Malimba', i: 'mzd' },
  { n: 'Morawa', i: 'mze' },
  { n: 'Monastic Sign Language', i: 'mzg' },
  { n: 'Wichí Lhamtés Güisnay', i: 'mzh' },
  { n: 'Ixcatlán Mazatec', i: 'mzi' },
  { n: 'Manya', i: 'mzj' },
  { n: 'Nigeria Mambila', i: 'mzk' },
  { n: 'Mazatlán Mixe', i: 'mzl' },
  { n: 'Mumuye', i: 'mzm' },
  { n: 'Mazanderani', i: 'mzn' },
  { n: 'Movima', i: 'mzp' },
  { n: 'Mori Atas', i: 'mzq' },
  { n: 'Marúbo', i: 'mzr' },
  { n: 'Macanese', i: 'mzs' },
  { n: 'Mintil', i: 'mzt' },
  { n: 'Inapang', i: 'mzu' },
  { n: 'Manza', i: 'mzv' },
  { n: 'Deg', i: 'mzw' },
  { n: 'Mawayana', i: 'mzx' },
  { n: 'Mozambican Sign Language', i: 'mzy' },
  { n: 'Maiadomu', i: 'mzz' },
  { n: 'Namla', i: 'naa' },
  { n: 'Southern Nambikuára', i: 'nab' },
  { n: 'Narak', i: 'nac' },
  { n: 'Nabak', i: 'naf' },
  { n: 'Naga Pidgin', i: 'nag' },
  { n: 'Nalu', i: 'naj' },
  { n: 'Nakanai', i: 'nak' },
  { n: 'Nalik', i: 'nal' },
  { n: "Ngan'gityemerri", i: 'nam' },
  { n: 'Min Nan Chinese', i: 'nan' },
  { n: 'Naaba', i: 'nao' },
  { n: 'Neapolitan', i: 'nap' },
  { n: 'Khoekhoe', i: 'naq' },
  { n: 'Iguta', i: 'nar' },
  { n: 'Naasioi', i: 'nas' },
  { n: 'Ca̱hungwa̱rya̱', i: 'nat' },
  { n: 'Nauru', i: 'nau' },
  { n: 'Navajo', i: 'nav' },
  { n: 'Nawuri', i: 'naw' },
  { n: 'Nakwi', i: 'nax' },
  { n: 'Coatepec Nahuatl', i: 'naz' },
  { n: 'Nyemba', i: 'nba' },
  { n: 'Ndoe', i: 'nbb' },
  { n: 'Chang Naga', i: 'nbc' },
  { n: 'Ngbinda', i: 'nbd' },
  { n: 'Konyak Naga', i: 'nbe' },
  { n: 'Nagarchal', i: 'nbg' },
  { n: 'Ngamo', i: 'nbh' },
  { n: 'Mao Naga', i: 'nbi' },
  { n: 'Ngarinyman', i: 'nbj' },
  { n: 'Nake', i: 'nbk' },
  { n: 'South Ndebele', i: 'nbl' },
  { n: "Ngbaka Ma'bo", i: 'nbm' },
  { n: 'Kuri', i: 'nbn' },
  { n: 'Nkukoli', i: 'nbo' },
  { n: 'Nnam', i: 'nbp' },
  { n: 'Nggem', i: 'nbq' },
  { n: 'Numana', i: 'nbr' },
  { n: 'Namibian Sign Language', i: 'nbs' },
  { n: 'Na', i: 'nbt' },
  { n: 'Rongmei Naga', i: 'nbu' },
  { n: 'Ngamambo', i: 'nbv' },
  { n: 'Southern Ngbandi', i: 'nbw' },
  { n: 'Ningera', i: 'nby' },
  { n: 'Iyo', i: 'nca' },
  { n: 'Central Nicobarese', i: 'ncb' },
  { n: 'Ponam', i: 'ncc' },
  { n: 'Nachering', i: 'ncd' },
  { n: 'Yale', i: 'nce' },
  { n: 'Notsi', i: 'ncf' },
  { n: "Nisga'a", i: 'ncg' },
  { n: 'Central Huasteca Nahuatl', i: 'nch' },
  { n: 'Northern Puebla Nahuatl', i: 'ncj' },
  { n: 'Na-kara', i: 'nck' },
  { n: 'Michoacán Nahuatl', i: 'ncl' },
  { n: 'Nambo', i: 'ncm' },
  { n: 'Nauna', i: 'ncn' },
  { n: 'Sibe', i: 'nco' },
  { n: 'Northern Katang', i: 'ncq' },
  { n: 'Ncane', i: 'ncr' },
  { n: 'Nicaraguan Sign Language', i: 'ncs' },
  { n: 'Chothe Naga', i: 'nct' },
  { n: 'Chumburung', i: 'ncu' },
  { n: 'Central Puebla Nahuatl', i: 'ncx' },
  { n: 'Ndasa', i: 'nda' },
  { n: 'Kenswei Nsei', i: 'ndb' },
  { n: 'Ndau', i: 'ndc' },
  { n: 'Nde-Nsele-Nta', i: 'ndd' },
  { n: 'North Ndebele', i: 'nde' },
  { n: 'Ndengereko', i: 'ndg' },
  { n: 'Ndali', i: 'ndh' },
  { n: 'Samba Leko', i: 'ndi' },
  { n: 'Ndamba', i: 'ndj' },
  { n: 'Ndaka', i: 'ndk' },
  { n: 'Ndolo', i: 'ndl' },
  { n: 'Ndam', i: 'ndm' },
  { n: 'Ngundi', i: 'ndn' },
  { n: 'Ndonga', i: 'ndo' },
  { n: 'Ndo', i: 'ndp' },
  { n: 'Ndombe', i: 'ndq' },
  { n: 'Ndoola', i: 'ndr' },
  { n: 'Low German', i: 'nds' },
  { n: 'Ndunga', i: 'ndt' },
  { n: 'Dugun', i: 'ndu' },
  { n: 'Ndut', i: 'ndv' },
  { n: 'Ndobo', i: 'ndw' },
  { n: 'Nduga', i: 'ndx' },
  { n: 'Lutos', i: 'ndy' },
  { n: 'Ndogo', i: 'ndz' },
  { n: "Eastern Ngad'a", i: 'nea' },
  { n: "Toura (Côte d'Ivoire)", i: 'neb' },
  { n: 'Nedebang', i: 'nec' },
  { n: 'Nde-Gbite', i: 'ned' },
  { n: 'Nêlêmwa-Nixumwak', i: 'nee' },
  { n: 'Nefamese', i: 'nef' },
  { n: 'Negidal', i: 'neg' },
  { n: 'Nyenkha', i: 'neh' },
  { n: 'Neko', i: 'nej' },
  { n: 'Neku', i: 'nek' },
  { n: 'Nemi', i: 'nem' },
  { n: 'Nengone', i: 'nen' },
  { n: 'Ná-Meo', i: 'neo' },
  { n: 'North Central Mixe', i: 'neq' },
  { n: 'Yahadian', i: 'ner' },
  { n: 'Bhoti Kinnauri', i: 'nes' },
  { n: 'Nete', i: 'net' },
  { n: 'Nyaheun', i: 'nev' },
  { n: 'Newari', i: 'new' },
  { n: 'Neme', i: 'nex' },
  { n: 'Neyo', i: 'ney' },
  { n: 'Nez Perce', i: 'nez' },
  { n: 'Dhao', i: 'nfa' },
  { n: 'Ahwai', i: 'nfd' },
  { n: 'Ayiwo', i: 'nfl' },
  { n: 'Nafaanra', i: 'nfr' },
  { n: 'Mfumte', i: 'nfu' },
  { n: 'Ngbaka', i: 'nga' },
  { n: 'Northern Ngbandi', i: 'ngb' },
  { n: 'Ngombe (Democratic Republic of Congo)', i: 'ngc' },
  { n: 'Ngando (Central African Republic)', i: 'ngd' },
  { n: 'Ngemba', i: 'nge' },
  { n: 'Ngbaka Manza', i: 'ngg' },
  { n: 'Nǁng', i: 'ngh' },
  { n: 'Ngizim', i: 'ngi' },
  { n: 'Ngie', i: 'ngj' },
  { n: 'Dalabon', i: 'ngk' },
  { n: 'Lomwe', i: 'ngl' },
  { n: "Ngatik Men's Creole", i: 'ngm' },
  { n: 'Ngwo', i: 'ngn' },
  { n: 'Ngoni', i: 'ngo' },
  { n: 'Ngulu', i: 'ngp' },
  { n: 'Ngurimi', i: 'ngq' },
  { n: 'Engdewu', i: 'ngr' },
  { n: 'Gvoko', i: 'ngs' },
  { n: 'Kriang', i: 'ngt' },
  { n: 'Guerrero Nahuatl', i: 'ngu' },
  { n: 'Ngwaba', i: 'ngw' },
  { n: 'Nggwahyi', i: 'ngx' },
  { n: 'Tibea', i: 'ngy' },
  { n: 'Ngungwel', i: 'ngz' },
  { n: 'Nhanda', i: 'nha' },
  { n: 'Beng', i: 'nhb' },
  { n: 'Chiripá', i: 'nhd' },
  { n: 'Eastern Huasteca Nahuatl', i: 'nhe' },
  { n: 'Nhuwala', i: 'nhf' },
  { n: 'Tetelcingo Nahuatl', i: 'nhg' },
  { n: 'Nahari', i: 'nhh' },
  { n: 'Zacatlán-Ahuacatlán-Tepetzintla Nahuatl', i: 'nhi' },
  { n: 'Isthmus-Cosoleacaque Nahuatl', i: 'nhk' },
  { n: 'Morelos Nahuatl', i: 'nhm' },
  { n: 'Central Nahuatl', i: 'nhn' },
  { n: 'Takuu', i: 'nho' },
  { n: 'Isthmus-Pajapan Nahuatl', i: 'nhp' },
  { n: 'Huaxcaleca Nahuatl', i: 'nhq' },
  { n: 'Naro', i: 'nhr' },
  { n: 'Ometepec Nahuatl', i: 'nht' },
  { n: 'Noone', i: 'nhu' },
  { n: 'Temascaltepec Nahuatl', i: 'nhv' },
  { n: 'Western Huasteca Nahuatl', i: 'nhw' },
  { n: 'Isthmus-Mecayapan Nahuatl', i: 'nhx' },
  { n: 'Northern Oaxaca Nahuatl', i: 'nhy' },
  { n: 'Santa María La Alta Nahuatl', i: 'nhz' },
  { n: 'Nias', i: 'nia' },
  { n: 'Nakame', i: 'nib' },
  { n: 'Niellim', i: 'nie' },
  { n: 'Nek', i: 'nif' },
  { n: 'Nyiha (Tanzania)', i: 'nih' },
  { n: 'Nii', i: 'nii' },
  { n: 'Ngaju', i: 'nij' },
  { n: 'Southern Nicobarese', i: 'nik' },
  { n: 'Nila', i: 'nil' },
  { n: 'Nilamba', i: 'nim' },
  { n: 'Ninzo', i: 'nin' },
  { n: 'Nganasan', i: 'nio' },
  { n: 'Nandi', i: 'niq' },
  { n: 'Nimboran', i: 'nir' },
  { n: 'Nimi', i: 'nis' },
  { n: 'Southeastern Kolami', i: 'nit' },
  { n: 'Niuean', i: 'niu' },
  { n: 'Gilyak', i: 'niv' },
  { n: 'Nimo', i: 'niw' },
  { n: 'Hema', i: 'nix' },
  { n: 'Ngiti', i: 'niy' },
  { n: 'Ningil', i: 'niz' },
  { n: 'Nzanyi', i: 'nja' },
  { n: 'Nocte Naga', i: 'njb' },
  { n: 'Ndonde Hamba', i: 'njd' },
  { n: 'Lotha Naga', i: 'njh' },
  { n: 'Gudanji', i: 'nji' },
  { n: 'Njen', i: 'njj' },
  { n: 'Njalgulgule', i: 'njl' },
  { n: 'Angami Naga', i: 'njm' },
  { n: 'Liangmai Naga', i: 'njn' },
  { n: 'Ao Naga', i: 'njo' },
  { n: 'Njerep', i: 'njr' },
  { n: 'Nisa', i: 'njs' },
  { n: 'Ndyuka-Trio Pidgin', i: 'njt' },
  { n: 'Ngadjunmaya', i: 'nju' },
  { n: 'Kunyi', i: 'njx' },
  { n: 'Njyem', i: 'njy' },
  { n: 'Nyishi', i: 'njz' },
  { n: 'Nkoya', i: 'nka' },
  { n: 'Khoibu Naga', i: 'nkb' },
  { n: 'Nkongho', i: 'nkc' },
  { n: 'Koireng', i: 'nkd' },
  { n: 'Duke', i: 'nke' },
  { n: 'Inpui Naga', i: 'nkf' },
  { n: 'Nekgini', i: 'nkg' },
  { n: 'Khezha Naga', i: 'nkh' },
  { n: 'Thangal Naga', i: 'nki' },
  { n: 'Nakai', i: 'nkj' },
  { n: 'Nokuku', i: 'nkk' },
  { n: 'Namat', i: 'nkm' },
  { n: 'Nkangala', i: 'nkn' },
  { n: 'Nkonya', i: 'nko' },
  { n: 'Nkami', i: 'nkq' },
  { n: 'Nukuoro', i: 'nkr' },
  { n: 'North Asmat', i: 'nks' },
  { n: 'Nyika (Tanzania)', i: 'nkt' },
  { n: 'Bouna Kulango', i: 'nku' },
  { n: 'Nyika (Malawi and Zambia)', i: 'nkv' },
  { n: 'Nkutu', i: 'nkw' },
  { n: 'Nkoroo', i: 'nkx' },
  { n: 'Nkari', i: 'nkz' },
  { n: 'Ngombale', i: 'nla' },
  { n: 'Nalca', i: 'nlc' },
  { n: 'Dutch', i: 'nld' },
  { n: 'East Nyala', i: 'nle' },
  { n: 'Gela', i: 'nlg' },
  { n: 'Grangali', i: 'nli' },
  { n: 'Nyali', i: 'nlj' },
  { n: 'Ninia Yali', i: 'nlk' },
  { n: 'Nihali', i: 'nll' },
  { n: 'Mankiyali', i: 'nlm' },
  { n: 'Ngul', i: 'nlo' },
  { n: 'Lao Naga', i: 'nlq' },
  { n: 'Nchumbulu', i: 'nlu' },
  { n: 'Orizaba Nahuatl', i: 'nlv' },
  { n: 'Nahali', i: 'nlx' },
  { n: 'Nyamal', i: 'nly' },
  { n: 'Nalögo', i: 'nlz' },
  { n: 'Maram Naga', i: 'nma' },
  { n: 'Big Nambas', i: 'nmb' },
  { n: 'Ngam', i: 'nmc' },
  { n: 'Ndumu', i: 'nmd' },
  { n: 'Mzieme Naga', i: 'nme' },
  { n: 'Tangkhul Naga (India)', i: 'nmf' },
  { n: 'Kwasio', i: 'nmg' },
  { n: 'Monsang Naga', i: 'nmh' },
  { n: 'Nyam', i: 'nmi' },
  { n: 'Ngombe (Central African Republic)', i: 'nmj' },
  { n: 'Namakura', i: 'nmk' },
  { n: 'Ndemli', i: 'nml' },
  { n: 'Manangba', i: 'nmm' },
  { n: 'ǃXóõ', i: 'nmn' },
  { n: 'Moyon Naga', i: 'nmo' },
  { n: 'Nambya', i: 'nmq' },
  { n: 'Letemboi', i: 'nms' },
  { n: 'Namonuito', i: 'nmt' },
  { n: 'Northeast Maidu', i: 'nmu' },
  { n: 'Nimoa', i: 'nmw' },
  { n: 'Nama (Papua New Guinea)', i: 'nmx' },
  { n: 'Namuyi', i: 'nmy' },
  { n: 'Nawdm', i: 'nmz' },
  { n: 'Nyangumarta', i: 'nna' },
  { n: 'Nande', i: 'nnb' },
  { n: 'Nancere', i: 'nnc' },
  { n: 'West Ambae', i: 'nnd' },
  { n: 'Ngandyera', i: 'nne' },
  { n: 'Ngaing', i: 'nnf' },
  { n: 'Maring Naga', i: 'nng' },
  { n: 'Ngiemboon', i: 'nnh' },
  { n: 'North Nuaulu', i: 'nni' },
  { n: 'Nyangatom', i: 'nnj' },
  { n: 'Nankina', i: 'nnk' },
  { n: 'Northern Rengma Naga', i: 'nnl' },
  { n: 'Namia', i: 'nnm' },
  { n: 'Ngete', i: 'nnn' },
  { n: 'Norwegian Nynorsk', i: 'nno' },
  { n: 'Wancho Naga', i: 'nnp' },
  { n: 'Ngindo', i: 'nnq' },
  { n: 'Dwang', i: 'nnu' },
  { n: 'Southern Nuni', i: 'nnw' },
  { n: "Nda'nda'", i: 'nnz' },
  { n: 'Woun Meu', i: 'noa' },
  { n: 'Norwegian Bokmål', i: 'nob' },
  { n: 'Nuk', i: 'noc' },
  { n: 'Northern Thai', i: 'nod' },
  { n: 'Nimadi', i: 'noe' },
  { n: 'Nomane', i: 'nof' },
  { n: 'Nogai', i: 'nog' },
  { n: 'Nomu', i: 'noh' },
  { n: 'Noiri', i: 'noi' },
  { n: 'Nonuya', i: 'noj' },
  { n: 'Numanggang', i: 'nop' },
  { n: 'Ngongo', i: 'noq' },
  { n: 'Eastern Nisu', i: 'nos' },
  { n: 'Nomatsiguenga', i: 'not' },
  { n: 'Ewage-Notu', i: 'nou' },
  { n: 'Nyambo', i: 'now' },
  { n: 'Noy', i: 'noy' },
  { n: 'Nayi', i: 'noz' },
  { n: 'Nar Phu', i: 'npa' },
  { n: 'Nupbikha', i: 'npb' },
  { n: 'Ponyo-Gongwang Naga', i: 'npg' },
  { n: 'Phom Naga', i: 'nph' },
  { n: 'Nepali (individual language)', i: 'npi' },
  { n: 'Southeastern Puebla Nahuatl', i: 'npl' },
  { n: 'Mondropolon', i: 'npn' },
  { n: 'Pochuri Naga', i: 'npo' },
  { n: 'Nipsan', i: 'nps' },
  { n: 'Puimei Naga', i: 'npu' },
  { n: 'Noipx', i: 'npx' },
  { n: 'Napu', i: 'npy' },
  { n: 'Southern Nago', i: 'nqg' },
  { n: 'Kura Ede Nago', i: 'nqk' },
  { n: 'Ngendelengo', i: 'nql' },
  { n: 'Ndom', i: 'nqm' },
  { n: 'Nen', i: 'nqn' },
  { n: "N'Ko", i: 'nqo' },
  { n: 'Kyan-Karyaw Naga', i: 'nqq' },
  { n: 'Akyaung Ari Naga', i: 'nqy' },
  { n: 'Ngom', i: 'nra' },
  { n: 'Nara', i: 'nrb' },
  { n: 'Southern Rengma Naga', i: 'nre' },
  { n: 'Jèrriais', i: 'nrf' },
  { n: 'Narango', i: 'nrg' },
  { n: 'Chokri Naga', i: 'nri' },
  { n: 'Ngarla', i: 'nrk' },
  { n: 'Ngarluma', i: 'nrl' },
  { n: 'Narom', i: 'nrm' },
  { n: 'Narua', i: 'nru' },
  { n: 'Lala', i: 'nrz' },
  { n: 'Sangtam Naga', i: 'nsa' },
  { n: 'Nshi', i: 'nsc' },
  { n: 'Southern Nisu', i: 'nsd' },
  { n: 'Nsenga', i: 'nse' },
  { n: 'Northwestern Nisu', i: 'nsf' },
  { n: 'Ngasa', i: 'nsg' },
  { n: 'Ngoshie', i: 'nsh' },
  { n: 'Nigerian Sign Language', i: 'nsi' },
  { n: 'Naskapi', i: 'nsk' },
  { n: 'Norwegian Sign Language', i: 'nsl' },
  { n: 'Sumi Naga', i: 'nsm' },
  { n: 'Nehan', i: 'nsn' },
  { n: 'Pedi', i: 'nso' },
  { n: 'Nepalese Sign Language', i: 'nsp' },
  { n: 'Northern Sierra Miwok', i: 'nsq' },
  { n: 'Maritime Sign Language', i: 'nsr' },
  { n: 'Nali', i: 'nss' },
  { n: 'Tase Naga', i: 'nst' },
  { n: 'Sierra Negra Nahuatl', i: 'nsu' },
  { n: 'Southwestern Nisu', i: 'nsv' },
  { n: 'Navut', i: 'nsw' },
  { n: 'Nsongo', i: 'nsx' },
  { n: 'Nasal', i: 'nsy' },
  { n: 'Nisenan', i: 'nsz' },
  { n: 'Northern Tidung', i: 'ntd' },
  { n: 'Nathembo', i: 'nte' },
  { n: 'Natioro', i: 'nti' },
  { n: 'Ngaanyatjarra', i: 'ntj' },
  { n: 'Ikoma-Nata-Isenye', i: 'ntk' },
  { n: 'Nateni', i: 'ntm' },
  { n: 'Ntomba', i: 'nto' },
  { n: 'Northern Tepehuan', i: 'ntp' },
  { n: 'Delo', i: 'ntr' },
  { n: 'Natügu', i: 'ntu' },
  { n: 'Tangkhul Naga (Myanmar)', i: 'ntx' },
  { n: 'Mantsi', i: 'nty' },
  { n: 'Natanzi', i: 'ntz' },
  { n: 'Yuanga', i: 'nua' },
  { n: 'Ngala', i: 'nud' },
  { n: 'Ngundu', i: 'nue' },
  { n: 'Nusu', i: 'nuf' },
  { n: 'Ndunda', i: 'nuh' },
  { n: 'Ngumbi', i: 'nui' },
  { n: 'Nyole', i: 'nuj' },
  { n: 'Nuu-chah-nulth', i: 'nuk' },
  { n: "Niuafo'ou", i: 'num' },
  { n: 'Anong', i: 'nun' },
  { n: 'Nguôn', i: 'nuo' },
  { n: 'Nupe-Nupe-Tako', i: 'nup' },
  { n: 'Nukumanu', i: 'nuq' },
  { n: 'Nukuria', i: 'nur' },
  { n: 'Nuer', i: 'nus' },
  { n: 'Nung (Viet Nam)', i: 'nut' },
  { n: 'Ngbundu', i: 'nuu' },
  { n: 'Northern Nuni', i: 'nuv' },
  { n: 'Nguluwan', i: 'nuw' },
  { n: 'Mehek', i: 'nux' },
  { n: 'Nunggubuyu', i: 'nuy' },
  { n: 'Tlamacazapa Nahuatl', i: 'nuz' },
  { n: 'Nasarian', i: 'nvh' },
  { n: 'Namiae', i: 'nvm' },
  { n: 'Nyokon', i: 'nvo' },
  { n: 'Nyabwa', i: 'nwb' },
  { n: 'Ngwe', i: 'nwe' },
  { n: 'Southwest Tanna', i: 'nwi' },
  { n: 'Nyamusa-Molo', i: 'nwm' },
  { n: 'Nawaru', i: 'nwr' },
  { n: 'Nauete', i: 'nxa' },
  { n: 'Ngando (Democratic Republic of Congo)', i: 'nxd' },
  { n: 'Nage', i: 'nxe' },
  { n: "Ngad'a", i: 'nxg' },
  { n: 'Nindi', i: 'nxi' },
  { n: 'Koki Naga', i: 'nxk' },
  { n: 'South Nuaulu', i: 'nxl' },
  { n: 'Ndambomo', i: 'nxo' },
  { n: 'Naxi', i: 'nxq' },
  { n: 'Ninggerum', i: 'nxr' },
  { n: 'Nafri', i: 'nxx' },
  { n: 'Nyanja', i: 'nya' },
  { n: 'Nyangbo', i: 'nyb' },
  { n: 'Nyanga-li', i: 'nyc' },
  { n: 'Nyore', i: 'nyd' },
  { n: 'Nyengo', i: 'nye' },
  { n: 'Giryama', i: 'nyf' },
  { n: 'Nyindu', i: 'nyg' },
  { n: 'Nyikina', i: 'nyh' },
  { n: 'Ama (Sudan)', i: 'nyi' },
  { n: 'Nyanga', i: 'nyj' },
  { n: 'Nyaneka', i: 'nyk' },
  { n: 'Nyeu', i: 'nyl' },
  { n: 'Nyamwezi', i: 'nym' },
  { n: 'Nyankole', i: 'nyn' },
  { n: 'Nyoro', i: 'nyo' },
  { n: 'Nayini', i: 'nyq' },
  { n: 'Nyiha (Malawi)', i: 'nyr' },
  { n: 'Nyungar', i: 'nys' },
  { n: 'Nyungwe', i: 'nyu' },
  { n: 'Nyaw', i: 'nyw' },
  { n: 'Nyakyusa-Ngonde', i: 'nyy' },
  { n: 'Tigon Mbembe', i: 'nza' },
  { n: 'Njebi', i: 'nzb' },
  { n: 'Nzadi', i: 'nzd' },
  { n: 'Nzima', i: 'nzi' },
  { n: 'Nzakara', i: 'nzk' },
  { n: 'Zeme Naga', i: 'nzm' },
  { n: 'New Zealand Sign Language', i: 'nzs' },
  { n: 'Teke-Nzikou', i: 'nzu' },
  { n: 'Nzakambay', i: 'nzy' },
  { n: 'Nanga Dama Dogon', i: 'nzz' },
  { n: 'Orok', i: 'oaa' },
  { n: 'Oroch', i: 'oac' },
  { n: 'Southern Bontok', i: 'obk' },
  { n: 'Oblo', i: 'obl' },
  { n: 'Obo Manobo', i: 'obo' },
  { n: 'Obulom', i: 'obu' },
  { n: 'Ocaina', i: 'oca' },
  { n: 'Occitan (post 1500)', i: 'oci' },
  { n: 'Atzingo Matlatzinca', i: 'ocu' },
  { n: 'Odut', i: 'oda' },
  { n: 'Od', i: 'odk' },
  { n: 'Odual', i: 'odu' },
  { n: 'Efutop', i: 'ofu' },
  { n: 'Ogbia', i: 'ogb' },
  { n: 'Ogbah', i: 'ogc' },
  { n: 'Ogbogolo', i: 'ogg' },
  { n: 'Khana', i: 'ogo' },
  { n: 'Ogbronuagum', i: 'ogu' },
  { n: 'Oirata', i: 'oia' },
  { n: 'Inebu One', i: 'oin' },
  { n: 'Northwestern Ojibwa', i: 'ojb' },
  { n: 'Central Ojibwa', i: 'ojc' },
  { n: 'Eastern Ojibwa', i: 'ojg' },
  { n: 'Severn Ojibwa', i: 'ojs' },
  { n: 'Ontong Java', i: 'ojv' },
  { n: 'Western Ojibwa', i: 'ojw' },
  { n: 'Okanagan', i: 'oka' },
  { n: 'Okobo', i: 'okb' },
  { n: 'Okodia', i: 'okd' },
  { n: 'Okpe (Southwestern Edo)', i: 'oke' },
  { n: 'Koresh-e Rostam', i: 'okh' },
  { n: 'Okiek', i: 'oki' },
  { n: 'Kwamtim One', i: 'okk' },
  { n: 'Oki-No-Erabu', i: 'okn' },
  { n: 'Kirike', i: 'okr' },
  { n: 'Oko-Eni-Osayen', i: 'oks' },
  { n: 'Oku', i: 'oku' },
  { n: 'Orokaiva', i: 'okv' },
  { n: 'Okpe (Northwestern Edo)', i: 'okx' },
  { n: 'Walungge', i: 'ola' },
  { n: 'Mochi', i: 'old' },
  { n: 'Olekha', i: 'ole' },
  { n: 'Oloma', i: 'olm' },
  { n: 'Livvi', i: 'olo' },
  { n: 'Olrat', i: 'olr' },
  { n: 'Kuvale', i: 'olu' },
  { n: 'Omaha-Ponca', i: 'oma' },
  { n: 'East Ambae', i: 'omb' },
  { n: 'Omagua', i: 'omg' },
  { n: 'Omi', i: 'omi' },
  { n: 'Ombo', i: 'oml' },
  { n: 'Utarmbung', i: 'omo' },
  { n: 'Omotik', i: 'omt' },
  { n: 'South Tairora', i: 'omw' },
  { n: 'Ona', i: 'ona' },
  { n: 'Lingao', i: 'onb' },
  { n: 'Oneida', i: 'one' },
  { n: 'Olo', i: 'ong' },
  { n: 'Onin', i: 'oni' },
  { n: 'Onjob', i: 'onj' },
  { n: 'Kabore One', i: 'onk' },
  { n: 'Onobasulu', i: 'onn' },
  { n: 'Onondaga', i: 'ono' },
  { n: 'Sartang', i: 'onp' },
  { n: 'Northern One', i: 'onr' },
  { n: 'Ono', i: 'ons' },
  { n: 'Ontenu', i: 'ont' },
  { n: 'Unua', i: 'onu' },
  { n: 'Onin Based Pidgin', i: 'onx' },
  { n: "Tohono O'odham", i: 'ood' },
  { n: 'Ong', i: 'oog' },
  { n: 'Önge', i: 'oon' },
  { n: 'Oorlams', i: 'oor' },
  { n: 'Okpamheri', i: 'opa' },
  { n: 'Kopkaka', i: 'opk' },
  { n: 'Oksapmin', i: 'opm' },
  { n: 'Opao', i: 'opo' },
  { n: 'Ofayé', i: 'opy' },
  { n: 'Oroha', i: 'ora' },
  { n: 'Orma', i: 'orc' },
  { n: 'Orejón', i: 'ore' },
  { n: 'Oring', i: 'org' },
  { n: 'Oroqen', i: 'orh' },
  { n: 'Orang Kanaq', i: 'orn' },
  { n: 'Orokolo', i: 'oro' },
  { n: 'Oruma', i: 'orr' },
  { n: 'Orang Seletar', i: 'ors' },
  { n: 'Adivasi Oriya', i: 'ort' },
  { n: 'Ormuri', i: 'oru' },
  { n: 'Oro Win', i: 'orw' },
  { n: 'Oro', i: 'orx' },
  { n: 'Odia', i: 'ory' },
  { n: 'Ormu', i: 'orz' },
  { n: 'Osage', i: 'osa' },
  { n: 'Osing', i: 'osi' },
  { n: 'Ososo', i: 'oso' },
  { n: 'Ossetian', i: 'oss' },
  { n: 'Osatu', i: 'ost' },
  { n: 'Southern One', i: 'osu' },
  { n: 'Ot Danum', i: 'otd' },
  { n: 'Mezquital Otomi', i: 'ote' },
  { n: 'Tilapa Otomi', i: 'otl' },
  { n: 'Eastern Highland Otomi', i: 'otm' },
  { n: 'Tenango Otomi', i: 'otn' },
  { n: 'Querétaro Otomi', i: 'otq' },
  { n: 'Otoro', i: 'otr' },
  { n: 'Estado de México Otomi', i: 'ots' },
  { n: 'Temoaya Otomi', i: 'ott' },
  { n: 'Ottawa', i: 'otw' },
  { n: 'Texcatepec Otomi', i: 'otx' },
  { n: 'Ixtenco Otomi', i: 'otz' },
  { n: 'Tagargrent', i: 'oua' },
  { n: 'Glio-Oubi', i: 'oub' },
  { n: 'Oune', i: 'oue' },
  { n: 'Elfdalian', i: 'ovd' },
  { n: 'Owiniga', i: 'owi' },
  { n: 'Oy', i: 'oyb' },
  { n: 'Oyda', i: 'oyd' },
  { n: 'Wayampi', i: 'oym' },
  { n: "Oya'oya", i: 'oyy' },
  { n: 'Koonzime', i: 'ozm' },
  { n: 'Parecís', i: 'pab' },
  { n: 'Pacoh', i: 'pac' },
  { n: 'Paumarí', i: 'pad' },
  { n: 'Pagibete', i: 'pae' },
  { n: 'Pangasinan', i: 'pag' },
  { n: 'Tenharim', i: 'pah' },
  { n: 'Pe', i: 'pai' },
  { n: 'Parakanã', i: 'pak' },
  { n: 'Pampanga', i: 'pam' },
  { n: 'Panjabi', i: 'pan' },
  { n: 'Northern Paiute', i: 'pao' },
  { n: 'Papiamento', i: 'pap' },
  { n: 'Parya', i: 'paq' },
  { n: 'Panamint', i: 'par' },
  { n: 'Papasena', i: 'pas' },
  { n: 'Papitalai', i: 'pat' },
  { n: 'Palauan', i: 'pau' },
  { n: 'Pakaásnovos', i: 'pav' },
  { n: 'Pawnee', i: 'paw' },
  { n: 'Pech', i: 'pay' },
  { n: 'Páez', i: 'pbb' },
  { n: 'Patamona', i: 'pbc' },
  { n: 'Mezontla Popoloca', i: 'pbe' },
  { n: 'Coyotepec Popoloca', i: 'pbf' },
  { n: "E'ñapa Woromaipu", i: 'pbh' },
  { n: 'Parkwa', i: 'pbi' },
  { n: 'Mak (Nigeria)', i: 'pbl' },
  { n: 'Puebla Mazatec', i: 'pbm' },
  { n: 'Kpasam', i: 'pbn' },
  { n: 'Papel', i: 'pbo' },
  { n: 'Badyara', i: 'pbp' },
  { n: 'Pangwa', i: 'pbr' },
  { n: 'Central Pame', i: 'pbs' },
  { n: 'Southern Pashto', i: 'pbt' },
  { n: 'Northern Pashto', i: 'pbu' },
  { n: 'Pnar', i: 'pbv' },
  { n: 'Pyu (Papua New Guinea)', i: 'pby' },
  { n: 'Santa Inés Ahuatempan Popoloca', i: 'pca' },
  { n: 'Pear', i: 'pcb' },
  { n: 'Bouyei', i: 'pcc' },
  { n: 'Picard', i: 'pcd' },
  { n: 'Ruching Palaung', i: 'pce' },
  { n: 'Paliyan', i: 'pcf' },
  { n: 'Paniya', i: 'pcg' },
  { n: 'Pardhan', i: 'pch' },
  { n: 'Duruwa', i: 'pci' },
  { n: 'Parenga', i: 'pcj' },
  { n: 'Paite Chin', i: 'pck' },
  { n: 'Pardhi', i: 'pcl' },
  { n: 'Nigerian Pidgin', i: 'pcm' },
  { n: 'Piti', i: 'pcn' },
  { n: 'Pacahuara', i: 'pcp' },
  { n: 'Pyapun', i: 'pcw' },
  { n: 'Anam', i: 'pda' },
  { n: 'Pennsylvania German', i: 'pdc' },
  { n: 'Pa Di', i: 'pdi' },
  { n: 'Podena', i: 'pdn' },
  { n: 'Padoe', i: 'pdo' },
  { n: 'Plautdietsch', i: 'pdt' },
  { n: 'Kayan', i: 'pdu' },
  { n: 'Peranakan Indonesian', i: 'pea' },
  { n: 'Mala (Papua New Guinea)', i: 'ped' },
  { n: 'Taje', i: 'pee' },
  { n: 'Pengo', i: 'peg' },
  { n: 'Bonan', i: 'peh' },
  { n: 'Chichimeca-Jonaz', i: 'pei' },
  { n: 'Penchal', i: 'pek' },
  { n: 'Pekal', i: 'pel' },
  { n: 'Phende', i: 'pem' },
  { n: 'Kunja', i: 'pep' },
  { n: 'Southern Pomo', i: 'peq' },
  { n: 'Iranian Persian', i: 'pes' },
  { n: 'Pémono', i: 'pev' },
  { n: 'Petats', i: 'pex' },
  { n: 'Petjo', i: 'pey' },
  { n: 'Eastern Penan', i: 'pez' },
  { n: 'Pááfang', i: 'pfa' },
  { n: 'Pere', i: 'pfe' },
  { n: 'Pfaelzisch', i: 'pfl' },
  { n: 'Sudanese Creole Arabic', i: 'pga' },
  { n: 'Pangwali', i: 'pgg' },
  { n: 'Pagi', i: 'pgi' },
  { n: 'Rerep', i: 'pgk' },
  { n: 'Pangseng', i: 'pgs' },
  { n: 'Pagu', i: 'pgu' },
  { n: 'Papua New Guinean Sign Language', i: 'pgz' },
  { n: 'Pa-Hng', i: 'pha' },
  { n: 'Phudagi', i: 'phd' },
  { n: 'Phuong', i: 'phg' },
  { n: 'Phukha', i: 'phh' },
  { n: 'Phake', i: 'phk' },
  { n: 'Phalura', i: 'phl' },
  { n: 'Phimbi', i: 'phm' },
  { n: 'Phunoi', i: 'pho' },
  { n: "Phana'", i: 'phq' },
  { n: 'Pahari-Potwari', i: 'phr' },
  { n: 'Phu Thai', i: 'pht' },
  { n: 'Phuan', i: 'phu' },
  { n: 'Pahlavani', i: 'phv' },
  { n: 'Phangduwali', i: 'phw' },
  { n: 'Pima Bajo', i: 'pia' },
  { n: 'Yine', i: 'pib' },
  { n: 'Pinji', i: 'pic' },
  { n: 'Piaroa', i: 'pid' },
  { n: 'Pingelapese', i: 'pif' },
  { n: 'Pisabo', i: 'pig' },
  { n: 'Pitcairn-Norfolk', i: 'pih' },
  { n: 'Pini', i: 'pii' },
  { n: 'Yom', i: 'pil' },
  { n: 'Piame', i: 'pin' },
  { n: 'Piapoco', i: 'pio' },
  { n: 'Pero', i: 'pip' },
  { n: 'Piratapuyo', i: 'pir' },
  { n: 'Pijin', i: 'pis' },
  { n: 'Pintupi-Luritja', i: 'piu' },
  { n: 'Pileni', i: 'piv' },
  { n: 'Pimbwe', i: 'piw' },
  { n: 'Piu', i: 'pix' },
  { n: 'Piya-Kwonci', i: 'piy' },
  { n: 'Pije', i: 'piz' },
  { n: 'Pitjantjatjara', i: 'pjt' },
  { n: 'Pokomo', i: 'pkb' },
  { n: 'Pak-Tong', i: 'pkg' },
  { n: 'Pankhu', i: 'pkh' },
  { n: 'Pakanha', i: 'pkn' },
  { n: 'Pökoot', i: 'pko' },
  { n: 'Pukapuka', i: 'pkp' },
  { n: 'Attapady Kurumba', i: 'pkr' },
  { n: 'Pakistan Sign Language', i: 'pks' },
  { n: 'Maleng', i: 'pkt' },
  { n: 'Paku', i: 'pku' },
  { n: 'Miani', i: 'pla' },
  { n: 'Polonombauk', i: 'plb' },
  { n: 'Central Palawano', i: 'plc' },
  { n: 'Polari', i: 'pld' },
  { n: "Palu'e", i: 'ple' },
  { n: 'Pilagá', i: 'plg' },
  { n: 'Paulohi', i: 'plh' },
  { n: 'Polci', i: 'plj' },
  { n: 'Kohistani Shina', i: 'plk' },
  { n: 'Shwe Palaung', i: 'pll' },
  { n: 'Palenquero', i: 'pln' },
  { n: 'Oluta Popoluca', i: 'plo' },
  { n: 'Palaka Senoufo', i: 'plr' },
  { n: 'San Marcos Tlacoyalco Popoloca', i: 'pls' },
  { n: 'Plateau Malagasy', i: 'plt' },
  { n: 'Palikúr', i: 'plu' },
  { n: 'Southwest Palawano', i: 'plv' },
  { n: "Brooke's Point Palawano", i: 'plw' },
  { n: 'Bolyu', i: 'ply' },
  { n: 'Paluan', i: 'plz' },
  { n: 'Paama', i: 'pma' },
  { n: 'Pambia', i: 'pmb' },
  { n: 'Pwaamei', i: 'pme' },
  { n: 'Pamona', i: 'pmf' },
  { n: 'Northern Pumi', i: 'pmi' },
  { n: 'Southern Pumi', i: 'pmj' },
  { n: 'Pomo', i: 'pmm' },
  { n: 'Pam', i: 'pmn' },
  { n: 'Pom', i: 'pmo' },
  { n: 'Northern Pame', i: 'pmq' },
  { n: 'Paynamar', i: 'pmr' },
  { n: 'Piemontese', i: 'pms' },
  { n: 'Tuamotuan', i: 'pmt' },
  { n: 'Plains Miwok', i: 'pmw' },
  { n: 'Poumei Naga', i: 'pmx' },
  { n: 'Papuan Malay', i: 'pmy' },
  { n: 'Punan Bah-Biau', i: 'pna' },
  { n: 'Western Panjabi', i: 'pnb' },
  { n: 'Pannei', i: 'pnc' },
  { n: 'Mpinda', i: 'pnd' },
  { n: 'Western Penan', i: 'pne' },
  { n: 'Pongu', i: 'png' },
  { n: 'Penrhyn', i: 'pnh' },
  { n: 'Aoheng', i: 'pni' },
  { n: 'Paunaka', i: 'pnk' },
  { n: 'Paleni', i: 'pnl' },
  { n: 'Punan Batu 1', i: 'pnm' },
  { n: 'Pinai-Hagahai', i: 'pnn' },
  { n: 'Pancana', i: 'pnp' },
  { n: 'Pana (Burkina Faso)', i: 'pnq' },
  { n: 'Panim', i: 'pnr' },
  { n: 'Ponosakan', i: 'pns' },
  { n: 'Pontic', i: 'pnt' },
  { n: 'Jiongnai Bunu', i: 'pnu' },
  { n: 'Pinigura', i: 'pnv' },
  { n: 'Banyjima', i: 'pnw' },
  { n: 'Phong-Kniang', i: 'pnx' },
  { n: 'Pinyin', i: 'pny' },
  { n: 'Pana (Central African Republic)', i: 'pnz' },
  { n: 'Poqomam', i: 'poc' },
  { n: 'San Juan Atzingo Popoloca', i: 'poe' },
  { n: 'Poke', i: 'pof' },
  { n: "Poqomchi'", i: 'poh' },
  { n: 'Highland Popoluca', i: 'poi' },
  { n: 'Pokangá', i: 'pok' },
  { n: 'Polish', i: 'pol' },
  { n: 'Southeastern Pomo', i: 'pom' },
  { n: 'Pohnpeian', i: 'pon' },
  { n: 'Pwapwâ', i: 'pop' },
  { n: 'Texistepec Popoluca', i: 'poq' },
  { n: 'Portuguese', i: 'por' },
  { n: 'Sayula Popoluca', i: 'pos' },
  { n: 'Potawatomi', i: 'pot' },
  { n: 'Upper Guinea Crioulo', i: 'pov' },
  { n: 'San Felipe Otlaltepec Popoloca', i: 'pow' },
  { n: 'Pogolo', i: 'poy' },
  { n: 'Papi', i: 'ppe' },
  { n: 'Paipai', i: 'ppi' },
  { n: 'Uma', i: 'ppk' },
  { n: 'Pipil', i: 'ppl' },
  { n: 'Papuma', i: 'ppm' },
  { n: 'Papapana', i: 'ppn' },
  { n: 'Folopa', i: 'ppo' },
  { n: 'Pelende', i: 'ppp' },
  { n: 'Pei', i: 'ppq' },
  { n: 'San Luís Temalacayuca Popoloca', i: 'pps' },
  { n: 'Pare', i: 'ppt' },
  { n: "Pa'a", i: 'pqa' },
  { n: 'Malecite-Passamaquoddy', i: 'pqm' },
  { n: 'Parachi', i: 'prc' },
  { n: 'Parsi-Dari', i: 'prd' },
  { n: 'Principense', i: 'pre' },
  { n: 'Paranan', i: 'prf' },
  { n: 'Prussian', i: 'prg' },
  { n: 'Porohanon', i: 'prh' },
  { n: 'Paicî', i: 'pri' },
  { n: 'Parauk', i: 'prk' },
  { n: 'Peruvian Sign Language', i: 'prl' },
  { n: 'Kibiri', i: 'prm' },
  { n: 'Prasuni', i: 'prn' },
  { n: 'Parsi', i: 'prp' },
  { n: 'Ashéninka Perené', i: 'prq' },
  { n: 'Dari', i: 'prs' },
  { n: 'Phai', i: 'prt' },
  { n: 'Puragi', i: 'pru' },
  { n: 'Parawen', i: 'prw' },
  { n: 'Purik', i: 'prx' },
  { n: 'Providencia Sign Language', i: 'prz' },
  { n: 'Asue Awyu', i: 'psa' },
  { n: 'Persian Sign Language', i: 'psc' },
  { n: 'Plains Indian Sign Language', i: 'psd' },
  { n: 'Central Malay', i: 'pse' },
  { n: 'Penang Sign Language', i: 'psg' },
  { n: 'Southwest Pashai', i: 'psh' },
  { n: 'Southeast Pashai', i: 'psi' },
  { n: 'Puerto Rican Sign Language', i: 'psl' },
  { n: 'Panasuan', i: 'psn' },
  { n: 'Polish Sign Language', i: 'pso' },
  { n: 'Philippine Sign Language', i: 'psp' },
  { n: 'Pasi', i: 'psq' },
  { n: 'Portuguese Sign Language', i: 'psr' },
  { n: 'Kaulong', i: 'pss' },
  { n: 'Central Pashto', i: 'pst' },
  { n: 'Port Sandwich', i: 'psw' },
  { n: 'Pai Tavytera', i: 'pta' },
  { n: 'Pindiini', i: 'pti' },
  { n: 'Patani', i: 'ptn' },
  { n: "Zo'é", i: 'pto' },
  { n: 'Patep', i: 'ptp' },
  { n: 'Pattapu', i: 'ptq' },
  { n: 'Piamatsina', i: 'ptr' },
  { n: 'Enrekang', i: 'ptt' },
  { n: 'Bambam', i: 'ptu' },
  { n: 'Port Vato', i: 'ptv' },
  { n: 'Pathiya', i: 'pty' },
  { n: 'Western Highland Purepecha', i: 'pua' },
  { n: 'Purum', i: 'pub' },
  { n: 'Punan Merap', i: 'puc' },
  { n: 'Punan Aput', i: 'pud' },
  { n: 'Punan Merah', i: 'puf' },
  { n: 'Phuie', i: 'pug' },
  { n: 'Puinave', i: 'pui' },
  { n: 'Punan Tubu', i: 'puj' },
  { n: 'Puma', i: 'pum' },
  { n: 'Puoc', i: 'puo' },
  { n: 'Pulabu', i: 'pup' },
  { n: 'Puruborá', i: 'pur' },
  { n: 'Putoh', i: 'put' },
  { n: 'Punu', i: 'puu' },
  { n: 'Puluwatese', i: 'puw' },
  { n: 'Puare', i: 'pux' },
  { n: 'Pawaia', i: 'pwa' },
  { n: 'Panawa', i: 'pwb' },
  { n: 'Gapapaiwa', i: 'pwg' },
  { n: 'Molbog', i: 'pwm' },
  { n: 'Paiwan', i: 'pwn' },
  { n: 'Pwo Western Karen', i: 'pwo' },
  { n: 'Powari', i: 'pwr' },
  { n: 'Pwo Northern Karen', i: 'pww' },
  { n: 'Quetzaltepec Mixe', i: 'pxm' },
  { n: 'Pye Krumen', i: 'pye' },
  { n: 'Fyam', i: 'pym' },
  { n: 'Poyanáwa', i: 'pyn' },
  { n: 'Paraguayan Sign Language', i: 'pys' },
  { n: 'Puyuma', i: 'pyu' },
  { n: 'Pyen', i: 'pyy' },
  { n: 'Para Naga', i: 'pzn' },
  { n: 'Quapaw', i: 'qua' },
  { n: 'Huallaga Huánuco Quechua', i: 'qub' },
  { n: "K'iche'", i: 'quc' },
  { n: 'Calderón Highland Quichua', i: 'qud' },
  { n: 'Lambayeque Quechua', i: 'quf' },
  { n: 'Chimborazo Highland Quichua', i: 'qug' },
  { n: 'South Bolivian Quechua', i: 'quh' },
  { n: 'Quileute', i: 'qui' },
  { n: 'Chachapoyas Quechua', i: 'quk' },
  { n: 'North Bolivian Quechua', i: 'qul' },
  { n: 'Sipacapense', i: 'qum' },
  { n: 'Southern Pastaza Quechua', i: 'qup' },
  { n: 'Quinqui', i: 'quq' },
  { n: 'Yanahuanca Pasco Quechua', i: 'qur' },
  { n: 'Santiago del Estero Quichua', i: 'qus' },
  { n: 'Sacapulteco', i: 'quv' },
  { n: 'Tena Lowland Quichua', i: 'quw' },
  { n: 'Yauyos Quechua', i: 'qux' },
  { n: 'Ayacucho Quechua', i: 'quy' },
  { n: 'Cusco Quechua', i: 'quz' },
  { n: 'Ambo-Pasco Quechua', i: 'qva' },
  { n: 'Cajamarca Quechua', i: 'qvc' },
  { n: 'Eastern Apurímac Quechua', i: 'qve' },
  { n: 'Huamalíes-Dos de Mayo Huánuco Quechua', i: 'qvh' },
  { n: 'Imbabura Highland Quichua', i: 'qvi' },
  { n: 'Loja Highland Quichua', i: 'qvj' },
  { n: 'Cajatambo North Lima Quechua', i: 'qvl' },
  { n: 'Margos-Yarowilca-Lauricocha Quechua', i: 'qvm' },
  { n: 'North Junín Quechua', i: 'qvn' },
  { n: 'Napo Lowland Quechua', i: 'qvo' },
  { n: 'Pacaraos Quechua', i: 'qvp' },
  { n: 'San Martín Quechua', i: 'qvs' },
  { n: 'Huaylla Wanca Quechua', i: 'qvw' },
  { n: 'Queyu', i: 'qvy' },
  { n: 'Northern Pastaza Quichua', i: 'qvz' },
  { n: 'Corongo Ancash Quechua', i: 'qwa' },
  { n: 'Huaylas Ancash Quechua', i: 'qwh' },
  { n: 'Sihuas Ancash Quechua', i: 'qws' },
  { n: 'Chiquián Ancash Quechua', i: 'qxa' },
  { n: 'Chincha Quechua', i: 'qxc' },
  { n: 'Panao Huánuco Quechua', i: 'qxh' },
  { n: 'Salasaca Highland Quichua', i: 'qxl' },
  { n: 'Northern Conchucos Ancash Quechua', i: 'qxn' },
  { n: 'Southern Conchucos Ancash Quechua', i: 'qxo' },
  { n: 'Puno Quechua', i: 'qxp' },
  { n: "Qashqa'i", i: 'qxq' },
  { n: 'Cañar Highland Quichua', i: 'qxr' },
  { n: 'Southern Qiang', i: 'qxs' },
  { n: 'Santa Ana de Tusi Pasco Quechua', i: 'qxt' },
  { n: 'Arequipa-La Unión Quechua', i: 'qxu' },
  { n: 'Jauja Wanca Quechua', i: 'qxw' },
  { n: 'Dungmali', i: 'raa' },
  { n: 'Camling', i: 'rab' },
  { n: 'Rasawa', i: 'rac' },
  { n: 'Rade', i: 'rad' },
  { n: 'Western Meohang', i: 'raf' },
  { n: 'Logooli', i: 'rag' },
  { n: 'Rabha', i: 'rah' },
  { n: 'Ramoaaina', i: 'rai' },
  { n: 'Tulu-Bohuai', i: 'rak' },
  { n: 'Ralte', i: 'ral' },
  { n: 'Canela', i: 'ram' },
  { n: 'Riantana', i: 'ran' },
  { n: 'Rao', i: 'rao' },
  { n: 'Rapanui', i: 'rap' },
  { n: 'Saam', i: 'raq' },
  { n: 'Rarotongan', i: 'rar' },
  { n: 'Tegali', i: 'ras' },
  { n: 'Razajerdi', i: 'rat' },
  { n: 'Raute', i: 'rau' },
  { n: 'Sampang', i: 'rav' },
  { n: 'Rawang', i: 'raw' },
  { n: 'Rang', i: 'rax' },
  { n: 'Rapa', i: 'ray' },
  { n: 'Rahambuu', i: 'raz' },
  { n: 'Rumai Palaung', i: 'rbb' },
  { n: 'Northern Bontok', i: 'rbk' },
  { n: 'Miraya Bikol', i: 'rbl' },
  { n: 'Réunion Creole French', i: 'rcf' },
  { n: 'Rudbari', i: 'rdb' },
  { n: 'Rerau', i: 'rea' },
  { n: 'Rembong', i: 'reb' },
  { n: 'Rejang Kayan', i: 'ree' },
  { n: 'Kara (Tanzania)', i: 'reg' },
  { n: 'Reli', i: 'rei' },
  { n: 'Rejang', i: 'rej' },
  { n: 'Rendille', i: 'rel' },
  { n: 'Rengao', i: 'ren' },
  { n: 'Reshe', i: 'res' },
  { n: 'Retta', i: 'ret' },
  { n: 'Reyesano', i: 'rey' },
  { n: 'Roria', i: 'rga' },
  { n: 'Romano-Greek', i: 'rge' },
  { n: 'Romagnol', i: 'rgn' },
  { n: 'Resígaro', i: 'rgr' },
  { n: 'Southern Roglai', i: 'rgs' },
  { n: 'Ringgou', i: 'rgu' },
  { n: 'Rohingya', i: 'rhg' },
  { n: 'Yahang', i: 'rhp' },
  { n: 'Riang (India)', i: 'ria' },
  { n: 'Tarifit', i: 'rif' },
  { n: 'Riang Lang', i: 'ril' },
  { n: 'Nyaturu', i: 'rim' },
  { n: 'Nungu', i: 'rin' },
  { n: 'Ribun', i: 'rir' },
  { n: 'Ritharrngu', i: 'rit' },
  { n: 'Riung', i: 'riu' },
  { n: 'Rajong', i: 'rjg' },
  { n: 'Raji', i: 'rji' },
  { n: 'Rajbanshi', i: 'rjs' },
  { n: 'Kraol', i: 'rka' },
  { n: 'Rikbaktsa', i: 'rkb' },
  { n: 'Rakahanga-Manihiki', i: 'rkh' },
  { n: 'Rakhine', i: 'rki' },
  { n: 'Marka', i: 'rkm' },
  { n: 'Rangpuri', i: 'rkt' },
  { n: 'Rama', i: 'rma' },
  { n: 'Rembarrnga', i: 'rmb' },
  { n: 'Carpathian Romani', i: 'rmc' },
  { n: 'Angloromani', i: 'rme' },
  { n: 'Kalo Finnish Romani', i: 'rmf' },
  { n: 'Traveller Norwegian', i: 'rmg' },
  { n: 'Murkim', i: 'rmh' },
  { n: 'Lomavren', i: 'rmi' },
  { n: 'Romkun', i: 'rmk' },
  { n: 'Baltic Romani', i: 'rml' },
  { n: 'Roma', i: 'rmm' },
  { n: 'Balkan Romani', i: 'rmn' },
  { n: 'Sinte Romani', i: 'rmo' },
  { n: 'Rempi', i: 'rmp' },
  { n: 'Caló', i: 'rmq' },
  { n: 'Romanian Sign Language', i: 'rms' },
  { n: 'Domari', i: 'rmt' },
  { n: 'Tavringer Romani', i: 'rmu' },
  { n: 'Welsh Romani', i: 'rmw' },
  { n: 'Romam', i: 'rmx' },
  { n: 'Vlax Romani', i: 'rmy' },
  { n: 'Marma', i: 'rmz' },
  { n: 'Ruund', i: 'rnd' },
  { n: 'Ronga', i: 'rng' },
  { n: 'Ranglong', i: 'rnl' },
  { n: 'Roon', i: 'rnn' },
  { n: 'Rongpo', i: 'rnp' },
  { n: 'Rungwa', i: 'rnw' },
  { n: "Tae'", i: 'rob' },
  { n: 'Cacgia Roglai', i: 'roc' },
  { n: 'Rogo', i: 'rod' },
  { n: 'Ronji', i: 'roe' },
  { n: 'Rombo', i: 'rof' },
  { n: 'Northern Roglai', i: 'rog' },
  { n: 'Romansh', i: 'roh' },
  { n: 'Romblomanon', i: 'rol' },
  { n: 'Romanian', i: 'ron' },
  { n: 'Rotokas', i: 'roo' },
  { n: 'Kriol', i: 'rop' },
  { n: 'Rongga', i: 'ror' },
  { n: 'Runga', i: 'rou' },
  { n: 'Dela-Oenale', i: 'row' },
  { n: 'Repanbitip', i: 'rpn' },
  { n: 'Rapting', i: 'rpt' },
  { n: 'Ririo', i: 'rri' },
  { n: 'Waima', i: 'rro' },
  { n: 'Romano-Serbian', i: 'rsb' },
  { n: 'Russian Sign Language', i: 'rsl' },
  { n: 'Miriwoong Sign Language', i: 'rsm' },
  { n: 'Rungtu Chin', i: 'rtc' },
  { n: 'Ratahan', i: 'rth' },
  { n: 'Rotuman', i: 'rtm' },
  { n: 'Rathawi', i: 'rtw' },
  { n: 'Gungu', i: 'rub' },
  { n: 'Ruuli', i: 'ruc' },
  { n: 'Rusyn', i: 'rue' },
  { n: 'Luguru', i: 'ruf' },
  { n: 'Roviana', i: 'rug' },
  { n: 'Ruga', i: 'ruh' },
  { n: 'Rufiji', i: 'rui' },
  { n: 'Che', i: 'ruk' },
  { n: 'Rundi', i: 'run' },
  { n: 'Istro Romanian', i: 'ruo' },
  { n: 'Macedo-Romanian', i: 'rup' },
  { n: 'Megleno Romanian', i: 'ruq' },
  { n: 'Russian', i: 'rus' },
  { n: 'Rutul', i: 'rut' },
  { n: 'Lanas Lobu', i: 'ruu' },
  { n: 'Mala (Nigeria)', i: 'ruy' },
  { n: 'Ruma', i: 'ruz' },
  { n: 'Rawo', i: 'rwa' },
  { n: 'Rwa', i: 'rwk' },
  { n: 'Amba (Uganda)', i: 'rwm' },
  { n: 'Rawa', i: 'rwo' },
  { n: 'Marwari (India)', i: 'rwr' },
  { n: 'Ngardi', i: 'rxd' },
  { n: 'Northern Amami-Oshima', i: 'ryn' },
  { n: 'Yaeyama', i: 'rys' },
  { n: 'Central Okinawan', i: 'ryu' },
  { n: 'Rāziḥī', i: 'rzh' },
  { n: 'Saba', i: 'saa' },
  { n: 'Buglere', i: 'sab' },
  { n: 'Meskwaki', i: 'sac' },
  { n: 'Sandawe', i: 'sad' },
  { n: 'Sabanê', i: 'sae' },
  { n: 'Safaliba', i: 'saf' },
  { n: 'Sango', i: 'sag' },
  { n: 'Yakut', i: 'sah' },
  { n: 'Sahu', i: 'saj' },
  { n: 'Sake', i: 'sak' },
  { n: 'Sause', i: 'sao' },
  { n: 'Samburu', i: 'saq' },
  { n: 'Sasak', i: 'sas' },
  { n: 'Santali', i: 'sat' },
  { n: 'Saleman', i: 'sau' },
  { n: 'Saafi-Saafi', i: 'sav' },
  { n: 'Sawi', i: 'saw' },
  { n: 'Sa', i: 'sax' },
  { n: 'Saya', i: 'say' },
  { n: 'Saurashtra', i: 'saz' },
  { n: 'Ngambay', i: 'sba' },
  { n: 'Simbo', i: 'sbb' },
  { n: 'Kele (Papua New Guinea)', i: 'sbc' },
  { n: 'Southern Samo', i: 'sbd' },
  { n: 'Saliba', i: 'sbe' },
  { n: 'Chabu', i: 'sbf' },
  { n: 'Seget', i: 'sbg' },
  { n: 'Sori-Harengan', i: 'sbh' },
  { n: 'Seti', i: 'sbi' },
  { n: 'Surbakhal', i: 'sbj' },
  { n: 'Safwa', i: 'sbk' },
  { n: 'Botolan Sambal', i: 'sbl' },
  { n: 'Sagala', i: 'sbm' },
  { n: 'Sindhi Bhil', i: 'sbn' },
  { n: 'Sabüm', i: 'sbo' },
  { n: 'Sangu (Tanzania)', i: 'sbp' },
  { n: 'Sileibi', i: 'sbq' },
  { n: 'Sembakung Murut', i: 'sbr' },
  { n: 'Subiya', i: 'sbs' },
  { n: 'Kimki', i: 'sbt' },
  { n: 'Stod Bhoti', i: 'sbu' },
  { n: 'Simba', i: 'sbw' },
  { n: 'Seberuang', i: 'sbx' },
  { n: 'Soli', i: 'sby' },
  { n: 'Sara Kaba', i: 'sbz' },
  { n: 'Chut', i: 'scb' },
  { n: 'Dongxiang', i: 'sce' },
  { n: 'San Miguel Creole French', i: 'scf' },
  { n: 'Sanggau', i: 'scg' },
  { n: 'Sakachep', i: 'sch' },
  { n: 'Sri Lankan Creole Malay', i: 'sci' },
  { n: 'Sadri', i: 'sck' },
  { n: 'Shina', i: 'scl' },
  { n: 'Sicilian', i: 'scn' },
  { n: 'Scots', i: 'sco' },
  { n: 'Hyolmo', i: 'scp' },
  { n: "Sa'och", i: 'scq' },
  { n: 'North Slavey', i: 'scs' },
  { n: 'Southern Katang', i: 'sct' },
  { n: 'Shumcho', i: 'scu' },
  { n: 'Sheni', i: 'scv' },
  { n: 'Sha', i: 'scw' },
  { n: "Toraja-Sa'dan", i: 'sda' },
  { n: 'Shabak', i: 'sdb' },
  { n: 'Sassarese Sardinian', i: 'sdc' },
  { n: 'Surubu', i: 'sde' },
  { n: 'Sarli', i: 'sdf' },
  { n: 'Savi', i: 'sdg' },
  { n: 'Southern Kurdish', i: 'sdh' },
  { n: 'Suundi', i: 'sdj' },
  { n: 'Sos Kundi', i: 'sdk' },
  { n: 'Saudi Arabian Sign Language', i: 'sdl' },
  { n: 'Gallurese Sardinian', i: 'sdn' },
  { n: 'Bukar-Sadung Bidayuh', i: 'sdo' },
  { n: 'Sherdukpen', i: 'sdp' },
  { n: 'Semandang', i: 'sdq' },
  { n: 'Oraon Sadri', i: 'sdr' },
  { n: 'Sarudu', i: 'sdu' },
  { n: 'Sibu Melanau', i: 'sdx' },
  { n: 'Sallands', i: 'sdz' },
  { n: 'Semai', i: 'sea' },
  { n: 'Shempire Senoufo', i: 'seb' },
  { n: 'Sechelt', i: 'sec' },
  { n: 'Sedang', i: 'sed' },
  { n: 'Seneca', i: 'see' },
  { n: 'Cebaara Senoufo', i: 'sef' },
  { n: 'Segeju', i: 'seg' },
  { n: 'Sena', i: 'seh' },
  { n: 'Seri', i: 'sei' },
  { n: 'Sene', i: 'sej' },
  { n: 'Sekani', i: 'sek' },
  { n: 'Selkup', i: 'sel' },
  { n: 'Nanerigé Sénoufo', i: 'sen' },
  { n: 'Suarmin', i: 'seo' },
  { n: 'Sìcìté Sénoufo', i: 'sep' },
  { n: 'Senara Sénoufo', i: 'seq' },
  { n: 'Serrano', i: 'ser' },
  { n: 'Koyraboro Senni Songhai', i: 'ses' },
  { n: 'Sentani', i: 'set' },
  { n: 'Serui-Laut', i: 'seu' },
  { n: 'Nyarafolo Senoufo', i: 'sev' },
  { n: 'Sewa Bay', i: 'sew' },
  { n: 'Secoya', i: 'sey' },
  { n: 'Senthang Chin', i: 'sez' },
  { n: 'Langue des signes de Belgique Francophone', i: 'sfb' },
  { n: 'Eastern Subanen', i: 'sfe' },
  { n: 'Small Flowery Miao', i: 'sfm' },
  { n: 'South African Sign Language', i: 'sfs' },
  { n: 'Sehwi', i: 'sfw' },
  { n: 'Mag-antsi Ayta', i: 'sgb' },
  { n: 'Kipsigis', i: 'sgc' },
  { n: 'Surigaonon', i: 'sgd' },
  { n: 'Segai', i: 'sge' },
  { n: 'Swiss-German Sign Language', i: 'sgg' },
  { n: 'Shughni', i: 'sgh' },
  { n: 'Suga', i: 'sgi' },
  { n: 'Surgujia', i: 'sgj' },
  { n: 'Sangkong', i: 'sgk' },
  { n: 'Singpho', i: 'sgp' },
  { n: 'Sangisari', i: 'sgr' },
  { n: 'Samogitian', i: 'sgs' },
  { n: 'Brokpake', i: 'sgt' },
  { n: 'Salas', i: 'sgu' },
  { n: 'Sebat Bet Gurage', i: 'sgw' },
  { n: 'Sierra Leone Sign Language', i: 'sgx' },
  { n: 'Sanglechi', i: 'sgy' },
  { n: 'Sursurunga', i: 'sgz' },
  { n: 'Shall-Zwall', i: 'sha' },
  { n: 'Ninam', i: 'shb' },
  { n: 'Sonde', i: 'shc' },
  { n: 'Kundal Shahi', i: 'shd' },
  { n: 'Sheko', i: 'she' },
  { n: 'Shua', i: 'shg' },
  { n: 'Shoshoni', i: 'shh' },
  { n: 'Tachelhit', i: 'shi' },
  { n: 'Shatt', i: 'shj' },
  { n: 'Shilluk', i: 'shk' },
  { n: 'Shendu', i: 'shl' },
  { n: 'Shahrudi', i: 'shm' },
  { n: 'Shan', i: 'shn' },
  { n: 'Shanga', i: 'sho' },
  { n: 'Shipibo-Conibo', i: 'shp' },
  { n: 'Sala', i: 'shq' },
  { n: 'Shi', i: 'shr' },
  { n: 'Shuswap', i: 'shs' },
  { n: 'Chadian Arabic', i: 'shu' },
  { n: 'Shehri', i: 'shv' },
  { n: 'Shwai', i: 'shw' },
  { n: 'She', i: 'shx' },
  { n: 'Tachawit', i: 'shy' },
  { n: 'Syenara Senoufo', i: 'shz' },
  { n: 'Sebop', i: 'sib' },
  { n: 'Sidamo', i: 'sid' },
  { n: 'Simaa', i: 'sie' },
  { n: 'Siamou', i: 'sif' },
  { n: 'Paasaal', i: 'sig' },
  { n: 'Zire', i: 'sih' },
  { n: 'Shom Peng', i: 'sii' },
  { n: 'Numbami', i: 'sij' },
  { n: 'Sikiana', i: 'sik' },
  { n: 'Tumulung Sisaala', i: 'sil' },
  { n: 'Mende (Papua New Guinea)', i: 'sim' },
  { n: 'Sinhala', i: 'sin' },
  { n: 'Sikkimese', i: 'sip' },
  { n: 'Sonia', i: 'siq' },
  { n: 'Siri', i: 'sir' },
  { n: 'Sinagen', i: 'siu' },
  { n: 'Sumariup', i: 'siv' },
  { n: 'Siwai', i: 'siw' },
  { n: 'Sumau', i: 'six' },
  { n: 'Sivandi', i: 'siy' },
  { n: 'Siwi', i: 'siz' },
  { n: 'Epena', i: 'sja' },
  { n: 'Sajau Basap', i: 'sjb' },
  { n: 'Kildin Sami', i: 'sjd' },
  { n: 'Pite Sami', i: 'sje' },
  { n: 'Assangori', i: 'sjg' },
  { n: 'Sajalong', i: 'sjl' },
  { n: 'Mapun', i: 'sjm' },
  { n: 'Xibe', i: 'sjo' },
  { n: 'Surjapuri', i: 'sjp' },
  { n: 'Siar-Lak', i: 'sjr' },
  { n: 'Ter Sami', i: 'sjt' },
  { n: 'Ume Sami', i: 'sju' },
  { n: 'Shawnee', i: 'sjw' },
  { n: 'Skagit', i: 'ska' },
  { n: 'Saek', i: 'skb' },
  { n: 'Ma Manda', i: 'skc' },
  { n: 'Southern Sierra Miwok', i: 'skd' },
  { n: 'Seke (Vanuatu)', i: 'ske' },
  { n: 'Sakirabiá', i: 'skf' },
  { n: 'Sakalava Malagasy', i: 'skg' },
  { n: 'Sikule', i: 'skh' },
  { n: 'Sika', i: 'ski' },
  { n: 'Seke (Nepal)', i: 'skj' },
  { n: 'Kutong', i: 'skm' },
  { n: 'Kolibugan Subanon', i: 'skn' },
  { n: 'Seko Tengah', i: 'sko' },
  { n: 'Sekapan', i: 'skp' },
  { n: 'Sininkere', i: 'skq' },
  { n: 'Saraiki', i: 'skr' },
  { n: 'Maia', i: 'sks' },
  { n: 'Sakata', i: 'skt' },
  { n: 'Sakao', i: 'sku' },
  { n: 'Skou', i: 'skv' },
  { n: 'Seko Padang', i: 'skx' },
  { n: 'Sikaiana', i: 'sky' },
  { n: 'Sekar', i: 'skz' },
  { n: 'Sáliba', i: 'slc' },
  { n: 'Sissala', i: 'sld' },
  { n: 'Sholaga', i: 'sle' },
  { n: 'Swiss-Italian Sign Language', i: 'slf' },
  { n: 'Selungai Murut', i: 'slg' },
  { n: 'Southern Puget Sound Salish', i: 'slh' },
  { n: 'Lower Silesian', i: 'sli' },
  { n: 'Salumá', i: 'slj' },
  { n: 'Slovak', i: 'slk' },
  { n: 'Salt-Yui', i: 'sll' },
  { n: 'Pangutaran Sama', i: 'slm' },
  { n: 'Lamaholot', i: 'slp' },
  { n: 'Salar', i: 'slr' },
  { n: 'Singapore Sign Language', i: 'sls' },
  { n: 'Sila', i: 'slt' },
  { n: 'Selaru', i: 'slu' },
  { n: 'Slovenian', i: 'slv' },
  { n: 'Sialum', i: 'slw' },
  { n: 'Salampasu', i: 'slx' },
  { n: 'Selayar', i: 'sly' },
  { n: "Ma'ya", i: 'slz' },
  { n: 'Southern Sami', i: 'sma' },
  { n: 'Simbari', i: 'smb' },
  { n: 'Sama', i: 'smd' },
  { n: 'Northern Sami', i: 'sme' },
  { n: 'Auwe', i: 'smf' },
  { n: 'Simbali', i: 'smg' },
  { n: 'Samei', i: 'smh' },
  { n: 'Lule Sami', i: 'smj' },
  { n: 'Bolinao', i: 'smk' },
  { n: 'Central Sama', i: 'sml' },
  { n: 'Musasa', i: 'smm' },
  { n: 'Inari Sami', i: 'smn' },
  { n: 'Samoan', i: 'smo' },
  { n: 'Samo', i: 'smq' },
  { n: 'Simeulue', i: 'smr' },
  { n: 'Skolt Sami', i: 'sms' },
  { n: 'Simte', i: 'smt' },
  { n: 'Samvedi', i: 'smv' },
  { n: 'Sumbawa', i: 'smw' },
  { n: 'Samba', i: 'smx' },
  { n: 'Semnani', i: 'smy' },
  { n: 'Simeku', i: 'smz' },
  { n: 'Shona', i: 'sna' },
  { n: 'Sebuyau', i: 'snb' },
  { n: 'Sinaugoro', i: 'snc' },
  { n: 'Sindhi', i: 'snd' },
  { n: 'Bau Bidayuh', i: 'sne' },
  { n: 'Noon', i: 'snf' },
  { n: 'Sanga (Democratic Republic of Congo)', i: 'sng' },
  { n: 'Riverain Sango', i: 'snj' },
  { n: 'Soninke', i: 'snk' },
  { n: 'Sangil', i: 'snl' },
  { n: "Southern Ma'di", i: 'snm' },
  { n: 'Siona', i: 'snn' },
  { n: 'Snohomish', i: 'sno' },
  { n: 'Siane', i: 'snp' },
  { n: 'Sangu (Gabon)', i: 'snq' },
  { n: 'Sihan', i: 'snr' },
  { n: 'South West Bay', i: 'sns' },
  { n: 'Senggi', i: 'snu' },
  { n: "Sa'ban", i: 'snv' },
  { n: 'Selee', i: 'snw' },
  { n: 'Sam', i: 'snx' },
  { n: 'Saniyo-Hiyewe', i: 'sny' },
  { n: 'Kou', i: 'snz' },
  { n: 'Thai Song', i: 'soa' },
  { n: 'Sobei', i: 'sob' },
  { n: 'So (Democratic Republic of Congo)', i: 'soc' },
  { n: 'Songoora', i: 'sod' },
  { n: 'Songomeno', i: 'soe' },
  { n: 'Aka', i: 'soh' },
  { n: 'Sonha', i: 'soi' },
  { n: 'Soi', i: 'soj' },
  { n: 'Sokoro', i: 'sok' },
  { n: 'Solos', i: 'sol' },
  { n: 'Somali', i: 'som' },
  { n: 'Songo', i: 'soo' },
  { n: 'Songe', i: 'sop' },
  { n: 'Kanasi', i: 'soq' },
  { n: 'Somrai', i: 'sor' },
  { n: 'Seeku', i: 'sos' },
  { n: 'Southern Sotho', i: 'sot' },
  { n: 'Southern Thai', i: 'sou' },
  { n: 'Sonsorol', i: 'sov' },
  { n: 'Sowanda', i: 'sow' },
  { n: 'Swo', i: 'sox' },
  { n: 'Miyobe', i: 'soy' },
  { n: 'Temi', i: 'soz' },
  { n: 'Spanish', i: 'spa' },
  { n: 'Sepa (Indonesia)', i: 'spb' },
  { n: 'Sapé', i: 'spc' },
  { n: 'Saep', i: 'spd' },
  { n: 'Sepa (Papua New Guinea)', i: 'spe' },
  { n: 'Sian', i: 'spg' },
  { n: 'Saponi', i: 'spi' },
  { n: 'Sengo', i: 'spk' },
  { n: 'Selepet', i: 'spl' },
  { n: 'Akukem', i: 'spm' },
  { n: 'Sanapaná', i: 'spn' },
  { n: 'Spokane', i: 'spo' },
  { n: 'Supyire Senoufo', i: 'spp' },
  { n: 'Loreto-Ucayali Spanish', i: 'spq' },
  { n: 'Saparua', i: 'spr' },
  { n: 'Saposa', i: 'sps' },
  { n: 'Spiti Bhoti', i: 'spt' },
  { n: 'Sapuan', i: 'spu' },
  { n: 'Sambalpuri', i: 'spv' },
  { n: 'Sabaot', i: 'spy' },
  { n: 'Shama-Sambuga', i: 'sqa' },
  { n: 'Shau', i: 'sqh' },
  { n: 'Albanian Sign Language', i: 'sqk' },
  { n: 'Suma', i: 'sqm' },
  { n: 'Sorkhei', i: 'sqo' },
  { n: 'Sou', i: 'sqq' },
  { n: 'Sri Lankan Sign Language', i: 'sqs' },
  { n: 'Soqotri', i: 'sqt' },
  { n: 'Squamish', i: 'squ' },
  { n: 'Saruga', i: 'sra' },
  { n: 'Sora', i: 'srb' },
  { n: 'Logudorese Sardinian', i: 'src' },
  { n: 'Sara', i: 'sre' },
  { n: 'Nafi', i: 'srf' },
  { n: 'Sulod', i: 'srg' },
  { n: 'Sarikoli', i: 'srh' },
  { n: 'Siriano', i: 'sri' },
  { n: 'Serudung Murut', i: 'srk' },
  { n: 'Isirawa', i: 'srl' },
  { n: 'Saramaccan', i: 'srm' },
  { n: 'Sranan Tongo', i: 'srn' },
  { n: 'Campidanese Sardinian', i: 'sro' },
  { n: 'Serbian', i: 'srp' },
  { n: 'Sirionó', i: 'srq' },
  { n: 'Serer', i: 'srr' },
  { n: 'Sarsi', i: 'srs' },
  { n: 'Sauri', i: 'srt' },
  { n: 'Suruí', i: 'sru' },
  { n: 'Southern Sorsoganon', i: 'srv' },
  { n: 'Serua', i: 'srw' },
  { n: 'Sirmauri', i: 'srx' },
  { n: 'Sera', i: 'sry' },
  { n: 'Shahmirzadi', i: 'srz' },
  { n: 'Southern Sama', i: 'ssb' },
  { n: 'Suba-Simbiti', i: 'ssc' },
  { n: 'Siroi', i: 'ssd' },
  { n: 'Balangingi', i: 'sse' },
  { n: 'Seimat', i: 'ssg' },
  { n: 'Shihhi Arabic', i: 'ssh' },
  { n: 'Sansi', i: 'ssi' },
  { n: 'Sausi', i: 'ssj' },
  { n: 'Sunam', i: 'ssk' },
  { n: 'Western Sisaala', i: 'ssl' },
  { n: 'Semnam', i: 'ssm' },
  { n: 'Waata', i: 'ssn' },
  { n: 'Sissano', i: 'sso' },
  { n: 'Spanish Sign Language', i: 'ssp' },
  { n: "So'a", i: 'ssq' },
  { n: 'Swiss-French Sign Language', i: 'ssr' },
  { n: 'Sô', i: 'sss' },
  { n: 'Sinasina', i: 'sst' },
  { n: 'Susuami', i: 'ssu' },
  { n: 'Shark Bay', i: 'ssv' },
  { n: 'Swati', i: 'ssw' },
  { n: 'Samberigi', i: 'ssx' },
  { n: 'Saho', i: 'ssy' },
  { n: 'Sengseng', i: 'ssz' },
  { n: 'Settla', i: 'sta' },
  { n: 'Northern Subanen', i: 'stb' },
  { n: 'Sentinel', i: 'std' },
  { n: 'Liana-Seti', i: 'ste' },
  { n: 'Seta', i: 'stf' },
  { n: 'Trieng', i: 'stg' },
  { n: 'Shelta', i: 'sth' },
  { n: 'Bulo Stieng', i: 'sti' },
  { n: 'Matya Samo', i: 'stj' },
  { n: 'Arammba', i: 'stk' },
  { n: 'Stellingwerfs', i: 'stl' },
  { n: 'Setaman', i: 'stm' },
  { n: 'Owa', i: 'stn' },
  { n: 'Stoney', i: 'sto' },
  { n: 'Southeastern Tepehuan', i: 'stp' },
  { n: 'Saterfriesisch', i: 'stq' },
  { n: 'Straits Salish', i: 'str' },
  { n: 'Shumashti', i: 'sts' },
  { n: 'Budeh Stieng', i: 'stt' },
  { n: 'Samtao', i: 'stu' },
  { n: "Silt'e", i: 'stv' },
  { n: 'Satawalese', i: 'stw' },
  { n: 'Siberian Tatar', i: 'sty' },
  { n: 'Sulka', i: 'sua' },
  { n: 'Suku', i: 'sub' },
  { n: 'Western Subanon', i: 'suc' },
  { n: 'Suena', i: 'sue' },
  { n: 'Suganga', i: 'sug' },
  { n: 'Suki', i: 'sui' },
  { n: 'Shubi', i: 'suj' },
  { n: 'Sukuma', i: 'suk' },
  { n: 'Sundanese', i: 'sun' },
  { n: 'Suri', i: 'suq' },
  { n: 'Mwaghavul', i: 'sur' },
  { n: 'Susu', i: 'sus' },
  { n: 'Puroik', i: 'suv' },
  { n: 'Sumbwa', i: 'suw' },
  { n: 'Suyá', i: 'suy' },
  { n: 'Sunwar', i: 'suz' },
  { n: 'Svan', i: 'sva' },
  { n: 'Ulau-Suain', i: 'svb' },
  { n: 'Vincentian Creole English', i: 'svc' },
  { n: 'Serili', i: 'sve' },
  { n: 'Slovakian Sign Language', i: 'svk' },
  { n: 'Slavomolisano', i: 'svm' },
  { n: 'Savosavo', i: 'svs' },
  { n: 'Maore Comorian', i: 'swb' },
  { n: 'Congo Swahili', i: 'swc' },
  { n: 'Swedish', i: 'swe' },
  { n: 'Sere', i: 'swf' },
  { n: 'Swabian', i: 'swg' },
  { n: 'Swahili (individual language)', i: 'swh' },
  { n: 'Sui', i: 'swi' },
  { n: 'Sira', i: 'swj' },
  { n: 'Malawi Sena', i: 'swk' },
  { n: 'Swedish Sign Language', i: 'swl' },
  { n: 'Samosa', i: 'swm' },
  { n: 'Sawknah', i: 'swn' },
  { n: 'Shanenawa', i: 'swo' },
  { n: 'Suau', i: 'swp' },
  { n: 'Sharwa', i: 'swq' },
  { n: 'Saweru', i: 'swr' },
  { n: 'Seluwasan', i: 'sws' },
  { n: 'Sawila', i: 'swt' },
  { n: 'Suwawa', i: 'swu' },
  { n: 'Shekhawati', i: 'swv' },
  { n: 'Suruahá', i: 'swx' },
  { n: 'Sarua', i: 'swy' },
  { n: 'Suba', i: 'sxb' },
  { n: 'Sighu', i: 'sxe' },
  { n: 'Shuhi', i: 'sxg' },
  { n: 'Samre', i: 'sxm' },
  { n: 'Sangir', i: 'sxn' },
  { n: 'Saaroa', i: 'sxr' },
  { n: 'Sasaru', i: 'sxs' },
  { n: 'Upper Saxon', i: 'sxu' },
  { n: 'Saxwe Gbe', i: 'sxw' },
  { n: 'Siang', i: 'sya' },
  { n: 'Central Subanen', i: 'syb' },
  { n: 'Seki', i: 'syi' },
  { n: 'Sukur', i: 'syk' },
  { n: 'Sylheti', i: 'syl' },
  { n: 'Maya Samo', i: 'sym' },
  { n: 'Senaya', i: 'syn' },
  { n: 'Suoy', i: 'syo' },
  { n: 'Sinyar', i: 'sys' },
  { n: 'Kagate', i: 'syw' },
  { n: 'Samay', i: 'syx' },
  { n: 'Al-Sayyid Bedouin Sign Language', i: 'syy' },
  { n: 'Semelai', i: 'sza' },
  { n: 'Ngalum', i: 'szb' },
  { n: 'Semaq Beri', i: 'szc' },
  { n: 'Seze', i: 'sze' },
  { n: 'Sengele', i: 'szg' },
  { n: 'Silesian', i: 'szl' },
  { n: 'Sula', i: 'szn' },
  { n: 'Suabo', i: 'szp' },
  { n: 'Solomon Islands Sign Language', i: 'szs' },
  { n: 'Isu (Fako Division)', i: 'szv' },
  { n: 'Sawai', i: 'szw' },
  { n: 'Sakizaya', i: 'szy' },
  { n: 'Lower Tanana', i: 'taa' },
  { n: 'Tabassaran', i: 'tab' },
  { n: 'Lowland Tarahumara', i: 'tac' },
  { n: 'Tause', i: 'tad' },
  { n: 'Tariana', i: 'tae' },
  { n: 'Tapirapé', i: 'taf' },
  { n: 'Tagoi', i: 'tag' },
  { n: 'Tahitian', i: 'tah' },
  { n: 'Eastern Tamang', i: 'taj' },
  { n: 'Tala', i: 'tak' },
  { n: 'Tal', i: 'tal' },
  { n: 'Tamil', i: 'tam' },
  { n: 'Tangale', i: 'tan' },
  { n: 'Yami', i: 'tao' },
  { n: 'Taabwa', i: 'tap' },
  { n: 'Tamasheq', i: 'taq' },
  { n: 'Central Tarahumara', i: 'tar' },
  { n: 'Tatar', i: 'tat' },
  { n: 'Upper Tanana', i: 'tau' },
  { n: 'Tatuyo', i: 'tav' },
  { n: 'Tai', i: 'taw' },
  { n: 'Tamki', i: 'tax' },
  { n: 'Atayal', i: 'tay' },
  { n: 'Tocho', i: 'taz' },
  { n: 'Aikanã', i: 'tba' },
  { n: 'Takia', i: 'tbc' },
  { n: 'Kaki Ae', i: 'tbd' },
  { n: 'Tanimbili', i: 'tbe' },
  { n: 'Mandara', i: 'tbf' },
  { n: 'North Tairora', i: 'tbg' },
  { n: 'Gaam', i: 'tbi' },
  { n: 'Tiang', i: 'tbj' },
  { n: 'Calamian Tagbanwa', i: 'tbk' },
  { n: 'Tboli', i: 'tbl' },
  { n: 'Tagbu', i: 'tbm' },
  { n: 'Barro Negro Tunebo', i: 'tbn' },
  { n: 'Tawala', i: 'tbo' },
  { n: 'Taworta', i: 'tbp' },
  { n: 'Tumtum', i: 'tbr' },
  { n: 'Tanguat', i: 'tbs' },
  { n: 'Tembo (Kitembo)', i: 'tbt' },
  { n: 'Tobo', i: 'tbv' },
  { n: 'Tagbanwa', i: 'tbw' },
  { n: 'Kapin', i: 'tbx' },
  { n: 'Tabaru', i: 'tby' },
  { n: 'Ditammari', i: 'tbz' },
  { n: 'Ticuna', i: 'tca' },
  { n: 'Tanacross', i: 'tcb' },
  { n: 'Datooga', i: 'tcc' },
  { n: 'Tafi', i: 'tcd' },
  { n: 'Southern Tutchone', i: 'tce' },
  { n: "Malinaltepec Me'phaa", i: 'tcf' },
  { n: 'Tamagario', i: 'tcg' },
  { n: 'Turks And Caicos Creole English', i: 'tch' },
  { n: 'Wára', i: 'tci' },
  { n: 'Tchitchege', i: 'tck' },
  { n: 'Tanahmerah', i: 'tcm' },
  { n: 'Tichurong', i: 'tcn' },
  { n: 'Taungyo', i: 'tco' },
  { n: 'Tawr Chin', i: 'tcp' },
  { n: 'Kaiy', i: 'tcq' },
  { n: 'Torres Strait Creole', i: 'tcs' },
  { n: "T'en", i: 'tct' },
  { n: 'Southeastern Tarahumara', i: 'tcu' },
  { n: 'Tecpatlán Totonac', i: 'tcw' },
  { n: 'Toda', i: 'tcx' },
  { n: 'Tulu', i: 'tcy' },
  { n: 'Thado Chin', i: 'tcz' },
  { n: 'Tagdal', i: 'tda' },
  { n: 'Panchpargania', i: 'tdb' },
  { n: 'Emberá-Tadó', i: 'tdc' },
  { n: 'Tai Nüa', i: 'tdd' },
  { n: 'Tiranige Diga Dogon', i: 'tde' },
  { n: 'Talieng', i: 'tdf' },
  { n: 'Western Tamang', i: 'tdg' },
  { n: 'Thulung', i: 'tdh' },
  { n: 'Tomadino', i: 'tdi' },
  { n: 'Tajio', i: 'tdj' },
  { n: 'Tambas', i: 'tdk' },
  { n: 'Sur', i: 'tdl' },
  { n: 'Taruma', i: 'tdm' },
  { n: 'Tondano', i: 'tdn' },
  { n: 'Teme', i: 'tdo' },
  { n: 'Tita', i: 'tdq' },
  { n: 'Todrah', i: 'tdr' },
  { n: 'Doutai', i: 'tds' },
  { n: 'Tetun Dili', i: 'tdt' },
  { n: 'Toro', i: 'tdv' },
  { n: 'Tandroy-Mahafaly Malagasy', i: 'tdx' },
  { n: 'Tadyawan', i: 'tdy' },
  { n: 'Temiar', i: 'tea' },
  { n: 'Terik', i: 'tec' },
  { n: 'Tepo Krumen', i: 'ted' },
  { n: 'Huehuetla Tepehua', i: 'tee' },
  { n: 'Teressa', i: 'tef' },
  { n: 'Teke-Tege', i: 'teg' },
  { n: 'Tehuelche', i: 'teh' },
  { n: 'Torricelli', i: 'tei' },
  { n: 'Ibali Teke', i: 'tek' },
  { n: 'Telugu', i: 'tel' },
  { n: 'Timne', i: 'tem' },
  { n: 'Teso', i: 'teo' },
  { n: 'Temein', i: 'teq' },
  { n: 'Tereno', i: 'ter' },
  { n: 'Tengger', i: 'tes' },
  { n: 'Tetum', i: 'tet' },
  { n: 'Soo', i: 'teu' },
  { n: 'Teor', i: 'tev' },
  { n: 'Tewa (USA)', i: 'tew' },
  { n: 'Tennet', i: 'tex' },
  { n: 'Tulishi', i: 'tey' },
  { n: 'Tetserret', i: 'tez' },
  { n: 'Tofin Gbe', i: 'tfi' },
  { n: 'Tanaina', i: 'tfn' },
  { n: 'Tefaro', i: 'tfo' },
  { n: 'Teribe', i: 'tfr' },
  { n: 'Ternate', i: 'tft' },
  { n: 'Sagalla', i: 'tga' },
  { n: 'Tobilung', i: 'tgb' },
  { n: 'Tigak', i: 'tgc' },
  { n: 'Ciwogai', i: 'tgd' },
  { n: 'Eastern Gorkha Tamang', i: 'tge' },
  { n: 'Chalikha', i: 'tgf' },
  { n: 'Tobagonian Creole English', i: 'tgh' },
  { n: 'Lawunuia', i: 'tgi' },
  { n: 'Tagin', i: 'tgj' },
  { n: 'Tajik', i: 'tgk' },
  { n: 'Tagalog', i: 'tgl' },
  { n: 'Tandaganon', i: 'tgn' },
  { n: 'Sudest', i: 'tgo' },
  { n: 'Tangoa', i: 'tgp' },
  { n: 'Tring', i: 'tgq' },
  { n: 'Tareng', i: 'tgr' },
  { n: 'Nume', i: 'tgs' },
  { n: 'Central Tagbanwa', i: 'tgt' },
  { n: 'Tanggu', i: 'tgu' },
  { n: 'Tagwana Senoufo', i: 'tgw' },
  { n: 'Tagish', i: 'tgx' },
  { n: 'Thai', i: 'tha' },
  { n: 'Kuuk Thaayorre', i: 'thd' },
  { n: 'Chitwania Tharu', i: 'the' },
  { n: 'Thangmi', i: 'thf' },
  { n: 'Northern Tarahumara', i: 'thh' },
  { n: 'Tai Long', i: 'thi' },
  { n: 'Tharaka', i: 'thk' },
  { n: 'Dangaura Tharu', i: 'thl' },
  { n: 'Aheu', i: 'thm' },
  { n: 'Thachanadan', i: 'thn' },
  { n: 'Thompson', i: 'thp' },
  { n: 'Kochila Tharu', i: 'thq' },
  { n: 'Rana Tharu', i: 'thr' },
  { n: 'Thakali', i: 'ths' },
  { n: 'Tahltan', i: 'tht' },
  { n: 'Thuri', i: 'thu' },
  { n: 'Tahaggart Tamahaq', i: 'thv' },
  { n: 'Tha', i: 'thy' },
  { n: 'Tayart Tamajeq', i: 'thz' },
  { n: 'Tidikelt Tamazight', i: 'tia' },
  { n: 'Tira', i: 'tic' },
  { n: 'Tifal', i: 'tif' },
  { n: 'Tigre', i: 'tig' },
  { n: 'Timugon Murut', i: 'tih' },
  { n: 'Tiene', i: 'tii' },
  { n: 'Tilung', i: 'tij' },
  { n: 'Tikar', i: 'tik' },
  { n: 'Timbe', i: 'tim' },
  { n: 'Tindi', i: 'tin' },
  { n: 'Teop', i: 'tio' },
  { n: 'Trimuris', i: 'tip' },
  { n: 'Tiéfo', i: 'tiq' },
  { n: 'Tigrinya', i: 'tir' },
  { n: 'Masadiit Itneg', i: 'tis' },
  { n: 'Tinigua', i: 'tit' },
  { n: 'Adasen', i: 'tiu' },
  { n: 'Tiv', i: 'tiv' },
  { n: 'Tiwi', i: 'tiw' },
  { n: 'Southern Tiwa', i: 'tix' },
  { n: 'Tiruray', i: 'tiy' },
  { n: 'Tai Hongjin', i: 'tiz' },
  { n: 'Tajuasohn', i: 'tja' },
  { n: 'Tunjung', i: 'tjg' },
  { n: 'Northern Tujia', i: 'tji' },
  { n: 'Tjungundji', i: 'tjj' },
  { n: 'Tai Laing', i: 'tjl' },
  { n: 'Temacine Tamazight', i: 'tjo' },
  { n: 'Tjupany', i: 'tjp' },
  { n: 'Southern Tujia', i: 'tjs' },
  { n: 'Djabwurrung', i: 'tjw' },
  { n: 'Buksa', i: 'tkb' },
  { n: 'Tukudede', i: 'tkd' },
  { n: 'Takwane', i: 'tke' },
  { n: 'Tesaka Malagasy', i: 'tkg' },
  { n: 'Tokelau', i: 'tkl' },
  { n: 'Toku-No-Shima', i: 'tkn' },
  { n: 'Tikopia', i: 'tkp' },
  { n: 'Tee', i: 'tkq' },
  { n: 'Tsakhur', i: 'tkr' },
  { n: 'Takestani', i: 'tks' },
  { n: 'Kathoriya Tharu', i: 'tkt' },
  { n: 'Upper Necaxa Totonac', i: 'tku' },
  { n: 'Mur Pano', i: 'tkv' },
  { n: 'Teanu', i: 'tkw' },
  { n: 'Tangko', i: 'tkx' },
  { n: 'Takua', i: 'tkz' },
  { n: 'Southwestern Tepehuan', i: 'tla' },
  { n: 'Tobelo', i: 'tlb' },
  { n: 'Yecuatla Totonac', i: 'tlc' },
  { n: 'Talaud', i: 'tld' },
  { n: 'Telefol', i: 'tlf' },
  { n: 'Tofanma', i: 'tlg' },
  { n: 'Tlingit', i: 'tli' },
  { n: 'Talinga-Bwisi', i: 'tlj' },
  { n: 'Taloki', i: 'tlk' },
  { n: 'Tetela', i: 'tll' },
  { n: 'Tolomako', i: 'tlm' },
  { n: "Talondo'", i: 'tln' },
  { n: 'Talodi', i: 'tlo' },
  { n: 'Filomena Mata-Coahuitlán Totonac', i: 'tlp' },
  { n: 'Tai Loi', i: 'tlq' },
  { n: 'Talise', i: 'tlr' },
  { n: 'Tambotalo', i: 'tls' },
  { n: 'Sou Nama', i: 'tlt' },
  { n: 'Tulehu', i: 'tlu' },
  { n: 'Taliabu', i: 'tlv' },
  { n: 'Khehek', i: 'tlx' },
  { n: 'Talysh', i: 'tly' },
  { n: 'Tama (Chad)', i: 'tma' },
  { n: 'Katbol', i: 'tmb' },
  { n: 'Tumak', i: 'tmc' },
  { n: 'Haruai', i: 'tmd' },
  { n: 'Toba-Maskoy', i: 'tmf' },
  { n: 'Tutuba', i: 'tmi' },
  { n: 'Samarokena', i: 'tmj' },
  { n: 'Northwestern Tamang', i: 'tmk' },
  { n: 'Tamnim Citak', i: 'tml' },
  { n: 'Tai Thanh', i: 'tmm' },
  { n: 'Taman (Indonesia)', i: 'tmn' },
  { n: 'Temoq', i: 'tmo' },
  { n: 'Tumleo', i: 'tmq' },
  { n: 'Tima', i: 'tms' },
  { n: 'Tasmate', i: 'tmt' },
  { n: 'Iau', i: 'tmu' },
  { n: 'Tembo (Motembo)', i: 'tmv' },
  { n: 'Temuan', i: 'tmw' },
  { n: 'Tami', i: 'tmy' },
  { n: 'Tacana', i: 'tna' },
  { n: 'Western Tunebo', i: 'tnb' },
  { n: 'Tanimuca-Retuarã', i: 'tnc' },
  { n: 'Angosturas Tunebo', i: 'tnd' },
  { n: 'Tobanga', i: 'tng' },
  { n: 'Maiani', i: 'tnh' },
  { n: 'Tandia', i: 'tni' },
  { n: 'Kwamera', i: 'tnk' },
  { n: 'Lenakel', i: 'tnl' },
  { n: 'Tabla', i: 'tnm' },
  { n: 'North Tanna', i: 'tnn' },
  { n: 'Toromono', i: 'tno' },
  { n: 'Whitesands', i: 'tnp' },
  { n: 'Ménik', i: 'tnr' },
  { n: 'Tenis', i: 'tns' },
  { n: 'Tontemboan', i: 'tnt' },
  { n: 'Tay Khang', i: 'tnu' },
  { n: 'Tangchangya', i: 'tnv' },
  { n: 'Tonsawang', i: 'tnw' },
  { n: 'Tanema', i: 'tnx' },
  { n: 'Tongwe', i: 'tny' },
  { n: "Ten'edn", i: 'tnz' },
  { n: 'Toba', i: 'tob' },
  { n: 'Coyutla Totonac', i: 'toc' },
  { n: 'Toma', i: 'tod' },
  { n: 'Gizrra', i: 'tof' },
  { n: 'Tonga (Nyasa)', i: 'tog' },
  { n: 'Gitonga', i: 'toh' },
  { n: 'Tonga (Zambia)', i: 'toi' },
  { n: 'Tojolabal', i: 'toj' },
  { n: 'Tombulu', i: 'tom' },
  { n: 'Tonga (Tonga Islands)', i: 'ton' },
  { n: 'Xicotepec De Juárez Totonac', i: 'too' },
  { n: 'Papantla Totonac', i: 'top' },
  { n: 'Toposa', i: 'toq' },
  { n: 'Togbo-Vara Banda', i: 'tor' },
  { n: 'Highland Totonac', i: 'tos' },
  { n: 'Tho', i: 'tou' },
  { n: 'Upper Taromi', i: 'tov' },
  { n: 'Jemez', i: 'tow' },
  { n: 'Tobian', i: 'tox' },
  { n: 'Topoiyo', i: 'toy' },
  { n: 'To', i: 'toz' },
  { n: 'Taupota', i: 'tpa' },
  { n: "Azoyú Me'phaa", i: 'tpc' },
  { n: 'Tippera', i: 'tpe' },
  { n: 'Tarpia', i: 'tpf' },
  { n: 'Kula', i: 'tpg' },
  { n: 'Tok Pisin', i: 'tpi' },
  { n: 'Tapieté', i: 'tpj' },
  { n: "Tlacoapa Me'phaa", i: 'tpl' },
  { n: 'Tampulma', i: 'tpm' },
  { n: 'Tai Pao', i: 'tpo' },
  { n: 'Pisaflores Tepehua', i: 'tpp' },
  { n: 'Tukpa', i: 'tpq' },
  { n: 'Tuparí', i: 'tpr' },
  { n: 'Tlachichilco Tepehua', i: 'tpt' },
  { n: 'Tampuan', i: 'tpu' },
  { n: 'Tanapag', i: 'tpv' },
  { n: "Acatepec Me'phaa", i: 'tpx' },
  { n: 'Trumai', i: 'tpy' },
  { n: 'Tinputz', i: 'tpz' },
  { n: 'Tembé', i: 'tqb' },
  { n: 'Lehali', i: 'tql' },
  { n: 'Turumsa', i: 'tqm' },
  { n: 'Tenino', i: 'tqn' },
  { n: 'Toaripi', i: 'tqo' },
  { n: 'Tomoip', i: 'tqp' },
  { n: 'Tunni', i: 'tqq' },
  { n: 'Western Totonac', i: 'tqt' },
  { n: 'Touo', i: 'tqu' },
  { n: 'Tirahi', i: 'tra' },
  { n: 'Terebu', i: 'trb' },
  { n: 'Copala Triqui', i: 'trc' },
  { n: 'Turi', i: 'trd' },
  { n: 'East Tarangan', i: 'tre' },
  { n: 'Trinidadian Creole English', i: 'trf' },
  { n: 'Lishán Didán', i: 'trg' },
  { n: 'Turaka', i: 'trh' },
  { n: 'Trió', i: 'tri' },
  { n: 'Toram', i: 'trj' },
  { n: 'Traveller Scottish', i: 'trl' },
  { n: 'Tregami', i: 'trm' },
  { n: 'Trinitario', i: 'trn' },
  { n: 'Tarao Naga', i: 'tro' },
  { n: 'Kok Borok', i: 'trp' },
  { n: 'San Martín Itunyoso Triqui', i: 'trq' },
  { n: 'Taushiro', i: 'trr' },
  { n: 'Chicahuaxtla Triqui', i: 'trs' },
  { n: 'Tunggare', i: 'trt' },
  { n: 'Turoyo', i: 'tru' },
  { n: 'Taroko', i: 'trv' },
  { n: 'Torwali', i: 'trw' },
  { n: 'Tringgus-Sembaan Bidayuh', i: 'trx' },
  { n: 'Tsaangi', i: 'tsa' },
  { n: 'Tsamai', i: 'tsb' },
  { n: 'Tswa', i: 'tsc' },
  { n: 'Tsakonian', i: 'tsd' },
  { n: 'Tunisian Sign Language', i: 'tse' },
  { n: 'Tausug', i: 'tsg' },
  { n: 'Tsuvan', i: 'tsh' },
  { n: 'Tsimshian', i: 'tsi' },
  { n: 'Tshangla', i: 'tsj' },
  { n: 'Tseku', i: 'tsk' },
  { n: "Ts'ün-Lao", i: 'tsl' },
  { n: 'Turkish Sign Language', i: 'tsm' },
  { n: 'Tswana', i: 'tsn' },
  { n: 'Tsonga', i: 'tso' },
  { n: 'Northern Toussian', i: 'tsp' },
  { n: 'Thai Sign Language', i: 'tsq' },
  { n: 'Akei', i: 'tsr' },
  { n: 'Taiwan Sign Language', i: 'tss' },
  { n: 'Tondi Songway Kiini', i: 'tst' },
  { n: 'Tsou', i: 'tsu' },
  { n: 'Tsogo', i: 'tsv' },
  { n: 'Tsishingini', i: 'tsw' },
  { n: 'Mubami', i: 'tsx' },
  { n: 'Tebul Sign Language', i: 'tsy' },
  { n: 'Purepecha', i: 'tsz' },
  { n: 'Gaa', i: 'ttb' },
  { n: 'Tektiteko', i: 'ttc' },
  { n: 'Tauade', i: 'ttd' },
  { n: 'Bwanabwana', i: 'tte' },
  { n: 'Tuotomb', i: 'ttf' },
  { n: 'Tutong', i: 'ttg' },
  { n: "Upper Ta'oih", i: 'tth' },
  { n: 'Tobati', i: 'tti' },
  { n: 'Tooro', i: 'ttj' },
  { n: 'Totoro', i: 'ttk' },
  { n: 'Totela', i: 'ttl' },
  { n: 'Northern Tutchone', i: 'ttm' },
  { n: 'Towei', i: 'ttn' },
  { n: "Lower Ta'oih", i: 'tto' },
  { n: 'Tombelala', i: 'ttp' },
  { n: 'Tawallammat Tamajaq', i: 'ttq' },
  { n: 'Tera', i: 'ttr' },
  { n: 'Northeastern Thai', i: 'tts' },
  { n: 'Muslim Tat', i: 'ttt' },
  { n: 'Torau', i: 'ttu' },
  { n: 'Titan', i: 'ttv' },
  { n: 'Long Wat', i: 'ttw' },
  { n: 'Sikaritai', i: 'tty' },
  { n: 'Tsum', i: 'ttz' },
  { n: 'Wiarumus', i: 'tua' },
  { n: 'Mutu', i: 'tuc' },
  { n: 'Tuyuca', i: 'tue' },
  { n: 'Central Tunebo', i: 'tuf' },
  { n: 'Tunia', i: 'tug' },
  { n: 'Taulil', i: 'tuh' },
  { n: 'Tupuri', i: 'tui' },
  { n: 'Tugutil', i: 'tuj' },
  { n: 'Turkmen', i: 'tuk' },
  { n: 'Tula', i: 'tul' },
  { n: 'Tumbuka', i: 'tum' },
  { n: 'Tunica', i: 'tun' },
  { n: 'Tucano', i: 'tuo' },
  { n: 'Tedaga', i: 'tuq' },
  { n: 'Turkish', i: 'tur' },
  { n: 'Tuscarora', i: 'tus' },
  { n: 'Tututni', i: 'tuu' },
  { n: 'Turkana', i: 'tuv' },
  { n: 'Tugen', i: 'tuy' },
  { n: 'Turka', i: 'tuz' },
  { n: 'Vaghua', i: 'tva' },
  { n: 'Tsuvadi', i: 'tvd' },
  { n: "Te'un", i: 'tve' },
  { n: 'Southeast Ambrym', i: 'tvk' },
  { n: 'Tuvalu', i: 'tvl' },
  { n: 'Tela-Masbuar', i: 'tvm' },
  { n: 'Tavoyan', i: 'tvn' },
  { n: 'Tidore', i: 'tvo' },
  { n: 'Taveta', i: 'tvs' },
  { n: 'Tutsa Naga', i: 'tvt' },
  { n: 'Tunen', i: 'tvu' },
  { n: 'Sedoa', i: 'tvw' },
  { n: 'Western Tawbuid', i: 'twb' },
  { n: 'Twents', i: 'twd' },
  { n: 'Tewa (Indonesia)', i: 'twe' },
  { n: 'Northern Tiwa', i: 'twf' },
  { n: 'Tereweng', i: 'twg' },
  { n: 'Tai Dón', i: 'twh' },
  { n: 'Twi', i: 'twi' },
  { n: 'Tawara', i: 'twl' },
  { n: 'Tawang Monpa', i: 'twm' },
  { n: 'Twendi', i: 'twn' },
  { n: 'Tswapong', i: 'two' },
  { n: 'Ere', i: 'twp' },
  { n: 'Tasawaq', i: 'twq' },
  { n: 'Southwestern Tarahumara', i: 'twr' },
  { n: 'Termanu', i: 'twu' },
  { n: 'Tuwari', i: 'tww' },
  { n: 'Tewe', i: 'twx' },
  { n: 'Tawoyan', i: 'twy' },
  { n: 'Tombonuo', i: 'txa' },
  { n: 'Totoli', i: 'txe' },
  { n: 'Ikpeng', i: 'txi' },
  { n: 'Tarjumo', i: 'txj' },
  { n: 'Tomini', i: 'txm' },
  { n: 'West Tarangan', i: 'txn' },
  { n: 'Toto', i: 'txo' },
  { n: 'Tii', i: 'txq' },
  { n: 'Tonsea', i: 'txs' },
  { n: 'Citak', i: 'txt' },
  { n: 'Kayapó', i: 'txu' },
  { n: 'Tatana', i: 'txx' },
  { n: 'Tanosy Malagasy', i: 'txy' },
  { n: 'Tauya', i: 'tya' },
  { n: 'Kyanga', i: 'tye' },
  { n: "O'du", i: 'tyh' },
  { n: 'Teke-Tsaayi', i: 'tyi' },
  { n: 'Tai Do', i: 'tyj' },
  { n: 'Thu Lao', i: 'tyl' },
  { n: 'Kombai', i: 'tyn' },
  { n: 'Tai Daeng', i: 'tyr' },
  { n: 'Tày Sa Pa', i: 'tys' },
  { n: 'Tày Tac', i: 'tyt' },
  { n: 'Kua', i: 'tyu' },
  { n: 'Tuvinian', i: 'tyv' },
  { n: 'Teke-Tyee', i: 'tyx' },
  { n: 'Tày', i: 'tyz' },
  { n: 'Tanzanian Sign Language', i: 'tza' },
  { n: 'Tzeltal', i: 'tzh' },
  { n: "Tz'utujil", i: 'tzj' },
  { n: 'Central Atlas Tamazight', i: 'tzm' },
  { n: 'Tugun', i: 'tzn' },
  { n: 'Tzotzil', i: 'tzo' },
  { n: 'Tabriak', i: 'tzx' },
  { n: 'Kuan', i: 'uan' },
  { n: 'Tairuma', i: 'uar' },
  { n: 'Ubang', i: 'uba' },
  { n: 'Ubi', i: 'ubi' },
  { n: "Buhi'non Bikol", i: 'ubl' },
  { n: 'Ubir', i: 'ubr' },
  { n: 'Umbu-Ungu', i: 'ubu' },
  { n: 'Uda', i: 'uda' },
  { n: 'Udihe', i: 'ude' },
  { n: 'Muduga', i: 'udg' },
  { n: 'Udi', i: 'udi' },
  { n: 'Ujir', i: 'udj' },
  { n: 'Wuzlam', i: 'udl' },
  { n: 'Udmurt', i: 'udm' },
  { n: 'Uduk', i: 'udu' },
  { n: 'Kioko', i: 'ues' },
  { n: 'Ufim', i: 'ufi' },
  { n: 'Ughele', i: 'uge' },
  { n: 'Ugandan Sign Language', i: 'ugn' },
  { n: 'Ugong', i: 'ugo' },
  { n: 'Uruguayan Sign Language', i: 'ugy' },
  { n: 'Uhami', i: 'uha' },
  { n: 'Damal', i: 'uhn' },
  { n: 'Uighur', i: 'uig' },
  { n: 'Uisai', i: 'uis' },
  { n: 'Iyive', i: 'uiv' },
  { n: 'Tanjijili', i: 'uji' },
  { n: 'Kaburi', i: 'uka' },
  { n: 'Ukuriguma', i: 'ukg' },
  { n: 'Ukhwejo', i: 'ukh' },
  { n: 'Kui (India)', i: 'uki' },
  { n: 'Muak Sa-aak', i: 'ukk' },
  { n: 'Ukrainian Sign Language', i: 'ukl' },
  { n: 'Ukpe-Bayobiri', i: 'ukp' },
  { n: 'Ukwa', i: 'ukq' },
  { n: 'Ukrainian', i: 'ukr' },
  { n: 'Urubú-Kaapor Sign Language', i: 'uks' },
  { n: 'Ukue', i: 'uku' },
  { n: 'Kuku', i: 'ukv' },
  { n: 'Ukwuani-Aboh-Ndoni', i: 'ukw' },
  { n: 'Fungwa', i: 'ula' },
  { n: 'Ulukwumi', i: 'ulb' },
  { n: 'Ulch', i: 'ulc' },
  { n: 'Usku', i: 'ulf' },
  { n: 'Ulithian', i: 'uli' },
  { n: 'Meriam Mir', i: 'ulk' },
  { n: 'Ullatan', i: 'ull' },
  { n: "Ulumanda'", i: 'ulm' },
  { n: 'Unserdeutsch', i: 'uln' },
  { n: "Uma' Lung", i: 'ulu' },
  { n: 'Ulwa', i: 'ulw' },
  { n: 'Umatilla', i: 'uma' },
  { n: 'Umbundu', i: 'umb' },
  { n: 'Ukit', i: 'umi' },
  { n: 'Umon', i: 'umm' },
  { n: 'Makyan Naga', i: 'umn' },
  { n: 'Umpila', i: 'ump' },
  { n: 'Pendau', i: 'ums' },
  { n: 'Munsee', i: 'umu' },
  { n: 'North Watut', i: 'una' },
  { n: 'Uneme', i: 'une' },
  { n: 'Ngarinyin', i: 'ung' },
  { n: 'Enawené-Nawé', i: 'unk' },
  { n: 'Kurnai', i: 'unn' },
  { n: 'Mundari', i: 'unr' },
  { n: 'Unubahe', i: 'unu' },
  { n: 'Munda', i: 'unx' },
  { n: 'Unde Kaili', i: 'unz' },
  { n: 'Umeda', i: 'upi' },
  { n: 'Uripiv-Wala-Rano-Atchin', i: 'upv' },
  { n: 'Urarina', i: 'ura' },
  { n: 'Urubú-Kaapor', i: 'urb' },
  { n: 'Urdu', i: 'urd' },
  { n: 'Uru', i: 'ure' },
  { n: 'Urigina', i: 'urg' },
  { n: 'Urhobo', i: 'urh' },
  { n: 'Urim', i: 'uri' },
  { n: "Urak Lawoi'", i: 'urk' },
  { n: 'Urali', i: 'url' },
  { n: 'Urapmin', i: 'urm' },
  { n: 'Uruangnirin', i: 'urn' },
  { n: 'Ura (Papua New Guinea)', i: 'uro' },
  { n: 'Uru-Pa-In', i: 'urp' },
  { n: 'Lehalurup', i: 'urr' },
  { n: 'Urat', i: 'urt' },
  { n: 'Sop', i: 'urw' },
  { n: 'Urimo', i: 'urx' },
  { n: 'Orya', i: 'ury' },
  { n: 'Uru-Eu-Wau-Wau', i: 'urz' },
  { n: 'Usarufa', i: 'usa' },
  { n: 'Ushojo', i: 'ush' },
  { n: 'Usui', i: 'usi' },
  { n: 'Usaghade', i: 'usk' },
  { n: 'Uspanteco', i: 'usp' },
  { n: 'us-Saare', i: 'uss' },
  { n: 'Uya', i: 'usu' },
  { n: 'Otank', i: 'uta' },
  { n: 'Ute-Southern Paiute', i: 'ute' },
  { n: 'ut-Hun', i: 'uth' },
  { n: 'Amba (Solomon Islands)', i: 'utp' },
  { n: 'Etulo', i: 'utr' },
  { n: 'Utu', i: 'utu' },
  { n: 'Urum', i: 'uum' },
  { n: 'Kulon-Pazeh', i: 'uun' },
  { n: 'Ura (Vanuatu)', i: 'uur' },
  { n: 'U', i: 'uuu' },
  { n: 'West Uvean', i: 'uve' },
  { n: 'Uri', i: 'uvh' },
  { n: 'Lote', i: 'uvl' },
  { n: 'Kuku-Uwanh', i: 'uwa' },
  { n: 'Doko-Uyanga', i: 'uya' },
  { n: 'Northern Uzbek', i: 'uzn' },
  { n: 'Southern Uzbek', i: 'uzs' },
  { n: 'Vaagri Booli', i: 'vaa' },
  { n: 'Vale', i: 'vae' },
  { n: 'Vafsi', i: 'vaf' },
  { n: 'Vagla', i: 'vag' },
  { n: 'Varhadi-Nagpuri', i: 'vah' },
  { n: 'Vai', i: 'vai' },
  { n: 'Sekele', i: 'vaj' },
  { n: 'Vehes', i: 'val' },
  { n: 'Vanimo', i: 'vam' },
  { n: 'Valman', i: 'van' },
  { n: 'Vao', i: 'vao' },
  { n: 'Vaiphei', i: 'vap' },
  { n: 'Huarijio', i: 'var' },
  { n: 'Vasavi', i: 'vas' },
  { n: 'Vanuma', i: 'vau' },
  { n: 'Varli', i: 'vav' },
  { n: 'Wayu', i: 'vay' },
  { n: 'Southeast Babar', i: 'vbb' },
  { n: 'Southwestern Bontok', i: 'vbk' },
  { n: 'Venetian', i: 'vec' },
  { n: 'Veddah', i: 'ved' },
  { n: 'Veluws', i: 'vel' },
  { n: 'Vemgo-Mabas', i: 'vem' },
  { n: 'Venda', i: 'ven' },
  { n: 'Veps', i: 'vep' },
  { n: 'Mom Jango', i: 'ver' },
  { n: 'Vaghri', i: 'vgr' },
  { n: 'Vlaamse Gebarentaal', i: 'vgt' },
  { n: 'Virgin Islands Creole English', i: 'vic' },
  { n: 'Vidunda', i: 'vid' },
  { n: 'Vietnamese', i: 'vie' },
  { n: 'Vili', i: 'vif' },
  { n: 'Viemo', i: 'vig' },
  { n: 'Vilela', i: 'vil' },
  { n: 'Vinza', i: 'vin' },
  { n: 'Vishavan', i: 'vis' },
  { n: 'Viti', i: 'vit' },
  { n: 'Iduna', i: 'viv' },
  { n: 'Ija-Zuba', i: 'vki' },
  { n: 'Kujarge', i: 'vkj' },
  { n: 'Kaur', i: 'vkk' },
  { n: 'Kulisusu', i: 'vkl' },
  { n: 'Kodeoha', i: 'vko' },
  { n: 'Korlai Creole Portuguese', i: 'vkp' },
  { n: 'Tenggarong Kutai Malay', i: 'vkt' },
  { n: 'Kurrama', i: 'vku' },
  { n: 'Valpei', i: 'vlp' },
  { n: 'Vlaams', i: 'vls' },
  { n: 'Martuyhunira', i: 'vma' },
  { n: 'Juxtlahuaca Mixtec', i: 'vmc' },
  { n: 'Mudu Koraga', i: 'vmd' },
  { n: 'East Masela', i: 'vme' },
  { n: 'Mainfränkisch', i: 'vmf' },
  { n: 'Lungalunga', i: 'vmg' },
  { n: 'Maraghei', i: 'vmh' },
  { n: 'Ixtayutla Mixtec', i: 'vmj' },
  { n: 'Makhuwa-Shirima', i: 'vmk' },
  { n: 'Mitlatongo Mixtec', i: 'vmm' },
  { n: 'Soyaltepec Mazatec', i: 'vmp' },
  { n: 'Soyaltepec Mixtec', i: 'vmq' },
  { n: 'Marenje', i: 'vmr' },
  { n: 'Makhuwa', i: 'vmw' },
  { n: 'Tamazola Mixtec', i: 'vmx' },
  { n: 'Ayautla Mazatec', i: 'vmy' },
  { n: 'Mazatlán Mazatec', i: 'vmz' },
  { n: 'Vano', i: 'vnk' },
  { n: 'Vinmavis', i: 'vnm' },
  { n: 'Vunapu', i: 'vnp' },
  { n: 'Voro', i: 'vor' },
  { n: 'Votic', i: 'vot' },
  { n: "Vera'a", i: 'vra' },
  { n: 'Võro', i: 'vro' },
  { n: 'Varisi', i: 'vrs' },
  { n: 'Burmbar', i: 'vrt' },
  { n: 'Moldova Sign Language', i: 'vsi' },
  { n: 'Venezuelan Sign Language', i: 'vsl' },
  { n: 'Valencian Sign Language', i: 'vsv' },
  { n: 'Vitou', i: 'vto' },
  { n: 'Vumbu', i: 'vum' },
  { n: 'Vunjo', i: 'vun' },
  { n: 'Vute', i: 'vut' },
  { n: 'Awa (China)', i: 'vwa' },
  { n: 'Walla Walla', i: 'waa' },
  { n: 'Wab', i: 'wab' },
  { n: 'Wandamen', i: 'wad' },
  { n: 'Walser', i: 'wae' },
  { n: "Wa'ema", i: 'wag' },
  { n: 'Watubela', i: 'wah' },
  { n: 'Wares', i: 'wai' },
  { n: 'Waffa', i: 'waj' },
  { n: 'Wolaytta', i: 'wal' },
  { n: 'Wan', i: 'wan' },
  { n: 'Wapishana', i: 'wap' },
  { n: 'Wagiman', i: 'waq' },
  { n: 'Waray (Philippines)', i: 'war' },
  { n: 'Washo', i: 'was' },
  { n: 'Kaninuwa', i: 'wat' },
  { n: 'Waurá', i: 'wau' },
  { n: 'Waka', i: 'wav' },
  { n: 'Waiwai', i: 'waw' },
  { n: 'Watam', i: 'wax' },
  { n: 'Wayana', i: 'way' },
  { n: 'Wampur', i: 'waz' },
  { n: 'Warao', i: 'wba' },
  { n: 'Wabo', i: 'wbb' },
  { n: 'Waritai', i: 'wbe' },
  { n: 'Wara', i: 'wbf' },
  { n: 'Wanda', i: 'wbh' },
  { n: 'Vwanji', i: 'wbi' },
  { n: 'Alagwa', i: 'wbj' },
  { n: 'Waigali', i: 'wbk' },
  { n: 'Wakhi', i: 'wbl' },
  { n: 'Wa', i: 'wbm' },
  { n: 'Warlpiri', i: 'wbp' },
  { n: 'Waddar', i: 'wbq' },
  { n: 'Wagdi', i: 'wbr' },
  { n: 'West Bengal Sign Language', i: 'wbs' },
  { n: 'Warnman', i: 'wbt' },
  { n: 'Wajarri', i: 'wbv' },
  { n: 'Woi', i: 'wbw' },
  { n: 'Yanomámi', i: 'wca' },
  { n: 'Waci Gbe', i: 'wci' },
  { n: 'Wandji', i: 'wdd' },
  { n: 'Wadaginam', i: 'wdg' },
  { n: 'Wadjiginy', i: 'wdj' },
  { n: 'Wè Western', i: 'wec' },
  { n: 'Wedau', i: 'wed' },
  { n: 'Wergaia', i: 'weg' },
  { n: 'Weh', i: 'weh' },
  { n: 'Kiunum', i: 'wei' },
  { n: 'Weme Gbe', i: 'wem' },
  { n: 'Wemale', i: 'weo' },
  { n: 'Westphalien', i: 'wep' },
  { n: 'Weri', i: 'wer' },
  { n: 'Cameroon Pidgin', i: 'wes' },
  { n: 'Perai', i: 'wet' },
  { n: 'Rawngtu Chin', i: 'weu' },
  { n: 'Wejewa', i: 'wew' },
  { n: 'Yafi', i: 'wfg' },
  { n: 'Wagawaga', i: 'wgb' },
  { n: 'Wahgi', i: 'wgi' },
  { n: 'Waigeo', i: 'wgo' },
  { n: 'Warrgamay', i: 'wgy' },
  { n: 'Sou Upaa', i: 'wha' },
  { n: 'North Wahgi', i: 'whg' },
  { n: 'Wahau Kenyah', i: 'whk' },
  { n: 'Wahau Kayan', i: 'whu' },
  { n: 'Southern Toussian', i: 'wib' },
  { n: 'Wik Ngathan', i: 'wig' },
  { n: "Wik-Me'anha", i: 'wih' },
  { n: 'Minidien', i: 'wii' },
  { n: 'Wik-Iiyanh', i: 'wij' },
  { n: 'Wikalkan', i: 'wik' },
  { n: 'Wik-Mungkan', i: 'wim' },
  { n: 'Ho-Chunk', i: 'win' },
  { n: 'Wiru', i: 'wiu' },
  { n: 'Vitu', i: 'wiv' },
  { n: 'Waja', i: 'wja' },
  { n: 'Warji', i: 'wji' },
  { n: 'Kumbaran', i: 'wkb' },
  { n: 'Wakde', i: 'wkd' },
  { n: 'Kalanadi', i: 'wkl' },
  { n: 'Keerray-Woorroong', i: 'wkr' },
  { n: 'Kunduvadi', i: 'wku' },
  { n: 'Walio', i: 'wla' },
  { n: 'Mwali Comorian', i: 'wlc' },
  { n: 'Wolane', i: 'wle' },
  { n: 'Kunbarlang', i: 'wlg' },
  { n: 'Welaun', i: 'wlh' },
  { n: 'Waioli', i: 'wli' },
  { n: 'Wali (Sudan)', i: 'wll' },
  { n: 'Walloon', i: 'wln' },
  { n: 'Wolio', i: 'wlo' },
  { n: 'Wailapa', i: 'wlr' },
  { n: 'Wallisian', i: 'wls' },
  { n: 'Wichí Lhamtés Vejoz', i: 'wlv' },
  { n: 'Walak', i: 'wlw' },
  { n: 'Wali (Ghana)', i: 'wlx' },
  { n: 'Wambaya', i: 'wmb' },
  { n: 'Wamas', i: 'wmc' },
  { n: 'Mamaindé', i: 'wmd' },
  { n: 'Wambule', i: 'wme' },
  { n: "Waima'a", i: 'wmh' },
  { n: 'Maiwa (Indonesia)', i: 'wmm' },
  { n: 'Wom (Papua New Guinea)', i: 'wmo' },
  { n: 'Wambon', i: 'wms' },
  { n: 'Walmajarri', i: 'wmt' },
  { n: 'Mwani', i: 'wmw' },
  { n: 'Womo', i: 'wmx' },
  { n: 'Wanambre', i: 'wnb' },
  { n: 'Wantoat', i: 'wnc' },
  { n: 'Waneci', i: 'wne' },
  { n: 'Wanggom', i: 'wng' },
  { n: 'Ndzwani Comorian', i: 'wni' },
  { n: 'Wanukaka', i: 'wnk' },
  { n: 'Wano', i: 'wno' },
  { n: 'Wanap', i: 'wnp' },
  { n: 'Usan', i: 'wnu' },
  { n: 'Wintu', i: 'wnw' },
  { n: 'Wanyi', i: 'wny' },
  { n: 'Kuwema', i: 'woa' },
  { n: 'Wè Northern', i: 'wob' },
  { n: 'Wogeo', i: 'woc' },
  { n: 'Wolani', i: 'wod' },
  { n: 'Woleaian', i: 'woe' },
  { n: 'Gambian Wolof', i: 'wof' },
  { n: 'Wogamusin', i: 'wog' },
  { n: 'Kamang', i: 'woi' },
  { n: 'Longto', i: 'wok' },
  { n: 'Wolof', i: 'wol' },
  { n: 'Wom (Nigeria)', i: 'wom' },
  { n: 'Wongo', i: 'won' },
  { n: 'Manombai', i: 'woo' },
  { n: 'Woria', i: 'wor' },
  { n: 'Hanga Hundi', i: 'wos' },
  { n: 'Wawonii', i: 'wow' },
  { n: 'Maco', i: 'wpc' },
  { n: 'Warapu', i: 'wra' },
  { n: 'Warduji', i: 'wrd' },
  { n: 'Garrwa', i: 'wrk' },
  { n: 'Warlmanpa', i: 'wrl' },
  { n: 'Warumungu', i: 'wrm' },
  { n: 'Warnang', i: 'wrn' },
  { n: 'Waropen', i: 'wrp' },
  { n: 'Wardaman', i: 'wrr' },
  { n: 'Waris', i: 'wrs' },
  { n: 'Waru', i: 'wru' },
  { n: 'Waruna', i: 'wrv' },
  { n: 'Wae Rana', i: 'wrx' },
  { n: 'Merwari', i: 'wry' },
  { n: 'Warembori', i: 'wsa' },
  { n: 'Adilabad Gondi', i: 'wsg' },
  { n: 'Wusi', i: 'wsi' },
  { n: 'Waskia', i: 'wsk' },
  { n: 'Owenia', i: 'wsr' },
  { n: 'Wasa', i: 'wss' },
  { n: 'Watiwa', i: 'wtf' },
  { n: 'Berta', i: 'wti' },
  { n: 'Watakataui', i: 'wtk' },
  { n: 'Mewati', i: 'wtm' },
  { n: 'Wotu', i: 'wtw' },
  { n: 'Wikngenchera', i: 'wua' },
  { n: 'Wunambal', i: 'wub' },
  { n: 'Wudu', i: 'wud' },
  { n: 'Wutunhua', i: 'wuh' },
  { n: 'Silimo', i: 'wul' },
  { n: 'Wumbvu', i: 'wum' },
  { n: 'Bungu', i: 'wun' },
  { n: 'Wutung', i: 'wut' },
  { n: 'Wu Chinese', i: 'wuu' },
  { n: 'Wuvulu-Aua', i: 'wuv' },
  { n: 'Wulna', i: 'wux' },
  { n: 'Wauyai', i: 'wuy' },
  { n: 'Waama', i: 'wwa' },
  { n: 'Wetamut', i: 'wwo' },
  { n: 'Wawa', i: 'www' },
  { n: 'Waxianghua', i: 'wxa' },
  { n: 'Wyandot', i: 'wya' },
  { n: 'Wangaaybuwan-Ngiyambaa', i: 'wyb' },
  { n: 'Wymysorys', i: 'wym' },
  { n: 'Wayoró', i: 'wyr' },
  { n: 'Western Fijian', i: 'wyy' },
  { n: 'Sambe', i: 'xab' },
  { n: 'Kachari', i: 'xac' },
  { n: 'Kalmyk', i: 'xal' },
  { n: 'Xamtanga', i: 'xan' },
  { n: 'Khao', i: 'xao' },
  { n: 'Katawixi', i: 'xat' },
  { n: 'Kauwera', i: 'xau' },
  { n: 'Xavánte', i: 'xav' },
  { n: 'Kawaiisu', i: 'xaw' },
  { n: 'Kayan Mahakam', i: 'xay' },
  { n: 'Kombio', i: 'xbi' },
  { n: 'Kambera', i: 'xbr' },
  { n: 'Batjala', i: 'xby' },
  { n: 'Darkinyung', i: 'xda' },
  { n: 'Kwandu', i: 'xdo' },
  { n: 'Malayic Dayak', i: 'xdy' },
  { n: 'Hdi', i: 'xed' },
  { n: 'Kelo', i: 'xel' },
  { n: 'Kembayan', i: 'xem' },
  { n: 'Xerénte', i: 'xer' },
  { n: 'Kesawai', i: 'xes' },
  { n: 'Xetá', i: 'xet' },
  { n: 'Keoru-Ahia', i: 'xeu' },
  { n: 'Unggumi', i: 'xgu' },
  { n: 'Khetrani', i: 'xhe' },
  { n: 'Xhosa', i: 'xho' },
  { n: 'Khua', i: 'xhv' },
  { n: 'Xiri', i: 'xii' },
  { n: 'Kisan', i: 'xis' },
  { n: 'Xipaya', i: 'xiy' },
  { n: 'Kalkoti', i: 'xka' },
  { n: 'Northern Nago', i: 'xkb' },
  { n: "Kho'ini", i: 'xkc' },
  { n: 'Mendalam Kayan', i: 'xkd' },
  { n: 'Kereho', i: 'xke' },
  { n: 'Khengkha', i: 'xkf' },
  { n: 'Kagoro', i: 'xkg' },
  { n: 'Kenyan Sign Language', i: 'xki' },
  { n: 'Kajali', i: 'xkj' },
  { n: "Kaco'", i: 'xkk' },
  { n: 'Mainstream Kenyah', i: 'xkl' },
  { n: 'Kayan River Kayan', i: 'xkn' },
  { n: 'Kiorr', i: 'xko' },
  { n: 'Kabatei', i: 'xkp' },
  { n: 'Koroni', i: 'xkq' },
  { n: 'Kumbewaha', i: 'xks' },
  { n: 'Kantosi', i: 'xkt' },
  { n: 'Kaamba', i: 'xku' },
  { n: 'Kgalagadi', i: 'xkv' },
  { n: 'Kembra', i: 'xkw' },
  { n: 'Karore', i: 'xkx' },
  { n: "Uma' Lasan", i: 'xky' },
  { n: 'Kurtokha', i: 'xkz' },
  { n: 'Kamula', i: 'xla' },
  { n: 'Mushungulu', i: 'xma' },
  { n: 'Mbonga', i: 'xmb' },
  { n: 'Makhuwa-Marrevone', i: 'xmc' },
  { n: 'Mbudum', i: 'xmd' },
  { n: 'Mingrelian', i: 'xmf' },
  { n: 'Mengaka', i: 'xmg' },
  { n: 'Kugu-Muminh', i: 'xmh' },
  { n: 'Majera', i: 'xmj' },
  { n: 'Malaysian Sign Language', i: 'xml' },
  { n: 'Manado Malay', i: 'xmm' },
  { n: 'Morerebi', i: 'xmo' },
  { n: 'Moroccan Sign Language', i: 'xms' },
  { n: 'Matbat', i: 'xmt' },
  { n: 'Antankarana Malagasy', i: 'xmv' },
  { n: 'Tsimihety Malagasy', i: 'xmw' },
  { n: 'Maden', i: 'xmx' },
  { n: 'Mayaguduna', i: 'xmy' },
  { n: 'Mori Bawah', i: 'xmz' },
  { n: 'Kanakanabu', i: 'xnb' },
  { n: 'Kuanhua', i: 'xnh' },
  { n: 'Northern Kankanay', i: 'xnn' },
  { n: 'Kangri', i: 'xnr' },
  { n: 'Kanashi', i: 'xns' },
  { n: 'Nyiyaparli', i: 'xny' },
  { n: 'Kenzi', i: 'xnz' },
  { n: 'Kokoda', i: 'xod' },
  { n: 'Soga', i: 'xog' },
  { n: 'Kominimung', i: 'xoi' },
  { n: 'Xokleng', i: 'xok' },
  { n: 'Komo (Sudan)', i: 'xom' },
  { n: 'Konkomba', i: 'xon' },
  { n: 'Kopar', i: 'xop' },
  { n: 'Korubo', i: 'xor' },
  { n: 'Kowaki', i: 'xow' },
  { n: 'Liberia Kpelle', i: 'xpe' },
  { n: 'Kulina Pano', i: 'xpk' },
  { n: 'Krahô', i: 'xra' },
  { n: 'Eastern Karaboro', i: 'xrb' },
  { n: 'Kreye', i: 'xre' },
  { n: 'Krikati-Timbira', i: 'xri' },
  { n: 'Marriammu', i: 'xru' },
  { n: 'Karawa', i: 'xrw' },
  { n: 'Sambal', i: 'xsb' },
  { n: 'Sempan', i: 'xse' },
  { n: 'Shamang', i: 'xsh' },
  { n: 'Sio', i: 'xsi' },
  { n: 'Subi', i: 'xsj' },
  { n: 'South Slavey', i: 'xsl' },
  { n: 'Kasem', i: 'xsm' },
  { n: 'Sanga (Nigeria)', i: 'xsn' },
  { n: 'Silopi', i: 'xsp' },
  { n: 'Makhuwa-Saka', i: 'xsq' },
  { n: 'Sherpa', i: 'xsr' },
  { n: 'Sanumá', i: 'xsu' },
  { n: 'Saisiyat', i: 'xsy' },
  { n: 'Alcozauca Mixtec', i: 'xta' },
  { n: 'Chazumba Mixtec', i: 'xtb' },
  { n: 'Katcha-Kadugli-Miri', i: 'xtc' },
  { n: 'Diuxi-Tilantongo Mixtec', i: 'xtd' },
  { n: 'Ketengban', i: 'xte' },
  { n: 'Sinicahua Mixtec', i: 'xti' },
  { n: 'San Juan Teita Mixtec', i: 'xtj' },
  { n: 'Tijaltepec Mixtec', i: 'xtl' },
  { n: 'Magdalena Peñasco Mixtec', i: 'xtm' },
  { n: 'Northern Tlaxiaco Mixtec', i: 'xtn' },
  { n: 'San Miguel Piedras Mixtec', i: 'xtp' },
  { n: 'Sindihui Mixtec', i: 'xts' },
  { n: 'Tacahua Mixtec', i: 'xtt' },
  { n: 'Cuyamecalco Mixtec', i: 'xtu' },
  { n: 'Tawandê', i: 'xtw' },
  { n: 'Yoloxochitl Mixtec', i: 'xty' },
  { n: 'Alu Kurumba', i: 'xua' },
  { n: 'Betta Kurumba', i: 'xub' },
  { n: 'Kunigami', i: 'xug' },
  { n: 'Jennu Kurumba', i: 'xuj' },
  { n: 'Kuo', i: 'xuo' },
  { n: 'Kxoe', i: 'xuu' },
  { n: 'Kamviri', i: 'xvi' },
  { n: 'Kwaza', i: 'xwa' },
  { n: 'Xwela Gbe', i: 'xwe' },
  { n: 'Kwegu', i: 'xwg' },
  { n: 'Western Xwla Gbe', i: 'xwl' },
  { n: 'Kwerba Mamberamo', i: 'xwr' },
  { n: "Ke'o", i: 'xxk' },
  { n: 'Yorta Yorta', i: 'xyy' },
  { n: 'Yaminahua', i: 'yaa' },
  { n: 'Yuhup', i: 'yab' },
  { n: 'Pass Valley Yali', i: 'yac' },
  { n: 'Yagua', i: 'yad' },
  { n: 'Pumé', i: 'yae' },
  { n: 'Yaka (Democratic Republic of Congo)', i: 'yaf' },
  { n: 'Yámana', i: 'yag' },
  { n: 'Yazgulyam', i: 'yah' },
  { n: 'Yagnobi', i: 'yai' },
  { n: 'Banda-Yangere', i: 'yaj' },
  { n: 'Yakama', i: 'yak' },
  { n: 'Yalunka', i: 'yal' },
  { n: 'Yamba', i: 'yam' },
  { n: 'Mayangna', i: 'yan' },
  { n: 'Yao', i: 'yao' },
  { n: 'Yapese', i: 'yap' },
  { n: 'Yaqui', i: 'yaq' },
  { n: 'Yabarana', i: 'yar' },
  { n: 'Nugunu (Cameroon)', i: 'yas' },
  { n: 'Yambeta', i: 'yat' },
  { n: 'Yuwana', i: 'yau' },
  { n: 'Yangben', i: 'yav' },
  { n: 'Yawalapití', i: 'yaw' },
  { n: 'Yauma', i: 'yax' },
  { n: 'Agwagwune', i: 'yay' },
  { n: 'Lokaa', i: 'yaz' },
  { n: 'Yala', i: 'yba' },
  { n: 'Yemba', i: 'ybb' },
  { n: 'West Yugur', i: 'ybe' },
  { n: 'Yakha', i: 'ybh' },
  { n: 'Yamphu', i: 'ybi' },
  { n: 'Hasha', i: 'ybj' },
  { n: 'Bokha', i: 'ybk' },
  { n: 'Yukuben', i: 'ybl' },
  { n: 'Yaben', i: 'ybm' },
  { n: 'Yabong', i: 'ybo' },
  { n: 'Yawiyo', i: 'ybx' },
  { n: 'Yaweyuha', i: 'yby' },
  { n: 'Chesu', i: 'ych' },
  { n: 'Lolopo', i: 'ycl' },
  { n: 'Yucuna', i: 'ycn' },
  { n: 'Chepya', i: 'ycp' },
  { n: 'Eastern Yiddish', i: 'ydd' },
  { n: 'Yangum Dey', i: 'yde' },
  { n: 'Yidgha', i: 'ydg' },
  { n: 'Yoidik', i: 'ydk' },
  { n: 'Ravula', i: 'yea' },
  { n: 'Yeniche', i: 'yec' },
  { n: 'Yimas', i: 'yee' },
  { n: 'Yevanic', i: 'yej' },
  { n: 'Yela', i: 'yel' },
  { n: 'Tarok', i: 'yer' },
  { n: 'Nyankpa', i: 'yes' },
  { n: 'Yetfa', i: 'yet' },
  { n: 'Yerukula', i: 'yeu' },
  { n: 'Yapunda', i: 'yev' },
  { n: 'Yeyi', i: 'yey' },
  { n: 'Yangum Gel', i: 'ygl' },
  { n: 'Yagomi', i: 'ygm' },
  { n: 'Gepo', i: 'ygp' },
  { n: 'Yagaria', i: 'ygr' },
  { n: 'Yolŋu Sign Language', i: 'ygs' },
  { n: 'Yugul', i: 'ygu' },
  { n: 'Yagwoia', i: 'ygw' },
  { n: 'Baha Buyang', i: 'yha' },
  { n: 'Judeo-Iraqi Arabic', i: 'yhd' },
  { n: 'Hlepho Phowa', i: 'yhl' },
  { n: 'Yan-nhaŋu Sign Language', i: 'yhs' },
  { n: 'Yinggarda', i: 'yia' },
  { n: 'Ache', i: 'yif' },
  { n: 'Wusa Nasu', i: 'yig' },
  { n: 'Western Yiddish', i: 'yih' },
  { n: 'Yidiny', i: 'yii' },
  { n: 'Yindjibarndi', i: 'yij' },
  { n: 'Dongshanba Lalo', i: 'yik' },
  { n: 'Yimchungru Naga', i: 'yim' },
  { n: 'Riang Lai', i: 'yin' },
  { n: 'Pholo', i: 'yip' },
  { n: 'Miqie', i: 'yiq' },
  { n: 'North Awyu', i: 'yir' },
  { n: 'Yis', i: 'yis' },
  { n: 'Eastern Lalu', i: 'yit' },
  { n: 'Awu', i: 'yiu' },
  { n: 'Northern Nisu', i: 'yiv' },
  { n: 'Axi Yi', i: 'yix' },
  { n: 'Azhe', i: 'yiz' },
  { n: 'Yakan', i: 'yka' },
  { n: 'Northern Yukaghir', i: 'ykg' },
  { n: 'Yoke', i: 'yki' },
  { n: 'Yakaikeke', i: 'ykk' },
  { n: 'Khlula', i: 'ykl' },
  { n: 'Kap', i: 'ykm' },
  { n: 'Kua-nsi', i: 'ykn' },
  { n: 'Yasa', i: 'yko' },
  { n: 'Yekora', i: 'ykr' },
  { n: 'Kathu', i: 'ykt' },
  { n: 'Kuamasi', i: 'yku' },
  { n: 'Yakoma', i: 'yky' },
  { n: 'Yaul', i: 'yla' },
  { n: 'Yaleba', i: 'ylb' },
  { n: 'Yele', i: 'yle' },
  { n: 'Yelogu', i: 'ylg' },
  { n: 'Angguruk Yali', i: 'yli' },
  { n: 'Yil', i: 'yll' },
  { n: 'Limi', i: 'ylm' },
  { n: 'Langnian Buyang', i: 'yln' },
  { n: 'Naluo Yi', i: 'ylo' },
  { n: 'Aribwaung', i: 'ylu' },
  { n: 'Nyâlayu', i: 'yly' },
  { n: 'Yambes', i: 'ymb' },
  { n: 'Southern Muji', i: 'ymc' },
  { n: 'Muda', i: 'ymd' },
  { n: 'Yamongeri', i: 'ymg' },
  { n: 'Mili', i: 'ymh' },
  { n: 'Moji', i: 'ymi' },
  { n: 'Makwe', i: 'ymk' },
  { n: 'Iamalele', i: 'yml' },
  { n: 'Maay', i: 'ymm' },
  { n: 'Yamna', i: 'ymn' },
  { n: 'Yangum Mon', i: 'ymo' },
  { n: 'Yamap', i: 'ymp' },
  { n: 'Qila Muji', i: 'ymq' },
  { n: 'Malasar', i: 'ymr' },
  { n: 'Northern Muji', i: 'ymx' },
  { n: 'Muzi', i: 'ymz' },
  { n: 'Aluo', i: 'yna' },
  { n: "Lang'e", i: 'yne' },
  { n: 'Yango', i: 'yng' },
  { n: 'Naukan Yupik', i: 'ynk' },
  { n: 'Yangulam', i: 'ynl' },
  { n: 'Yong', i: 'yno' },
  { n: 'Yendang', i: 'ynq' },
  { n: 'Yansi', i: 'yns' },
  { n: 'Yogad', i: 'yog' },
  { n: 'Yonaguni', i: 'yoi' },
  { n: 'Yokuts', i: 'yok' },
  { n: 'Yombe', i: 'yom' },
  { n: 'Yongkom', i: 'yon' },
  { n: 'Yoruba', i: 'yor' },
  { n: 'Yotti', i: 'yot' },
  { n: 'Yoron', i: 'yox' },
  { n: 'Yoy', i: 'yoy' },
  { n: 'Phala', i: 'ypa' },
  { n: 'Labo Phowa', i: 'ypb' },
  { n: 'Phola', i: 'ypg' },
  { n: 'Phupha', i: 'yph' },
  { n: 'Phuma', i: 'ypm' },
  { n: 'Ani Phowa', i: 'ypn' },
  { n: 'Alo Phola', i: 'ypo' },
  { n: 'Phupa', i: 'ypp' },
  { n: 'Phuza', i: 'ypz' },
  { n: 'Yerakai', i: 'yra' },
  { n: 'Yareba', i: 'yrb' },
  { n: 'Yaouré', i: 'yre' },
  { n: 'Nenets', i: 'yrk' },
  { n: 'Nhengatu', i: 'yrl' },
  { n: 'Yirrk-Mel', i: 'yrm' },
  { n: 'Yerong', i: 'yrn' },
  { n: 'Yaroamë', i: 'yro' },
  { n: 'Yarsun', i: 'yrs' },
  { n: 'Yarawata', i: 'yrw' },
  { n: 'Yarluyandi', i: 'yry' },
  { n: 'Samatao', i: 'ysd' },
  { n: 'Sonaga', i: 'ysg' },
  { n: 'Yugoslavian Sign Language', i: 'ysl' },
  { n: 'Sani', i: 'ysn' },
  { n: 'Nisi (China)', i: 'yso' },
  { n: 'Southern Lolopo', i: 'ysp' },
  { n: 'Yessan-Mayo', i: 'yss' },
  { n: 'Sanie', i: 'ysy' },
  { n: 'Talu', i: 'yta' },
  { n: 'Tanglang', i: 'ytl' },
  { n: 'Thopho', i: 'ytp' },
  { n: 'Yout Wam', i: 'ytw' },
  { n: 'Yucateco', i: 'yua' },
  { n: 'Yuchi', i: 'yuc' },
  { n: 'Judeo-Tripolitanian Arabic', i: 'yud' },
  { n: 'Yue Chinese', i: 'yue' },
  { n: 'Havasupai-Walapai-Yavapai', i: 'yuf' },
  { n: 'Yurutí', i: 'yui' },
  { n: 'Karkar-Yuri', i: 'yuj' },
  { n: 'Yulu', i: 'yul' },
  { n: 'Quechan', i: 'yum' },
  { n: 'Bena (Nigeria)', i: 'yun' },
  { n: 'Yukpa', i: 'yup' },
  { n: 'Yuqui', i: 'yuq' },
  { n: 'Yopno', i: 'yut' },
  { n: 'Yau (Morobe Province)', i: 'yuw' },
  { n: 'Southern Yukaghir', i: 'yux' },
  { n: 'East Yugur', i: 'yuy' },
  { n: 'Yuracare', i: 'yuz' },
  { n: 'Yawa', i: 'yva' },
  { n: 'Kalou', i: 'ywa' },
  { n: 'Yinhawangka', i: 'ywg' },
  { n: 'Western Lalu', i: 'ywl' },
  { n: 'Yawanawa', i: 'ywn' },
  { n: 'Wuding-Luquan Yi', i: 'ywq' },
  { n: 'Yawuru', i: 'ywr' },
  { n: 'Xishanba Lalo', i: 'ywt' },
  { n: 'Wumeng Nasu', i: 'ywu' },
  { n: 'Yau (Sandaun Province)', i: 'yyu' },
  { n: 'Ayizi', i: 'yyz' },
  { n: "E'ma Buyang", i: 'yzg' },
  { n: 'Zokhuo', i: 'yzk' },
  { n: 'Sierra de Juárez Zapotec', i: 'zaa' },
  { n: 'Western Tlacolula Valley Zapotec', i: 'zab' },
  { n: 'Ocotlán Zapotec', i: 'zac' },
  { n: 'Cajonos Zapotec', i: 'zad' },
  { n: 'Yareni Zapotec', i: 'zae' },
  { n: 'Ayoquesco Zapotec', i: 'zaf' },
  { n: 'Zaghawa', i: 'zag' },
  { n: 'Zangwal', i: 'zah' },
  { n: 'Isthmus Zapotec', i: 'zai' },
  { n: 'Zaramo', i: 'zaj' },
  { n: 'Zanaki', i: 'zak' },
  { n: 'Zauzou', i: 'zal' },
  { n: 'Miahuatlán Zapotec', i: 'zam' },
  { n: 'Ozolotepec Zapotec', i: 'zao' },
  { n: 'Aloápam Zapotec', i: 'zaq' },
  { n: 'Rincón Zapotec', i: 'zar' },
  { n: 'Santo Domingo Albarradas Zapotec', i: 'zas' },
  { n: 'Tabaa Zapotec', i: 'zat' },
  { n: 'Zangskari', i: 'zau' },
  { n: 'Yatzachi Zapotec', i: 'zav' },
  { n: 'Mitla Zapotec', i: 'zaw' },
  { n: 'Xadani Zapotec', i: 'zax' },
  { n: 'Zayse-Zergulla', i: 'zay' },
  { n: 'Zari', i: 'zaz' },
  { n: 'Central Berawan', i: 'zbc' },
  { n: 'East Berawan', i: 'zbe' },
  { n: 'Batui', i: 'zbt' },
  { n: 'West Berawan', i: 'zbw' },
  { n: 'Coatecas Altas Zapotec', i: 'zca' },
  { n: 'Central Hongshuihe Zhuang', i: 'zch' },
  { n: 'Ngazidja Comorian', i: 'zdj' },
  { n: 'Zeeuws', i: 'zea' },
  { n: 'Zenag', i: 'zeg' },
  { n: 'Eastern Hongshuihe Zhuang', i: 'zeh' },
  { n: 'Zenaga', i: 'zen' },
  { n: 'Kinga', i: 'zga' },
  { n: 'Guibei Zhuang', i: 'zgb' },
  { n: 'Standard Moroccan Tamazight', i: 'zgh' },
  { n: 'Minz Zhuang', i: 'zgm' },
  { n: 'Guibian Zhuang', i: 'zgn' },
  { n: 'Magori', i: 'zgr' },
  { n: 'Zhaba', i: 'zhb' },
  { n: 'Dai Zhuang', i: 'zhd' },
  { n: 'Zhire', i: 'zhi' },
  { n: 'Nong Zhuang', i: 'zhn' },
  { n: 'Zhoa', i: 'zhw' },
  { n: 'Zia', i: 'zia' },
  { n: 'Zimbabwe Sign Language', i: 'zib' },
  { n: 'Zimakani', i: 'zik' },
  { n: 'Zialo', i: 'zil' },
  { n: 'Mesme', i: 'zim' },
  { n: 'Zinza', i: 'zin' },
  { n: 'Zigula', i: 'ziw' },
  { n: 'Zizilivakan', i: 'ziz' },
  { n: 'Kaimbulawa', i: 'zka' },
  { n: 'Kadu', i: 'zkd' },
  { n: 'Kanan', i: 'zkn' },
  { n: 'Zakhring', i: 'zkr' },
  { n: 'Kaurna', i: 'zku' },
  { n: 'Liujiang Zhuang', i: 'zlj' },
  { n: 'Malay (individual language)', i: 'zlm' },
  { n: 'Lianshan Zhuang', i: 'zln' },
  { n: 'Liuqian Zhuang', i: 'zlq' },
  { n: 'Manda (Australia)', i: 'zma' },
  { n: 'Zimba', i: 'zmb' },
  { n: 'Maridan', i: 'zmd' },
  { n: 'Mfinu', i: 'zmf' },
  { n: 'Marti Ke', i: 'zmg' },
  { n: 'Negeri Sembilan Malay', i: 'zmi' },
  { n: 'Maridjabin', i: 'zmj' },
  { n: 'Marimanindji', i: 'zmm' },
  { n: 'Mbangwe', i: 'zmn' },
  { n: 'Molo', i: 'zmo' },
  { n: 'Mpuono', i: 'zmp' },
  { n: 'Mituku', i: 'zmq' },
  { n: 'Maranunggu', i: 'zmr' },
  { n: 'Mbesa', i: 'zms' },
  { n: 'Maringarr', i: 'zmt' },
  { n: 'Mbo (Democratic Republic of Congo)', i: 'zmw' },
  { n: 'Bomitaba', i: 'zmx' },
  { n: 'Mariyedi', i: 'zmy' },
  { n: 'Mbandja', i: 'zmz' },
  { n: 'Zan Gula', i: 'zna' },
  { n: 'Zande (individual language)', i: 'zne' },
  { n: 'Mang', i: 'zng' },
  { n: 'Mangas', i: 'zns' },
  { n: 'Copainalá Zoque', i: 'zoc' },
  { n: 'Chimalapa Zoque', i: 'zoh' },
  { n: 'Zou', i: 'zom' },
  { n: 'Asunción Mixtepec Zapotec', i: 'zoo' },
  { n: 'Tabasco Zoque', i: 'zoq' },
  { n: 'Rayón Zoque', i: 'zor' },
  { n: 'Francisco León Zoque', i: 'zos' },
  { n: 'Lachiguiri Zapotec', i: 'zpa' },
  { n: 'Yautepec Zapotec', i: 'zpb' },
  { n: 'Choapan Zapotec', i: 'zpc' },
  { n: 'Southeastern Ixtlán Zapotec', i: 'zpd' },
  { n: 'Petapa Zapotec', i: 'zpe' },
  { n: 'San Pedro Quiatoni Zapotec', i: 'zpf' },
  { n: 'Guevea De Humboldt Zapotec', i: 'zpg' },
  { n: 'Totomachapan Zapotec', i: 'zph' },
  { n: 'Santa María Quiegolani Zapotec', i: 'zpi' },
  { n: 'Quiavicuzas Zapotec', i: 'zpj' },
  { n: 'Tlacolulita Zapotec', i: 'zpk' },
  { n: 'Lachixío Zapotec', i: 'zpl' },
  { n: 'Mixtepec Zapotec', i: 'zpm' },
  { n: 'Santa Inés Yatzechi Zapotec', i: 'zpn' },
  { n: 'Amatlán Zapotec', i: 'zpo' },
  { n: 'El Alto Zapotec', i: 'zpp' },
  { n: 'Zoogocho Zapotec', i: 'zpq' },
  { n: 'Santiago Xanica Zapotec', i: 'zpr' },
  { n: 'Coatlán Zapotec', i: 'zps' },
  { n: 'San Vicente Coatlán Zapotec', i: 'zpt' },
  { n: 'Yalálag Zapotec', i: 'zpu' },
  { n: 'Chichicapan Zapotec', i: 'zpv' },
  { n: 'Zaniza Zapotec', i: 'zpw' },
  { n: 'San Baltazar Loxicha Zapotec', i: 'zpx' },
  { n: 'Mazaltepec Zapotec', i: 'zpy' },
  { n: 'Texmelucan Zapotec', i: 'zpz' },
  { n: 'Qiubei Zhuang', i: 'zqe' },
  { n: 'Mirgan', i: 'zrg' },
  { n: 'Zerenkel', i: 'zrn' },
  { n: 'Záparo', i: 'zro' },
  { n: 'Mairasi', i: 'zrs' },
  { n: 'Sarasira', i: 'zsa' },
  { n: 'Zambian Sign Language', i: 'zsl' },
  { n: 'Standard Malay', i: 'zsm' },
  { n: 'Southern Rincon Zapotec', i: 'zsr' },
  { n: 'Sukurum', i: 'zsu' },
  { n: 'Elotepec Zapotec', i: 'zte' },
  { n: 'Xanaguía Zapotec', i: 'ztg' },
  { n: 'Lapaguía-Guivini Zapotec', i: 'ztl' },
  { n: 'San Agustín Mixtepec Zapotec', i: 'ztm' },
  { n: 'Santa Catarina Albarradas Zapotec', i: 'ztn' },
  { n: 'Loxicha Zapotec', i: 'ztp' },
  { n: 'Quioquitani-Quierí Zapotec', i: 'ztq' },
  { n: 'Tilquiapan Zapotec', i: 'zts' },
  { n: 'Tejalapan Zapotec', i: 'ztt' },
  { n: 'Güilá Zapotec', i: 'ztu' },
  { n: 'Zaachila Zapotec', i: 'ztx' },
  { n: 'Yatee Zapotec', i: 'zty' },
  { n: 'Zeem', i: 'zua' },
  { n: 'Tokano', i: 'zuh' },
  { n: 'Zulu', i: 'zul' },
  { n: 'Kumzari', i: 'zum' },
  { n: 'Zuni', i: 'zun' },
  { n: 'Zumaya', i: 'zuy' },
  { n: 'Zay', i: 'zwa' },
  { n: 'Yongbei Zhuang', i: 'zyb' },
  { n: 'Yang Zhuang', i: 'zyg' },
  { n: 'Youjiang Zhuang', i: 'zyj' },
  { n: 'Yongnan Zhuang', i: 'zyn' },
  { n: 'Zyphe Chin', i: 'zyp' },
  { n: 'Zuojiang Zhuang', i: 'zzj' },
  { n: 'Akan', i: 'aka' },
  { n: 'Arabic', i: 'ara' },
  { n: 'Aymara', i: 'aym' },
  { n: 'Azerbaijani', i: 'aze' },
  { n: 'Baluchi', i: 'bal' },
  { n: 'Bikol', i: 'bik' },
  { n: 'Bontok', i: 'bnc' },
  { n: 'Buriat', i: 'bua' },
  { n: 'Mari (Russia)', i: 'chm' },
  { n: 'Cree', i: 'cre' },
  { n: 'Delaware', i: 'del' },
  { n: 'Slave (Athapascan)', i: 'den' },
  { n: 'Dinka', i: 'din' },
  { n: 'Dogri (macrolanguage)', i: 'doi' },
  { n: 'Estonian', i: 'est' },
  { n: 'Persian', i: 'fas' },
  { n: 'Fulah', i: 'ful' },
  { n: 'Gbaya (Central African Republic)', i: 'gba' },
  { n: 'Gondi', i: 'gon' },
  { n: 'Grebo', i: 'grb' },
  { n: 'Guarani', i: 'grn' },
  { n: 'Haida', i: 'hai' },
  { n: 'Serbo-Croatian', i: 'hbs' },
  { n: 'Hmong', i: 'hmn' },
  { n: 'Inuktitut', i: 'iku' },
  { n: 'Inupiaq', i: 'ipk' },
  { n: 'Judeo-Arabic', i: 'jrb' },
  { n: 'Kanuri', i: 'kau' },
  { n: 'Kalenjin', i: 'kln' },
  { n: 'Konkani (macrolanguage)', i: 'kok' },
  { n: 'Komi', i: 'kom' },
  { n: 'Kongo', i: 'kon' },
  { n: 'Kpelle', i: 'kpe' },
  { n: 'Kurdish', i: 'kur' },
  { n: 'Lahnda', i: 'lah' },
  { n: 'Latvian', i: 'lav' },
  { n: 'Luyia', i: 'luy' },
  { n: 'Mandingo', i: 'man' },
  { n: 'Malagasy', i: 'mlg' },
  { n: 'Mongolian', i: 'mon' },
  { n: 'Malay (macrolanguage)', i: 'msa' },
  { n: 'Marwari', i: 'mwr' },
  { n: 'Nepali (macrolanguage)', i: 'nep' },
  { n: 'Norwegian', i: 'nor' },
  { n: 'Ojibwa', i: 'oji' },
  { n: 'Oriya (macrolanguage)', i: 'ori' },
  { n: 'Oromo', i: 'orm' },
  { n: 'Pushto', i: 'pus' },
  { n: 'Quechua', i: 'que' },
  { n: 'Rajasthani', i: 'raj' },
  { n: 'Romany', i: 'rom' },
  { n: 'Albanian', i: 'sqi' },
  { n: 'Sardinian', i: 'srd' },
  { n: 'Swahili (macrolanguage)', i: 'swa' },
  { n: 'Syriac', i: 'syr' },
  { n: 'Tamashek', i: 'tmh' },
  { n: 'Uzbek', i: 'uzb' },
  { n: 'Yiddish', i: 'yid' },
  { n: 'Zapotec', i: 'zap' },
  { n: 'Zhuang', i: 'zha' },
  { n: 'Chinese', i: 'zho' },
  { n: 'Zaza', i: 'zza' },
];
